// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { useNavigate, useParams } from 'react-router-dom'
import LoginSignUpButton from './loginSignUpButton'
import NextPreviousButton from './NextPreviousButton'
import PriceBreackup from './priceBreackup'
import PriceBreackupEdit from './priceBreackupEdit'
import { getConfigDetails } from '../../services/config'
// import graphImg from './../../../src/assets/img/graph-paper.svg'
import reservationcalendar from './../../../src/assets/img/reservationcalendar.png'
import debounce from 'lodash/debounce'
import {
  EncryptionHandler,
  formatDecimal,
  changeTimeZone,
  isLoggedIn,
  sortPortalPermissionByKey,
  isPermissionExist,
  loggedInUserData,
  restrictInputValues,
  restrictSpecialChar,
  numberMobile,
  getPartnerDetails,
  validExpiryDate,
  getDisclaimerNote,
  // areDatesExactlyGivenMonthsApart,
  trimedSpacePayload,
  // restrictInValidCharPassword
  restrictInValidCharLicense,
  allowalphabetical,
  restrictSpecialCharPromo,
  phoneMasker,
  handleKeyPressRestrictLeadingTrailingSpace,
  trimObjectValues,
  validatePhone,
  showhideWalletButton,
  getDeviceType,
  formatYearMonthExpiry,
  getConfigPermission,
  validateEmail,
  isParksfo,
  getParkSfoDisclaimerNote,
  getParkSfoEstimateDisclaimer,
  // restrictInputValuesVal
} from '../../utils/helper'
import { getCardDataList } from '../../redux/actions/cardDetailsAction'
import { QRCodeSVG } from 'qrcode.react'
import './reservation.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import { Circles } from 'react-loader-spinner'
import { EMPTY_ARRAY, EMPTY_OBJECT, getWalletScriptUrl, validPhone, PAYMENT_GATEWAY, usesHostedCardFields } from '../../constants/globalConstants'
import { completeStripeRequiredAction, getStripeRequiredAction, isStripeGateway, STRIPE_CAPTURE } from '../../components/stripe/stripeClient'
import { stripePaymentFields } from '../../components/stripe/stripePayload'
import { getStripeErrorMessage } from '../../components/stripe/stripeErrors'
import {
  applyPromoCodeReservation,
  saveReservationPayment,
  updateReservationPayment,
  downloadTicket,
  inventoryUpdateReservatino,
} from '../../redux/actions/widgetReservationAction'
import { getVehicleDataList, getVehicleDetailsList, getVehicleModelList } from '../../redux/actions/VehicleListAction'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import Multiselect from 'multiselect-react-dropdown'
import { getPriceDetailsByTime } from '../../redux/actions/widgetReservationAction'
import ModalLogin from '../../components/global/modalLogin'
import ModalTerm from './termCond'
import VehicalModel from './vehicalModel'
import PassWalletButtons from '../../components/global/PassWalletButtons'
import { APICONFIG } from '../../redux/config/apiConfig'
import WalletButtons from '../../components/walletButtons'
import { addScript } from '../../utils/addScript'
import { getParkingTypes } from '../../redux/actions'
import { getValidationCodes } from '../../redux/actions/reservationActions'
import CardConnectTokenizer, { waitForCardTokenizer } from '../../components/walletButtons/CardConnectTokenizer'
import { errorMessage } from '../../constants/errorMessage'
import useRecaptcha from '../../Hooks/useRecaptcha'


import PaymentGatewayCommon from '../paymentForm/PaymentGatewayCommon'
import PaymentMethodModal from '../../components/global/PaymentMethodModal'

const DefaultComponent = () => <></>

// EOS-5093 Amenities
// The reservation rate API returns every amenity configured for the facility as
// a facility-amenity row that wraps the master amenity record, so the label can
// sit at a couple of different depths depending on the payload.
const getAmenityLabel = (amenity = {}) =>
  amenity?.amenity?.name ||
  amenity?.name ||
  amenity?.amenity_name ||
  amenity?.title ||
  amenity?.amenity?.description ||
  ''

// Match on the facility-amenity id when the payload carries one, fall back to
// the label so a selection is not lost when the rate response is refreshed.
const isSameAmenity = (firstAmenity = {}, secondAmenity = {}) =>
  (firstAmenity?.id && secondAmenity?.id)
    ? firstAmenity?.id == secondAmenity?.id
    : getAmenityLabel(firstAmenity) == getAmenityLabel(secondAmenity)

// The original row is spread as is, so the complete amenity object stays
// available to the reservation flow, only a display label is added on top.
const formatAmenityOptions = (facilityAmenities) => {
  if (!Array.isArray(facilityAmenities) || facilityAmenities?.length == 0) {
    return EMPTY_ARRAY
  }
  return facilityAmenities
    ?.filter((amenity) => amenity && getAmenityLabel(amenity) != '')
    ?.map((amenity) => ({ ...amenity, amenity_label: getAmenityLabel(amenity) }))
}

// The reservation save/update APIs take the picked amenities as the master
// amenity id plus the price charged for it at booking time. The rate API row
// carries amenity_id directly, the nested amenity id is the fallback.
const formatUserAmenitiesPayload = (amenities) => {
  if (!Array.isArray(amenities) || amenities?.length == 0) {
    return EMPTY_ARRAY
  }
  return amenities?.map((amenity) => ({
    amenity_id: amenity?.amenity_id || amenity?.amenity?.id || amenity?.id,
    price: amenity?.price ? amenity?.price : '0',
  }))
}

// Comma separated amenity ids for the reservation rate slug.
const getSelectedAmenityIds = (amenities) =>
  formatUserAmenitiesPayload(amenities)
    ?.map((amenity) => amenity?.amenity_id)
    ?.filter((amenityId) => amenityId || amenityId == 0)
    ?.join(',') || ''
// EOS-5093 Amenities

function responsiveReservation(props) {
  const divRef = useRef(null)
  const {
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    reset,
    clearErrors,
    setError,
    register,
    trigger,
  } = useForm()
  //   const { dispatch, loader, notify } = props


  const navigate = useNavigate()
  let { partner, resfacility } = useParams()
  const { dispatch, notify, partnerDetails, BookingEditData, BookingEdit, countryData, prevButton } = props
  const [facilityTimeZone, setFacilityTimeZone] = useState()
  // const airlineName = [{ id: 1, name: 'Allegiant' }, { id: 2, name: 'American' }, { id: 3, name: 'Avelo' }, { id: 4, name: 'Delta' }, { id: 1, name: 'JetBlue' },
  // { id: 5, name: 'Southwest' }, { id: 6, name: 'Spirit' }, { id: 7, name: 'United' },
  // ]

  // const cardnumbermask = createDefaultMaskGenerator('9999-9999-9999-9999-9999')
  const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
  const cardlastFournumbermask = createDefaultMaskGenerator('9999')
  const expirymask = createDefaultMaskGenerator('99/99')
  const phoneMask = createDefaultMaskGenerator('(999) 999-9999')
  const [page, setPage] = useState(1)
  const [facility, setFacility] = useState(EMPTY_ARRAY)
  const [airline, setAirline] = useState(EMPTY_ARRAY)

  const [facilityId, setFacilityId] = useState(resfacility || '')
  const [priceDetails, setPriceDetails] = useState(EMPTY_OBJECT)
  const [promoCodeApply, setPromoCodeApply] = useState(false)
  const [discount, setDiscount] = useState()
  //payment
  const [bookingStatus, setBookingStatus] = useState(false)
  const [bookingError, setBookingError] = useState(false)
  const [totalHoursLength, setTotalHoursLength] = useState(0)
  const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
  const [isLoading, setIsLoading] = useState(true)
  const [facilityName, setFacilityName] = useState(true)
  const [promocode, setPromocode] = useState('')
  const [webSourceBooking, setWebSourceBooking] = useState('')
  const [mapURL, setMapURL] = useState('')
  const [defaultPhone, setDefaultPhone] = useState('')
  const [mobile, setMobile] = useState('')
  const [isLicensePlate, setIsLicensePlate] = useState(false)
  const [loaderTicket, setLoaderTicket] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [entryDateTime, setEntryDateTime] = useState(new Date())
  const [exitDateTime, setExitDateTime] = useState(new Date())
  const [startDateTime, setStartDateTime] = useState(new Date())
  const [isCardFormVisible, setCardFormVisible] = useState(false)
  // Payment modal (Proceed To Pay) and its tab ('card' | 'saved-card' | 'wallet')
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  const [paymentTab, setPaymentTab] = useState(null)
  const [cardList, setCardList] = useState(EMPTY_ARRAY)
  const [paymentProfileId, setPaymentProfileId] = useState('')
  const [userConsent, setUserConsent] = useState(false)
  const [loaderPrice, setLoaderPrice] = useState(false)
  const [paymentDisable, setPaymentDisable] = useState(false)
  const [partnerUserId, setPartnerUserId] = useState(partnerDetails?.brand_setting?.user_id
    ? partnerDetails?.brand_setting?.user_id
    : partnerDetails?.partner_details?.brand_setting?.user_id || '')
  // const [checkInGate, setCheckInGate] = useState(EMPTY_ARRAY)
  // const [checkInGateID, setCheckInGateID] = useState('')
  const [accessPermissions, setAccessPermissions] = useState('')
  const [termCondition, setTermCondition] = useState(false)

  //vehicel

  const [isVehicleTableVisible, setIsVehicleTableVisible] = useState(false)
  const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
  const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
  const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
  const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
  const [vehicalId, setVehicalId] = useState('')
  const [otherMake, setOtherMake] = useState(false)
  const [otherModel, setOtherModel] = useState(false)
  const [maxstartDateTime, setMaxStartDateTime] = useState('')
  const [applyPromoLoder, setApplyPromoLoder] = useState(false)
  const [vehicleDetailsState, setVehicleDetailsState] = useState(EMPTY_ARRAY)



  //login
  const [caller, setCaller] = useState()
  const [show, setShow] = useState(false)
  const [showTerm, setTermShow] = useState(false)
  // const [showOtherVehical, setShowOtherVehical] = useState(false)
  const [useFor, setUseFor] = useState(false)

  //flight
  const [arrivalTime, setArrivalTime] = useState()
  const [departureTime, setDepartureTime] = useState()
  // const [vehicleMakeID, setVehicleMakeID] = useState('')
  const [vehicleMakeIDData, setVehicleMakeIDData] = useState('')
  const [vehicleModelIDData, setVehicleModelIDData] = useState('')
  const [vehicleColorDData, setVehicleColorDData] = useState('')
  // for the vehicle type 
  const [vehicleTypeData, setVehicleTypeData] = useState(null)
  // end for vehicle type 

  // edit condition
  const [timeupdate, setTimeupdate] = useState(false)
  const [isCheckinStatus, setIsCheckinStatus] = useState()
  const [isCheckOutStatus, setIsCheckOutStatus] = useState(false)
  const [diff, setDiff] = useState()
  const [actionTime, setActionTime] = useState(60)
  // const [bookingStartAfterTime, setbookingStartAfterTime] = useState(0)
  const [lengthPlusMinus, setLengthPlusMinus] = useState('')
  const [isPromo, setIsPromo] = useState(false)
  // const [stateName, setStateName] = useState()
  const [stateName, setStateName] = useState()
  const [promoAplicable, setPromoAplicable] = useState(false)
  const [cardNumber, setCardNumber] = useState('')
  const [cardExpiry, setCardExpiry] = useState('')
  const [defaultTimeZone, setDefaultTimeZone] = useState('America/New_York')
  const [isPromoDisabled, setIsPromoDisabled] = useState(false)
  const [facilityMaxVehicle, setFacilityMaxVehicle] = useState('')
  const [cardExpiryMessage, setCardExpiryMessage] = useState('')
  // const [CVV, setCVV] = useState('')
  const [usmLInkMsg, setUsmLInkMsg] = useState('Access Options/Where to Park/Rules')
  const [usmLInk, setUsmLInk] = useState('https://usm.maine.edu/parking-services')
  const [isRateMisMatch, setIsRateMisMatch] = useState(false)
  const [mismatchRateError, setMismatchRateError] = useState('')
  // const [selectedFacilityData, setSelectedFacilityData] = useState({})
  // const [showdateError, setShowDateError] = useState(false)
  // const [maxEndDate, setMaxEndDate] = useState(new Date(moment(new Date()).add(1, 'months')))
  const [startchange, setStartchange] = useState(false)
  const [bookingEditStatus, setBookingEditStatus] = useState(false)

  // for on behalf state 
  const [isOnBehalfExist, setOnBehalf] = useState(false)
  const [onBehalfButtonShow, setOnBehalfButtonShow] = useState(true)
  const [creater_id, setCreaterId] = useState('')
  const [promocodeRes, setPromocodeRes] = useState(EMPTY_OBJECT)
  const ismobileEmailEnabled = isLoggedIn() ? !isOnBehalfExist : BookingEdit
  const [isVehicleOversize, setIsVehicleOverSize] = useState(false)

  const [verifyPrepay, setVerifyPrepay] = useState('1')
  const [walletDisable, setWalletDisable] = useState(false)
  const [isIOSDevice, setIsIOSdevice] = useState(false)
  const loaded = useRef()
  const APILoad = useRef(true)
  const applePaySessionRef = useRef(null)
  const [walletButtonShow, setWalletButtonShow] = useState(null)

  // EOS_517
  const [parkingType, setParkingType] = useState([])
  const [selectedParkingType, setSelectedParkingType] = useState([])
  const [validationCodes, setValidationCodes] = useState([])
  const [selectedValidationCode, setSelectedValidationCode] = useState({})
  const [resetKey, setResetKey] = useState(0)
  const totalHoursLengthRef = useRef(null)
  const [isParkingTypeDisabled, setParkingTypeDisabled] = useState(false)
  const [selectedPaymentType, setSelectedPaymentType] = useState('0')
  const promocodeRef = useRef(null)
  // EOS-5093 The rate slug is built inside a setTimeout, so the selection is
  // mirrored on a ref to stay readable ahead of the async state update.
  const selectedAmenitiesRef = useRef(EMPTY_ARRAY)
  const startTimeRef = useRef(new Date())
  const exitTimeRef = useRef(new Date())
  // EOS-517

  // EOS-988
  const [couponConditions, setCouponConditions] = useState(false)
  // EOS-988
  // end

  // EOS-973
  const facilityRef = useRef(null)
  const tokenRef = useRef(null)
  const [cardToken, setCardToken] = useState('')
  const [iframeErrorMsg, setIframeErrorMsg] = useState('')

  // EOS-973

  // disabled Apply promo code button if entry exit time is not selected or parking type is not selected in case of parking type enabled 
  const newConditionForPromocode = BookingEdit ? (lengthPlusMinus == '0' || lengthPlusMinus == '2') ? true : false : false
  const isPromocodeAlreadyApplied = BookingEdit ? BookingEditData?.promocode ? false : true : false
  const isPromocodeEnabled = !promoAplicable || isPromoDisabled || (newConditionForPromocode && isPromocodeAlreadyApplied)

  // EOS-3503
  const [isReservationEnabled, setIsReservationEnabled] = useState(true)

  // EOS-5093 Amenities
  const [amenitiesList, setAmenitiesList] = useState(EMPTY_ARRAY)
  const [selectedAmenities, setSelectedAmenities] = useState(EMPTY_ARRAY)
  // EOS-5093 Amenities

  // ===== reCAPTCHA v3 Hook =====
  const { getToken, isReady } = useRecaptcha()
  // ===== End reCAPTCHA Hook =====

  useEffect(() => {
    if (partnerDetails?.facilities?.length == 1) {
      const reservationEnableState = partnerDetails?.facilities?.[0]?.facility_configuration?.is_reservation_enabled == 0 ? false : true
      setIsReservationEnabled(reservationEnableState)
    }
  }, [partnerDetails])


  useEffect(() => {
    if (BookingEdit) {
      if (BookingEditData?.facilityAmenities && BookingEditData?.facilityAmenities?.length > 0) {
        const amenityOptions = formatAmenityOptions(BookingEditData?.facilityAmenities)
        setAmenitiesList(amenityOptions)

        const updatedAmenities = formatAmenityOptions(BookingEditData?.reservation_amenities) || []

        setSelectedAmenities(updatedAmenities)
        selectedAmenitiesRef.current = updatedAmenities
      }

      setParkingTypeDisabled(true)
      if (BookingEditData?.promocode) {
        setIsPromo(true)
        setValue('promo_code', BookingEditData?.promocode ?? '')
      }
      startTimeRef.current = BookingEditData?.start_timestamp
      exitTimeRef.current = BookingEditData?.end_timestamp
      if (BookingEditData?.card_last_four && selectedPaymentType == 0) {
        handleCardNumber(BookingEditData?.card_last_four)
        setValue('card_number', BookingEditData?.card_last_four)
      }
      if (BookingEditData?.card_expiry && selectedPaymentType == 0) {
        handlCardExpiry(BookingEditData?.card_expiry)
        setValue('card_expiry', BookingEditData?.card_expiry)
      }
    } else {
      setParkingTypeDisabled(false)
    }
  }, [BookingEdit, BookingEditData])

  useEffect(() => {
    setUsmLInkMsg('Access Options/Where to Park/Rules')
    setUsmLInk('https://usm.maine.edu/parking-services')
    const isPromoApplical = (BookingEdit && BookingEditData?.promocode) ? true : false
    setIsPromo(isPromoApplical)
    setDefaultTimeZone('America/New_York')

    const getAccessPermissionData = sortPortalPermissionByKey(
      partnerDetails,
      ['Restricted Permissions', 'Access Permissions']
    )
    setAccessPermissions(getAccessPermissionData)
    const deviceType = getDeviceType()
    setIsIOSdevice(deviceType)


    // EOS-988 Hiding Facility
    if (isPermissionExist(getAccessPermissionData, 'Hide Facility')) {
      setFacilityId(partnerDetails?.facilities?.[0]?.id)
      const event = {
        target: {
          value: partnerDetails?.facilities?.[0]?.id
        }
      }
      if (!BookingEdit) handelGarage(event, partnerDetails?.facilities)// comment no need load first time booking edit open
    }
    // EOS-988 Hiding Facility
  }, [EMPTY_ARRAY, partnerDetails])

  // PIMS-15113
  useEffect(() => {
    let facilityList = partnerDetails?.facilities
    setFacility(facilityList)
    setAirline(partnerDetails?.airlines ? partnerDetails?.airlines : EMPTY_ARRAY)
    setFacilityId(resfacility ?? BookingEditData?.facility?.id ?? '')
    let user_id = partnerDetails?.brand_setting?.user_id
      ? partnerDetails?.brand_setting?.user_id
      : partnerDetails?.partner_details?.brand_setting?.user_id
    setPartnerUserId(user_id)
    if (resfacility && resfacility != '' && facilityList?.length > 0) {
      const event = {
        target: {
          value: resfacility
        }
      }
      handelGarage(event, facilityList)
    }
  }, [partnerDetails, resfacility])

  // Load Wallet Payment Script
  useEffect(() => {
    // Load Wallet Payment Script
    if (facilityRef?.current && (facilityRef?.current?.facility_configuration?.show_google_pay_button == '1' || facilityRef?.current?.facility_configuration?.show_apple_pay_button == '1')) {
      const getWalletPermission = isPermissionExist(accessPermissions, 'Enable A/G Pay - Reservation')
      setWalletButtonShow(showhideWalletButton(facilityRef?.current) && getWalletPermission, getWalletPermission)
    }
    if (facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1) {
      setSelectedPaymentType('0')
    } else {
      setSelectedPaymentType('1')
    }
    const paymentGateway = facilityRef?.current?.facility_payment_details?.facility_payment_type_id
    const applePayScript = getWalletScriptUrl(paymentGateway)
    Object.values(applePayScript)?.map((item) => {
      if (item) {
        addScript(loaded, item, '')
      }
    })
    // Load Wallet Payment Script
  }, [EMPTY_ARRAY, facilityRef?.current?.facility_payment_details?.facility_payment_type_id])


  const handleVehicleChange = (event) => {
    setBookingEditStatus(true)
    clearErrors('vehicle')
    setVehicalId(event.target.value)
    setValue('vehicle', event.target.value)
    let filter = vehicleList?.filter((veh) => veh?.id == event.target.value)
    setValue('license_plate', restrictInValidCharLicense(filter?.[0]?.license_plate_number)?.replace(/[^a-zA-Z0-9]/g, ''))
    //setValue('license_plate', event.target.value)
  }

  const showVehicleTable = () => {
    clearErrors('vehicle')
    setIsVehicleTableVisible(true)
    setVehicalId('')
    setValue('vehicle', '')
    setValue('license_plate', '')
    setValue('make', '')
    setValue('model', '')
    setValue('color', '')
    reset(formValues => ({ ...formValues, vehicle_country: 'US' })) // AS PER PIMS-13126 SHOW US BY DEFAULT IN VEHICLE COUNTRY DROPDOWN
  }

  const removeVehicleMake = () => {
    setVehicalId('')
    setValue('vehicle', '')
    setValue('license_plate', '')
    setIsVehicleTableVisible(false)
    if (vehicleList.length == 1) {
      setVehicalId(vehicleList[0]?.id)
      setValue('vehicle', vehicleList[0]?.id)
      // setValue('license_plate', vehicleList[0]?.license_plate_number)
    } else {
      setVehicalId('')
      setValue('vehicle', '')
    }


  }

  const handleDownloadTicket = (Id, ticketNumber) => {
    if (!loaderTicket) {
      setLoaderTicket(true)
      dispatch(downloadTicket(Id, ticketNumber))
        .then((res) => {
          setLoaderTicket(false)
          if (res?.errors) {
            notify('error', res?.errors?.message)
          } else {
            notify('Success', 'Reservation Downloaded!')
          }
        })
        .catch(() => {
          setLoaderTicket(false)
          notify('error', 'Something went wrong, Please try again!')
        })
    }
  }

  const resetFormValue = () => {
    reset()
    setTotalHoursLength(0)
    totalHoursLengthRef.current = 0
    setPaymentProfileId('')
    setPromoCodeApply(false)
    setDiscount(0)
    setPromocode()
    promocodeRef.current = null
    //setPriceDetailsResponce(EMPTY_OBJECT)
    setPriceDetails(EMPTY_OBJECT)
    setValue('entry_time', new Date(entryDateTime))
    setValue('exit_time', new Date(exitDateTime))
    setValue('garage', facilityId)
    setPaymentDisable(false)
    setVehicalId('')
    setValue('vehicle', '')
  }

  // const applyPromocodeRate = (priceRes='') => {
  //  // let priceDetails =priceRes
  //   let promoForm = getValues()
  //   if (promoForm.email) {
  //     if (promoForm.promo_code) {
  //       let promoCodePayload = {
  //         is_guest: isLoggedIn() ? false : true,
  //         tax_amount: priceRes.tax_fee,
  //         client_id: partnerDetails?.clients?.secret,
  //         email: promoForm.email, //'dhirendra002@yopmail.com',
  //         promocode: promoForm.promo_code, //'TESTWORLDPORT',
  //         amount: BookingEdit ? priceRes.payable_amount : priceRes.total, //payable_amount,parking_amount
  //         processing_fee: priceRes.processing_fee,
  //         reservation_id: BookingEdit ? BookingEditData.id:'',
  //       }
  //       dispatch(applyPromoCodeReservation(promoCodePayload))
  //         .then((response) => {
  //           if (response.status == 200 && response?.data) {
  //             setPromocode(promoCodePayload?.promocode)
  //             setPromoCodeApply(true)
  //             setDiscount(response.data.discount_in_dollar)              
  //             // let checkPayment = priceRes.payable_amount - response.data.discount_in_dollar
  //             let payable={...priceRes}
  //             payable['payable_amount']=response?.data?.payable_amount
  //             setPriceDetails(payable)
  //             // priceDetails['payable_amount']=response?.data?.payable_amount
  //             let checkPayment =response?.data?.payable_amount ? response?.data?.payable_amount:''

  //             if (checkPayment == 0) {
  //               setPaymentDisable(true)
  //             } else {
  //               setPaymentDisable(false)
  //             }
  //             notify(
  //               'success',
  //               response.data
  //                 ? response.data.message
  //                 : 'Promocode applied successfully!'
  //             )
  //           } else {
  //             setPaymentDisable(false)
  //             notify(
  //               'error',
  //               response.errors
  //                 ? response.errors.message
  //                 : 'Please Enter Valid Promo Code'
  //             )
  //           }
  //         })
  //         .catch((err) => {
  //           notify('error', err)
  //         })
  //     } else {
  //       notify('error', 'Please Enter Promo Code')
  //     }
  //   } else {
  //     notify('error', 'Please Enter email')
  //   }
  // }
  const applyPromocode = (priceResPonsce = '', msgStatus = '') => {
    setApplyPromoLoder(true)
    setBookingEditStatus(true)
    let priceRes = priceResPonsce ? priceResPonsce : priceDetails

    let promoForm = getValues()
    if (promoForm.email || (facilityRef?.current?.facility_configuration?.enable_third_party_coupons && facilityRef?.current?.facility_configuration?.enable_third_party_coupons == 1)) {
      if (trimedSpacePayload(promoForm?.promo_code)) {
        let promoCodePayload = {
          is_guest: isLoggedIn() ? false : true,
          // tax_amount: BookingEdit ? BookingEditData?.tax_fee : priceRes?.tax_fee,
          tax_amount: BookingEdit ? priceRes?.tax_fee ?? BookingEditData?.tax_fee : priceRes?.tax_fee,
          client_id: partnerDetails?.clients?.secret,
          email: promoForm?.email, //'dhirendra002@yopmail.com',
          promocode: promoForm?.promo_code, //'TESTWORLDPORT',
          // amount: priceRes?.payable_amount, //payable_amount,parking_amount
          amount: (BookingEdit && lengthPlusMinus == 2) ? BookingEditData?.reservation_amount : priceRes?.reservation_amount, //payable_amount,parking_amount
          processing_fee: priceRes?.processing_fee,
          reservation_id: BookingEdit ? BookingEditData?.id : '',
          license_plate: BookingEdit ? (BookingEditData?.license_plate) ? BookingEditData?.license_plate : '' : getValues()?.license_plate ? getValues()?.license_plate : '',
          phone: mobile ? mobile : '',
          // reservation_mode: BookingEdit ? lengthPlusMinus == '1' ? '2' : lengthPlusMinus == '3' ? '3' : '1' : '0',
          reservation_mode: BookingEdit ? lengthPlusMinus == '1' ? '2' : lengthPlusMinus == '0' ? '1' : '3' : '0',// new reservation= 0, extend=2, reduce =>1, other update =3

          facility_id: facilityId,
          length_of_stay: totalHoursLengthRef.current ? formatDecimal(totalHoursLengthRef.current) : '',
          extension_promocode_applied: (BookingEdit && !BookingEditData?.promocode) ? true : false,//As per discussed with lokesh
          rate_id_hourly: priceDetails?.rate_id_hourly ? priceDetails?.rate_id_hourly : '',
          arrival_time: entryDateTime ? dateTimeFormatefunction(entryDateTime) : '',
          // EOS-5093 Latest amenity selection, as the comma separated ids the
          // promo endpoint expects. Read from the ref, which every add/remove
          // updates synchronously, so a promo applied straight after an amenity
          // change never validates against a stale selection.
          amenities: getSelectedAmenityIds(selectedAmenitiesRef?.current),
        }
        if (selectedParkingType && selectedParkingType != '') {
          promoCodePayload.parking_type_id = selectedParkingType
        }
        if (priceRes?.additional_fee && priceRes?.additional_fee != '') {
          promoCodePayload.additional_fee = priceRes?.additional_fee
        }
        if (priceRes?.surcharge_fee && priceRes?.surcharge_fee != '') {
          promoCodePayload.surcharge_fee = priceRes?.surcharge_fee
        }
        if (priceRes?.parking_amount && priceRes?.parking_amount != '') {
          promoCodePayload.parking_amount = priceRes?.parking_amount
        }
        if ((facilityRef?.current?.facility_configuration?.enable_third_party_coupons && facilityRef?.current?.facility_configuration?.enable_third_party_coupons == 1)) {
          promoCodePayload.is_third_party_coupon = 1
        }
        dispatch(applyPromoCodeReservation(trimedSpacePayload(promoCodePayload)))
          .then((response) => {
            setApplyPromoLoder(false)
            if ((response?.status == 200 || response.status == 202 || response.status == 201) && response?.data) {
              setPromocode(promoCodePayload?.promocode)
              promocodeRef.current = promoCodePayload?.promocode
              setPromoCodeApply(true)
              setDiscount(response?.data?.discount_amount)
              setPromocodeRes(response?.data)
              // let checkPayment = priceRes.payable_amount - response.data.discount_in_dollar
              // let payable = { ...priceRes }
              // payable['payable_amount'] = response?.data?.payable_amount
              const updatedPriceDetails = { ...priceDetails, ...response?.data }
              setPriceDetails(updatedPriceDetails)
              // priceDetails['payable_amount']=response?.data?.payable_amount
              let checkPayment = response?.data?.payable_amount ? response?.data?.payable_amount : ''

              if (checkPayment == 0) {
                setPaymentDisable(true)
              } else {
                setPaymentDisable(false)
              }
              msgStatus != '0' ? notify(
                'success',
                response?.data
                  ? response?.data?.message
                  : 'Promocode applied successfully'
              ) : ''
            } else {
              setValue('promo_code', '')
              if (priceDetails?.payable_amount == 0) {
                setPaymentDisable(true)
              } else {
                setPaymentDisable(false)
              }
              // setPaymentDisable(false)
              const errorMessage = response?.errors?.detail
                ? Object.values(response?.errors?.detail)?.flat()?.join('\n')
                : response?.errors?.message || 'Please Enter Valid Promo Code'
              notify(
                'error',
                response?.errors
                  ? errorMessage
                  : 'Please Enter Valid Promo Code'
              )
              setWalletDisable(true)
              if (!BookingEdit && !BookingEditData) {
                removePromocode(false)
              }

            }
          })
          .catch((err) => {
            const errorMessage = err?.errors?.detail
              ? Object.values(err?.errors?.detail)?.flat()?.join('\n')
              : err?.errors?.message || 'Please Enter Valid Promo Code'
            setApplyPromoLoder(false)
            notify('error', errorMessage)
            setWalletDisable(true)
            setValue('promo_code', '')
            if (!BookingEdit && !BookingEditData) {
              removePromocode(false)
            }
          })
      } else {
        setApplyPromoLoder(false)
        notify('error', 'Please Enter Promo Code')
      }
    } else {
      setApplyPromoLoder(false)
      notify('error', 'Please Enter Email')
    }
  }

  // const applyPromocodeOld = () => {
  //   let promoForm = getValues()
  //   if (promoForm.email) {
  //     if (promoForm.promo_code) {
  //       let promoCodePayload = {
  //         is_guest: isLoggedIn() ? false : true,
  //         tax_amount: priceDetails.tax_fee,
  //         client_id: partnerDetails?.clients?.secret,
  //         email: promoForm.email, //'dhirendra002@yopmail.com',
  //         promocode: promoForm.promo_code, //'TESTWORLDPORT',
  //         amount: BookingEdit ? priceDetails.payable_amount : priceDetails.total, //payable_amount,parking_amount
  //         processing_fee: priceDetails.processing_fee,
  //         reservation_id: BookingEdit ? BookingEditData.id:'',
  //       }
  //       dispatch(applyPromoCodeReservation(promoCodePayload))
  //         .then((response) => {
  //           if (response.status == 200 && response?.data) {
  //             setPromocode(promoCodePayload?.promocode)
  //             setPromoCodeApply(true)
  //             setDiscount(response.data.discount_in_dollar)              
  //             // let checkPayment = priceDetails.payable_amount - response.data.discount_in_dollar
  //             let payable={...priceDetails}
  //             payable['payable_amount']=response?.data?.payable_amount
  //             setPriceDetails(payable)
  //             // priceDetails['payable_amount']=response?.data?.payable_amount
  //             let checkPayment =response?.data?.payable_amount ? response?.data?.payable_amount:''

  //             if (checkPayment == 0) {
  //               setPaymentDisable(true)
  //             } else {
  //               setPaymentDisable(false)
  //             }
  //             notify(
  //               'success',
  //               response.data
  //                 ? response.data.message
  //                 : 'Promocode applied successfully!'
  //             )
  //           } else {
  //             setPaymentDisable(false)
  //             notify(
  //               'error',
  //               response.errors
  //                 ? response.errors.message
  //                 : 'Please Enter Valid Promo Code'
  //             )
  //           }
  //         })
  //         .catch((err) => {
  //           notify('error', err)
  //         })
  //     } else {
  //       notify('error', 'Please Enter Promo Code')
  //     }
  //   } else {
  //     notify('error', 'Please Enter email')
  //   }
  // }

  const resetPriceValue = () => {
    setPromoCodeApply(false)
    setDiscount(0)
  }

  const removePromocode = (showRemoveMsg = true) => {
    setWalletDisable(true)
    setPromoCodeApply(false)
    setDiscount(0)
    setPromocode(null)
    setBookingEditStatus(true)
    promocodeRef.current = null
    setValue('promo_code', '')
    setPromocodeRes(EMPTY_OBJECT)

    if (priceDetails.payable_amount > 0) {
      setPaymentDisable(false)
    }
    getPriceDetaitlsToggle(
      partnerUserId,
      BookingEditData?.facility?.id || facilityId,
      entryDateTime,
      exitDateTime,
      true
    )
    setSelectedValidationCode({})
    setResetKey(prev => prev + 1)
    showRemoveMsg ? notify('error', ' Promocode has been removed successfully') : null

  }

  const diff_hours = (endTime, startTime) => {
    const startDate = new Date(startTime)
    const endDate = new Date(endTime)
    let timeDiff
    if (!isNaN(startDate) && !isNaN(endDate)) {
      const timeDifferenceInMilliseconds = endDate - startDate
      const hours = Math.floor(timeDifferenceInMilliseconds / 3600000)
      const minutes = Math.floor(
        (timeDifferenceInMilliseconds % 3600000) / 60000
      )
      timeDiff = `${hours}.${minutes}`
    } else {
      timeDiff = 'Invalid Time'
    }
    setTotalHoursLength(timeDiff)
    totalHoursLengthRef.current = timeDiff
    return timeDiff
  }

  const dateTimeFormatefunction = (date) => {
    let dateformate =
      date.toLocaleDateString('en-CA') +
      ' ' +
      String(date.getHours()).padStart(2, '0') +
      ':' +
      String(date.getMinutes()).padStart(2, '0') +
      ':' +
      String(date.getSeconds()).padStart(2, '0')
    return dateformate
  }

  const getNumberPrice = (value) => {
    let data = value.toString()
    let price
    if (data != 'N/A') {
      price = data.replace(/,/g, '')
      price = Number(price)
    } else {
      price = 'N/A'
    }

    return price
  }

  useEffect(() => {
    if (BookingEdit && BookingEditData && Object.keys(BookingEditData)?.length > 0 && BookingEditData?.facility?.id != '') {
      let bookHour = moment(new Date(BookingEditData?.start_timestamp)).format('YYYY-MM-DD HH:mm:ss')
      let bookendTime = moment(new Date(BookingEditData?.end_timestamp)).format('YYYY-MM-DD HH:mm:ss')

      const isSameStart = moment(bookHour).isSame(moment(startTimeRef?.current))
      const isSameEnd = moment(bookendTime).isSame(moment(exitTimeRef?.current))

      if (!isSameStart && !isSameEnd) {
        getPriceDetaitlsToggle(partnerUserId, BookingEditData?.facility_id, entryDateTime, exitDateTime)
      }
    } else {
      facilityId ? getPriceDetaitlsToggle(partnerUserId, facilityId, entryDateTime, exitDateTime) : null
      if (BookingEditData?.facility?.id || facilityId) {
        setValue('promo_code', '')
        setSelectedValidationCode({})
        removePromocode(false)
      }
    }
  }, [isVehicleOversize, selectedParkingType])



  const getPriceDetaitlsToggle = (partnerId, facilityIds, startDate, endDate, removePromo = false) => {
    setArrivalTime()
    if (!props.BookingEdit) {
      setDepartureTime()
      setValue('departure_time', undefined)
    }
    setValue('arrival_time', undefined)

    // if (!isPermissionExist(accessPermissions, 'Hide Address Fields')) {
    //   setValue('country', 'United States')
    // }
    setIsLoading(true)
    setLoaderPrice(true)
    setPaymentDisable(false)
    let user_id = partnerId
    let dt1 = startDate
    let dt2 = endDate
    // let dt1 = startDate ? startDate : entryDateTime
    // let dt2 = endDate ? endDate : exitDateTime



    if (user_id && (facilityIds || resfacility) && dt1 <= dt2 && dt1 != null && dt2 != null) {
      let hours = diff_hours(dt2, dt1)
      var length_plus_minus = ''
      if (props.BookingEdit) {
        let bookingHours = formatDecimal(props?.BookingEditData?.length)
        bookingHours = Number(bookingHours)
        let newHours = formatDecimal(hours)
        newHours = Number(newHours)

        if (newHours > bookingHours) {//extend case
          length_plus_minus = '1'
          setTimeupdate(true)
          // setPaymentDisable(false)
        } else if (newHours < bookingHours) {//refund case
          length_plus_minus = '0'
          setTimeupdate(true)
          // setPaymentDisable(true)
        } else if (newHours == bookingHours) {
          length_plus_minus = '2'
          // length_plus_minus = startchange ? '3' : '2'
          console.log(startchange)
          setTimeupdate(true)
          // setPaymentDisable(true)
        } else {
          length_plus_minus = '2'
          setTimeupdate(false)
          // setPaymentDisable(true)
        }
      }

      if (facilityRef?.current?.facility_configuration?.is_process_fee_charged == '1') {
        setPaymentDisable(false)
      }

      setLengthPlusMinus(length_plus_minus)

      // For EOS-2551 We need to uncomment the below code and update as required... butcurrently its not working from BE.
      if (length_plus_minus == '0') {
        setPromoCodeApply(false)
        setDiscount(0)
        setPromocode(null)
        promocodeRef.current = null
        setValue('promo_code', '')
        setPromocodeRes(EMPTY_OBJECT)
        // priceDetails.promocode = null
        // BookingEditData.promocode = null
        // BookingEditData?.promocode ? notify('error', 'By selecting previous date, the existing Coupon code will be removed, You will need to re-select/apply the coupon for new reservation dates.') : null
      }

      if (hours >= 1) {
        setTotalHoursLength(hours)
        totalHoursLengthRef.current = hours
        setTimeout(() => {
          let entryTime = dateTimeFormatefunction(new Date(dt1))
          let slug = ''
          if (props.BookingEdit) {
            let reservation_id = props?.BookingEditData?.id
            slug = `arrival_time=${entryTime}&reservation_id=${reservation_id}&length_plus_minus=${length_plus_minus}&length_of_stay=${hours}&use_bonus=0&user_id=${user_id}&is_vehicle_oversize=${isVehicleOversize ? '1' : '0'}`

          } else {
            slug = `arrival_time=${entryTime}&length_of_stay=${hours}&use_bonus=0&user_id=${user_id}&is_vehicle_oversize=${isVehicleOversize ? '1' : '0'}`

          }
          if (getConfigPermission(facilityRef?.current, 'enable_parking_type') && selectedParkingType && selectedParkingType != '') {
            slug = `${slug}&parking_type_id=${selectedParkingType}`
          }

          // EOS-5093 Amenities the user picked, so the rate comes back priced
          // with them included.
          const selectedAmenityIds = getSelectedAmenityIds(selectedAmenitiesRef?.current)
          if (selectedAmenityIds != '') {
            slug = `${slug}&amenities=${selectedAmenityIds}`
          }

          // Enable Auto Apply Coupon EOS-701
          if (facilityRef?.current?.facility_configuration?.enable_third_party_coupons && facilityRef?.current?.facility_configuration?.enable_third_party_coupons == 1) {
            slug = `${slug}&enable_promo_auto_apply=${facilityRef?.current?.facility_configuration?.enable_promo_auto_apply}`
          }

          if (BookingEdit && BookingEditData?.promocode && length_plus_minus != 0 && !removePromo) {
            slug = `${slug}&promocode=${BookingEditData?.promocode}`
          }



          // if (length_plus_minus == '' || length_plus_minus != '2') {
          dispatch(getPriceDetailsByTime(facilityIds || resfacility, slug)).then((res) => {
            if (res?.status == 500 && res?.errors?.message) {
              notify('error', res?.errors?.message ? res?.errors?.message : 'Somthing went wrong!')
              setLoaderPrice(false)
              setIsLoading(false)
              return
            }
            // let priceRes
            let isFacilityClosed = res?.data?.isFacilityClosed

            // EOS-701 Auto Apply Coupon
            if (facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == res?.data?.facility?.facility_configuration?.enable_promo_auto_apply && res?.data?.facility?.facility_configuration?.enable_promo_auto_apply == 1 && (res?.data?.discount_amount && res?.data?.discount_amount != '' && res?.data?.applied_promo_code && res?.data?.applied_promo_code != '')) {
              setPromoCodeApply(true)
              setDiscount(res?.data?.discount_amount)
              setPromocode(res?.data?.applied_promo_code?.code)
              promocodeRef.current = res?.data?.applied_promo_code?.code
            } else {
              setPromocode(null)
              promocodeRef.current = null
            }
            // EOS-701 Auto Apply Coupon

            // EOS-3503
            if (res?.data?.facility?.facility_configuration?.is_reservation_enabled && res?.data?.facility?.facility_configuration?.is_reservation_enabled == 0) {
              setIsReservationEnabled(false)
            } else {
              setIsReservationEnabled(true)
            }
            // EOS-3503

            // Update PromoResponse
            if (res?.data?.promocode) {
              setPromocodeRes(res?.data?.promocode)
            }
            // Update PromoResponse

            // Updating The Facility Object
            if (res?.data?.facility && res?.data?.facility != '') {
              const updatedFacilityData = res?.data?.facility
              updatedFacilityData.facility_payment_details = facilityRef?.current?.facility_payment_details
              facilityRef.current = updatedFacilityData
              // setSelectedFacilityData(updatedFacilityData)
            }
            // Updating The Facility Object

            // EOS-5093 Amenities are read from this same rate response, so no
            // extra request is made for data the page already has. A missing,
            // null or empty facilityAmenities simply leaves the list empty.
            const amenityOptions = formatAmenityOptions(res?.data?.facilityAmenities)
            setAmenitiesList(amenityOptions)
            // Keep whatever the user already picked, minus anything the
            // refreshed facility no longer offers.
            const retainedAmenities = (selectedAmenitiesRef?.current || EMPTY_ARRAY)?.filter((previousAmenity) =>
              amenityOptions?.some((amenity) => isSameAmenity(amenity, previousAmenity))
            )
            if (!BookingEdit) {
              selectedAmenitiesRef.current = retainedAmenities
              setSelectedAmenities(retainedAmenities)
            }
            // EOS-5093 Amenities

            let availability = res?.data?.availability
            if (res?.data && isFacilityClosed != 1 && availability > 0) {
              // setPriceDetailsResponce(res?.data)
              let price = Number(
                formatDecimal(getNumberPrice(res?.data?.price))
              )
              let tax_fee = Number(
                formatDecimal(getNumberPrice(res?.data?.tax_fee))
              )

              // FOR STAGING
              // let processing_fee = Number(
              //   parseFloat(
              //     getNumberPrice(res?.data?.processing_fee)
              //   )
              // ).toFixed(2)

              // FOR LIVE
              let processing_fee = Number(
                formatDecimal(getNumberPrice(res?.data?.facility?.processing_fee))
              )
              let payableAmount = price + tax_fee + processing_fee
              Number(payableAmount)

              let priceResponce = res?.data

              //for 100 % coupon apply
              if (props.BookingEdit) { //Number(priceResponce?.promocode?.discount_amount) > 0
                let rateDiscount = Number(priceResponce?.promocode?.discount_amount) > 0 ? formatDecimal(priceResponce?.promocode?.discount_amount) : formatDecimal(priceResponce?.discount_amount)
                let couponName = priceResponce?.promocode?.promocode?.promocode ? priceResponce?.promocode?.promocode?.promocode : ''
                setDiscount(rateDiscount ? rateDiscount : discount)
                setIsPromo(couponName ? true : false)
                setValue('promo_code', couponName)
                setPromoAplicable(couponName ? false : true)
              }

              // to hide the card details properly while 100 % coupon apply
              const isPayableAmountZero = props.BookingEdit && formatDecimal(priceResponce?.promocode?.payable_amount) == formatDecimal(0) ? true : false
              setPaymentDisable(isPayableAmountZero)

              res?.data?.price == 'N/A'
                ? setIsLoading(true)
                : setIsLoading(false)

              res.data.parking_amount = priceResponce?.parking_amount != 'N/A' ? formatDecimal(priceResponce?.parking_amount) : 'N/A'
              if (res?.data?.promocode && res?.data?.promocode != '') {
                res.data.promocode.reservation_amount = res.data.reservation_amount
                setPriceDetails(res?.data?.promocode)
              } else {
                setPriceDetails(res?.data)
              }

              if (BookingEdit && !isPromoDisabled && discount > 0 && (promocodeRef?.current || getValues().promo_code)) {
                const code = promocodeRef?.current || getValues().promo_code
                const selectedPromocode = validationCodes?.filter((validation_code) => validation_code?.promo_code?.[0]?.promocode == code)

                if (moment(selectedPromocode?.[0]?.valid_to).isAfter(moment(exitTimeRef?.current))) {
                  applyPromocode(res?.data)
                } else {
                  notify('error', 'Selected Coupon Code is not Valid for this Parking Duration')
                  Object.keys(selectedValidationCode)?.length > 0 ? removePromocode(false) : null
                  setSelectedValidationCode({})
                  setValue('promo_code', '')
                }
              } else {
                if ((promocodeRef?.current || getValues().promo_code) && facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == 0 && !BookingEdit) {
                  const code = promocodeRef?.current || getValues().promo_code
                  const selectedPromocode = validationCodes?.filter((validation_code) => validation_code?.promo_code?.[0]?.promocode == code)

                  if (moment(selectedPromocode?.[0]?.valid_to).isAfter(moment(exitTimeRef?.current))) {
                    applyPromocode(res?.data)
                  } else {
                    notify('error', 'Selected Coupon Code is not Valid for this Parking Duration')
                    Object.keys(selectedValidationCode)?.length > 0 ? removePromocode(false) : null
                    setSelectedValidationCode({})
                    setValue('promo_code', '')
                  }

                }
              }

              if (Number(res?.data?.payable_amount) > 0 || Number(priceResponce?.promocode?.payable_amount) > 0) {
                setPaymentDisable(false)
              } else {
                if (facilityRef?.current?.facility_configuration?.is_process_fee_charged == '1') {
                  setPaymentDisable(false)
                } else {
                  setPaymentDisable(true)
                }
              }
            } else {
              let priceRes = {
                parking_amount: 'N/A',
                tax_fee: 'N/A',
                processing_fee: 'N/A',
                payable_amount: 'N/A',
                additional_fee: 'N/A',
                surcharge_fee: 'N/A'
              }
              if (props.BookingEdit) {
                setPriceDetails(priceRes)
              } else {
                setPriceDetails(priceRes)
              }

            }
            if (availability <= 0) {
              notify('error', res?.data?.availability_msg)
            }
            setLoaderPrice(false)
            setWalletDisable(false)
          }).catch((err) => {
            console.log('err', err)
            // EOS-5093 Amenities are optional, drop the list rather than
            // leaving a stale one behind when the rate call fails.
            setAmenitiesList(EMPTY_ARRAY)
            setSelectedAmenities(EMPTY_ARRAY)
            selectedAmenitiesRef.current = EMPTY_ARRAY
            notify('error', 'Somthing went wrong!')
          })

          // } else {
          //   setIsLoading(false)
          //   setLoaderPrice(false)
          // }
        }, 0)
      } else {
        setLoaderPrice(false)
        setWalletDisable(false)
        setIsLoading(true)
        setPriceDetails(null)
        notify('error', 'Booking is available for minimum 1 hour!')
      }
    } else {
      let priceRes = {
        parking_amount: 'N/A',
        tax_fee: 'N/A',
        processing_fee: 'N/A',
        payable_amount: 'N/A',
        additional_fee: 'N/A',
        surcharge_fee: 'N/A',
      }
      setPriceDetails(priceRes)
      setLoaderPrice(false)
      setWalletDisable(false)
      if (facilityIds == '') {
        notify('error', 'Please select a parking zone/garage')
      }
      // notify('error', 'sorry,something went wrong!')
    }
  }

  const handleEntryTime = (event) => {
    setBookingEditStatus(true)
    if (event) {
      let entryDate = new Date(event)
      let exitDate = new Date(event).setHours(new Date(event).getHours() + 2)
      if (moment(entryDate).add(1, 'hour').isAfter(moment(exitTimeRef?.current))) {
        exitDate = new Date(event).setHours(new Date(event).getHours() + 2)
      } else {
        exitDate = exitTimeRef?.current
      }

      // setMaxEndDate(new Date(moment(new Date(event)).add(1, 'months')))

      exitDate = new Date(exitDate)
      exitTimeRef.current = new Date(exitDate)
      if (maxstartDateTime == '' || (new Date(maxstartDateTime) >= new Date(event))) {
        resetPriceValue()
        setEntryDateTime(event)
        startTimeRef.current = event
        setValue('entry_time', event)
        // if (entryDate > exitDateTime) {
        setExitDateTime(exitDate)
        exitTimeRef.current = exitDate
        setValue('exit_time', exitDate)
        clearErrors('exit_time')
        getPriceDetaitlsToggle(
          partnerUserId,
          BookingEditData?.facility?.id || facilityId || resfacility,
          entryDate,
          exitDate
        )
        // } else {
        //   setExitDateTime(exitDateTime)
        //   setValue('exit_time', exitDateTime)
        //   clearErrors('exit_time')
        //   getPriceDetaitlsToggle(
        //     partnerUserId,
        //     facilityId,
        //     entryDate,
        //     exitDateTime
        //   )
        // }

        setStartchange(props.BookingEdit ? true : false)

      } else {
        if (moment(new Date(maxstartDateTime)).format('YYYY-MM-DD') > moment(new Date(entryDateTime)).format('YYYY-MM-DD')) {
          entryDate = new Date(event)
          let exitDate = new Date(event).setHours(new Date(event).getHours() + 2)
          exitDate = new Date(exitDate)
          exitTimeRef.current = exitDate
          resetPriceValue()
          setEntryDateTime(maxstartDateTime)
          startTimeRef.current = maxstartDateTime
          // setMaxEndDate(new Date(moment(new Date(maxstartDateTime)).add(1, 'months')))
          setValue('entry_time', maxstartDateTime)
          // if (entryDate > exitDateTime) {
          setExitDateTime(exitDate)
          exitTimeRef.current = exitDate
          setValue('exit_time', exitDate)
          clearErrors('exit_time')
          getPriceDetaitlsToggle(
            partnerUserId,
            BookingEditData?.facility?.id || facilityId || resfacility,
            entryDate,
            exitDate
          )
          // } else {
          //   setExitDateTime(exitDateTime)
          //   setValue('exit_time', exitDateTime)
          //   clearErrors('exit_time')
          //   getPriceDetaitlsToggle(
          //     partnerUserId,
          //     facilityId,
          //     entryDate,
          //     exitDateTime
          //   )
          // }

          // setStartchange(props.BookingEdit ? true : false)


        } else {
          notify('error', 'you can not book reservation more than 24 hours from current time')
        }
        // else {
        //   notify('error', 'you can not book reservation more for passed date/time')
        // }
        // && new Date(event) >= new Date(startDateTime)
      }
    } else {
      resetPriceValue()
      setEntryDateTime(event)
      startTimeRef.current = event
      // setMaxEndDate(new Date(moment(new Date(event)).add(1, 'months')))
      setStartchange(props.BookingEdit ? true : false)
      setValue('entry_time', event)
      getPriceDetaitlsToggle(
        partnerUserId,
        BookingEditData?.facility?.id || facilityId || resfacility,
        event,
        getValues().exit_time
      )
    }
    fetchValidationCodes()
    clearErrors('entry_time')
  }

  const bookingDiff = (event) => {
    let timeShorten = true
    const currentDateTime = moment(new Date()).tz(`${BookingEditData?.facility?.timezone ? BookingEditData?.facility?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
    let bookHour = moment(new Date(BookingEditData?.start_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
    let bookendTime = moment(new Date(BookingEditData?.end_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
    let eventDate = moment(new Date(event)).format('YYYY-MM-DDTHH:mm:ss')
    // let diff = Math.floor((new Date(bookHour).getTime() - new Date(currentDateTime).getTime()) / 60000)

    if (BookingEditData?.parking_type_id && BookingEditData?.parking_type_id != '') {
      setSelectedParkingType(BookingEditData?.parking_type_id)
    }

    if (BookingEditData?.is_ticket == '1' || currentDateTime > bookHour) {
      if (eventDate > bookendTime) {
        timeShorten = true
      } else {
        timeShorten = false
        notify('error', 'Reservation time can not reduced!')
      }
    }
    return timeShorten
  }

  const handleExitTime = (event) => {
    setBookingEditStatus(true)
    // resetPriceValue()
    // if (new Date(moment(event).format('YYYY-MM-DD h:mm:ss')) > new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss'))) {
    //   setExitDateTime(new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')))
    //   setValue('exit_time', new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')))
    // } else {
    //   setExitDateTime(event)
    //   setValue('exit_time', event)
    // }

    setExitDateTime(event)
    exitTimeRef.current = event
    setValue('exit_time', event)
    if (event == null) {
      setExitDateTime(event)
      exitTimeRef.current = event
      setValue('exit_time', event)
    }
    let shorten = true
    if (BookingEdit) {
      shorten = bookingDiff(event)
    }
    if (shorten) {
      if (event) {
        let dt1 = entryDateTime
        let dt2 = new Date(event)

        //Checking if the Exit/End Date time is greater than 1 month then setting end date as max enddate time, else user selected date time.
        // if (new Date(moment(event).format('YYYY-MM-DD h:mm:ss')) > new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss'))) {
        //   dt2 = new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss'))          
        // } else {
        //   dt2 = event
        // }

        let hours = diff_hours(dt2, dt1)
        if (dt2 > dt1) {
          const isValidDays = true // remove check monthly parking booking as per discussed vishal sir
          // const isValidDays = areDatesExactlyGivenMonthsApart(moment(entryDateTime).format('YYYY-MM-DD h:mm:ss'), moment(dt2).format('YYYY-MM-DD h:mm:ss'), 1)
          if (!isValidDays) {
            // if (hours > 24 * 30) {
            notify('error', 'Monthly parking not available!')
            // setIsLoading(true)
          } else if (hours < 1) {
            setPriceDetails(null)
            notify('error', 'Booking is available for minimum 1 hour!')
            //setIsLoading(true)
          } else {
            resetPriceValue()
            // if (new Date(moment(event).format('YYYY-MM-DD h:mm:ss')) > new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss'))) {
            //   setExitDateTime(new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')))
            //   setValue('exit_time', new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')))
            // } else {
            setExitDateTime(dt2)
            exitTimeRef.current = dt2
            setValue('exit_time', dt2)
            //}
            clearErrors('exit_time')
            setStartchange(false)
            getPriceDetaitlsToggle(
              partnerUserId,
              BookingEditData?.facility?.id || facilityId || resfacility,
              entryDateTime,
              getValues().exit_time
            )
          }
        } else {
          notify('error', 'End time should not be less then start time!')
          // setIsLoading(true)
        }
      } else {
        setStartchange(false)
        // if (new Date(moment(event).format('YYYY-MM-DD h:mm:ss')) > new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss'))) {
        //   getPriceDetaitlsToggle(partnerUserId, facilityId, new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')), new Date(moment(maxEndDate).format('YYYY-MM-DD h:mm:ss')))
        // } else {
        //   getPriceDetaitlsToggle(partnerUserId, facilityId, event, event)
        // }
        //for remove max date check
        getPriceDetaitlsToggle(partnerUserId, BookingEditData?.facility?.id || facilityId || resfacility, event, event)
      }
    }
    fetchValidationCodes()

  }

  // const handleDepartureTime = (event) => {
  //   if (event == null) {
  //     setDepartureTime()
  //     setValue('departure_time',)
  //   }
  //   // event.getHours()
  //   // if (event && event.getHours()>0) {
  //   if (event) {
  //     // let departure_time_Date = moment(event, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').tz(`${facilityTimeZone ? facilityTimeZone : 'America/Los_Angeles'}`).format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)')
  //     // setDepartureTime(new Date(departure_time_Date))
  //     // setValue('departure_time', new Date(departure_time_Date))
  //     let departure_time_Date = event
  //     if (departure_time_Date) {
  //       let dt1 = startDateTime
  //       let dt2 = new Date(departure_time_Date)
  //       if (dt2 >= dt1) {
  //         setDepartureTime(new Date(departure_time_Date))
  //         setValue('departure_time', new Date(departure_time_Date))
  //       } else {
  //         // event.getHours()>0 ? notify('error', 'Departing should not be less then Start time!'):''
  //         // setIsLoading(true)
  //       }
  //     }
  //   }
  //   clearErrors('departure_time')
  // }

  // const handleArrivalTime = (event) => {
  //   // setValue('arrival_time', departureTime)
  //   //     setArrivalTime(new Date(departureTime))

  //   if (event == null) {
  //     setArrivalTime(undefined)
  //     setValue('arrival_time', undefined)
  //   } else {
  //     if (event && departureTime) {
  //       // setArrivalTime(new Date(departureTime))
  //       let dt1 = departureTime
  //       let dt2 = new Date(event)
  //       //setArrivalTime(new Date(event))
  //       if (dt2 >= dt1) {
  //         setValue('arrival_time', event)
  //         setArrivalTime(new Date(event))
  //       } else {
  //         setArrivalTime(new Date(departureTime))
  //         // event.getHours() > 0 ? notify('error', 'Arriving should be less then Departing time!') : ''
  //         //setIsLoading(true)
  //       }


  //     } else {

  //       setDepartureTime(new Date(event))
  //       setValue('departure_time', new Date(event))
  //       setArrivalTime(new Date(event))
  //       setValue('arrival_time', new Date(event))
  //       //notify('error', 'Arriving should not be less then Departing time!')
  //     }

  //     clearErrors('arrival_time')
  //   }
  // }

  const handelAirline = (event) => {
    setBookingEditStatus(true)
    const { name, value } = event.target
    setValue(name, value)
    clearErrors(name)
  }


  const handelGarage = (event, facilityList = {}) => {
    setBookingEditStatus(true)
    clearErrors('garage')
    setValue('garage', event.target.value)
    if (event.target.value) {
      let selectedFcility = {}
      if (facility?.length > 0) {
        selectedFcility = facility.filter((v) => v.id == event.target.value)
      } else {
        selectedFcility = facilityList.filter((v) => v.id == event.target.value)
      }
      // EOS-5093 Amenities belong to the facility, clear them before the rate
      // call repopulates the list for the newly selected parking zone.
      if (!BookingEdit) {
        setAmenitiesList(EMPTY_ARRAY)
        setSelectedAmenities(EMPTY_ARRAY)
        selectedAmenitiesRef.current = EMPTY_ARRAY
      }
      if (getConfigPermission(selectedFcility?.[0], 'enable_parking_type')) {
        fetchParkingTypes()
      }
      if (selectedFcility?.[0]?.facility_configuration?.enable_coupon_selection == 1) {
        fetchValidationCodes()
      }
      if (selectedFcility?.[0]?.facility_configuration?.enable_pay_now_selection == 1) {
        setSelectedPaymentType('0')
      } else {
        setSelectedPaymentType('1')
      }

      let partnerFacilityId = event.target.value
      // let facilityCountry=selectedFcility[0]?.country_code
      //let country=vehicleDetailsList?.country.filter((v)=>v.country_code==facilityCountry)
      // setCountryList(country)
      // setSelectedFacilityData(selectedFcility?.[0])
      facilityRef.current = selectedFcility?.[0]
      setFacilityId(partnerFacilityId)

      let resStartAfterTime = selectedFcility?.[0]?.reservation_start_time ? selectedFcility?.[0]?.reservation_start_time : 0
      let d2 = moment(new Date())
        .tz(`${selectedFcility[0]?.timezone}`)
        .format('YYYY-MM-DDTHH:mm:ss')
      d2 = moment(d2).add(resStartAfterTime, 'minutes').format('YYYY-MM-DDTHH:mm')//set facility
      let dateTime = timeRoundOff(d2)
      if (selectedFcility?.[0]?.facility_configuration?.booking_duration_hours) {
        let minutes = Number(selectedFcility?.[0]?.facility_configuration?.booking_duration_hours)
        let startTime = new Date(dateTime).setMinutes(new Date(dateTime).getMinutes() + minutes)
        let maxBookingTime = moment(startTime).add(1, 'year')
        setStartDateTime(new Date(startTime))
        setMaxStartDateTime(new Date(maxBookingTime))
      } else {
        setStartDateTime(new Date(dateTime))
      }
      //getCheckInGateLane(partnerFacilityId)
      setFacilityName(
        selectedFcility[0]?.full_name
          ? selectedFcility[0]?.full_name
          : facility[0]?.full_name
      )
      const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
      const loginUserData = getuserDatafromLocal?.user
      // let filterState = vehicleDetailsList?.state?.filter((item) => item?.id == loginUserData?.state)
      let filterState = vehicleDetailsList?.state?.filter((item) => item?.id == loginUserData?.state || item?.state_code == loginUserData?.state)
      let countryName = loginUserData?.country ? loginUserData?.country : 'United States'
      reset(formValues => ({ ...formValues, country: countryName, state: filterState?.length > 0 ? filterState?.[0]?.state_code : selectedFcility[0]?.geolocations?.state ? selectedFcility[0]?.geolocations?.state : '', city: loginUserData?.city ? loginUserData?.city : selectedFcility[0]?.geolocations?.city ? selectedFcility[0]?.geolocations?.city : '', }))
      //new set time base on facility time zone
      setFacilityTimeZone(selectedFcility[0]?.timezone)
      setFacilityMaxVehicle((selectedFcility[0]?.facility_configuration?.max_vehicle && selectedFcility[0]?.facility_configuration?.max_vehicle > 0) ? selectedFcility[0]?.facility_configuration?.max_vehicle : (isPermissionExist(accessPermissions, 'Enable Vehicle Limit') && partnerDetails?.max_vehicle && partnerDetails?.max_vehicle > 0) ? partnerDetails?.max_vehicle : '')
      let before_cancel_time = selectedFcility[0]?.facility_configuration?.before_cancel_time ? selectedFcility[0]?.facility_configuration?.before_cancel_time : 60
      setActionTime(before_cancel_time)
      // let resStartAfterTime = selectedFcility?.[0]?.reservation_start_time ? selectedFcility?.[0]?.reservation_start_time : 0
      // let d2 = moment(new Date())
      //   .tz(`${selectedFcility[0]?.timezone}`)
      //   .format('YYYY-MM-DDTHH:mm:ss')
      // d2 = moment(d2).add(resStartAfterTime, 'minutes').format('YYYY-MM-DDTHH:mm')//set facility
      // let dateTime = timeRoundOff(d2)
      let reservationExitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
      reservationExitTime = new Date(reservationExitTime)
      setValue('entry_time', new Date(dateTime))
      setValue('exit_time', reservationExitTime)
      // setbookingStartAfterTime(resStartAfterTime)
      if (selectedFcility[0]?.facility_configuration?.booking_duration_hours) {
        let d2 = moment(new Date()).tz(`${selectedFcility?.[0]?.timezone ? selectedFcility?.[0]?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
        let endmaxtime = timeRoundOff(d2)
        let minutes = Number(selectedFcility[0]?.facility_configuration?.booking_duration_hours)
        let startTime = new Date(endmaxtime).setMinutes(new Date(endmaxtime).getMinutes() + minutes)

        let maxBookingTime = moment(startTime).add(1, 'year')
        setStartDateTime(new Date(startTime))
        setEntryDateTime(new Date(startTime))
        // setMaxEndDate(new Date(moment(new Date(startTime)).add(1, 'months')))

        let reservationExitTime = new Date(startTime).setHours(new Date(startTime).getHours() + 2)
        reservationExitTime = new Date(reservationExitTime)
        setExitDateTime(new Date(reservationExitTime))
        exitTimeRef.current = new Date(reservationExitTime)
        setMaxStartDateTime(new Date(maxBookingTime))
      } else {
        setEntryDateTime(new Date(dateTime))
        // setMaxEndDate(new Date(moment(new Date(dateTime)).add(1, 'months')))
        setStartDateTime(new Date(dateTime))
        let reservationExitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
        setExitDateTime(new Date(reservationExitTime))
        exitTimeRef.current = new Date(reservationExitTime)

      }
      // setArrivalTime()
      // setDepartureTime()
      // setValue('arrival_time',undefined)
      // setValue('departure_time',undefined)



      // setbookingStartAfterTime(0)
      getPriceDetaitlsToggle(
        partnerUserId,
        partnerFacilityId,
        new Date(dateTime),
        reservationExitTime
      )
    } else {
      facilityRef.current = EMPTY_OBJECT
      // setSelectedFacilityData(EMPTY_OBJECT)
      setFacilityId('')
      setFacilityName('')
      getPriceDetaitlsToggle(partnerUserId, '', entryDateTime, exitDateTime)
    }
  }

  let bookingWeb = location.host

  const timeRoundOff = (date) => {
    const start = moment(new Date(date))
    const remainder = 15 - (start.minute() % 15)
    return moment(start).add(remainder, 'minutes').format('YYYY-MM-DDTHH:mm')
  }

  const getVehical = () => {
    dispatch(getVehicleDetailsList()).then((res) => {
      let makeList = res?.make
      makeList?.unshift({
        'id': 'Others',
        'name': 'Others',
        'mst_model': [{
          'id': 'Others',
          'make_id': 'Others',
          'name': 'Others'
        }]
      })

      setVehicleMakeList(makeList)
      setVehicleDetailsList(res)
      setVehicleDetailsState(res)

      if (isLoggedIn()) {
        const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
        if (getuserDatafromLocal?.access_token) {
          const { user: loginUserData } = getuserDatafromLocal
          let countryData = res?.country?.filter((v) => v?.country_code == loginUserData.country || v?.name == loginUserData.country)

          dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
            setVehicleDetailsList(res)
            // setVehicleDetailsState(res)
            loggedInUser(false, res)
          })
        }

      } else {
        loggedInUser(false)
      }

      if (!isPermissionExist(accessPermissions, 'Hide Address Fields')) {
        // setValue('country', res.country[0].name)
      }
      if (getValues()?.state) {
        let filterState = res?.state?.filter((item) => item?.id == getValues()?.state || item?.state_code == getValues()?.state)
        reset(formValues => ({ ...formValues, state: filterState?.length > 0 ? filterState?.[0]?.state_code : getValues()?.state ? getValues()?.state : '' }))
      }

      // if (getValues()?.country) {
      //   let filterCountry = res?.country?.filter((item) => item?.name == getValues()?.country || item?.country_code == getValues()?.country)
      //   reset(formValues => ({ ...formValues,vehicle_country: filterCountry?.length > 0 ? filterCountry?.[0]?.country_code : 'US' }))
      // }

      if (BookingEdit) {
        let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
        setvehicleModelList(model[0]?.mst_model)
      }

    })

  }

  const handleLogout = () => {
    localStorage.removeItem('userData')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('masquerade')

    if (getPartnerDetails()) {
      sessionStorage.setItem('partnerSecret', getConfigDetails()?.CLIENT_SECRET)
      sessionStorage.setItem('partnerData', JSON.stringify(getPartnerDetails()))

    }
    localStorage.removeItem('partnerSecret')
    sessionStorage.removeItem('partnerSecret')
    localStorage.removeItem('partnerData')
    sessionStorage.removeItem('partnerData')
    localStorage.clear()
    localStorage.setItem('isLoggedIn', false)
    navigate(0)

  }



  useEffect(() => {
    // loggedInUser(false)
    getVehical()
    if (partnerDetails && Object.keys(partnerDetails).length > 0) {
      let user_id = partnerDetails?.brand_setting?.user_id
        ? partnerDetails?.brand_setting?.user_id
        : partnerDetails?.partner_details?.brand_setting?.user_id

      let facilityList = partnerDetails?.facilities

      let partnerFacilityId = facilityList?.length == 1 ? facilityList[0]?.id : ''
      if (facilityList?.length == 1) {
        let before_cancel_time = facilityList[0]?.facility_configuration?.before_cancel_time ? facilityList[0]?.facility_configuration?.before_cancel_time : 60
        setActionTime(before_cancel_time)
        reset(formValues => ({ ...formValues, state: (isLoggedIn() && getValues().state) ? getValues().state : facilityList[0]?.geolocations?.state ? facilityList[0]?.geolocations?.state : '', city: (isLoggedIn() && getValues().city) ? getValues().city : facilityList[0]?.geolocations?.city ? facilityList[0]?.geolocations?.city : '', }))
        if (getConfigPermission(facilityList?.[0], 'enable_parking_type')) {
          fetchParkingTypes()
        }
        if (facilityList?.[0]?.facility_configuration?.enable_coupon_selection == 1) {
          fetchValidationCodes()
        }
      }
      setFacilityMaxVehicle((facilityList[0]?.facility_configuration?.max_vehicle && facilityList[0]?.facility_configuration?.max_vehicle > 0) ? facilityList[0]?.facility_configuration?.max_vehicle : (isPermissionExist(accessPermissions, 'Enable Vehicle Limit') && partnerDetails?.max_vehicle && partnerDetails?.max_vehicle > 0) ? partnerDetails?.max_vehicle : '')
      setWebSourceBooking(bookingWeb)
      setFacility(facilityList)
      setFacilityId(partnerFacilityId)
      setPartnerUserId(user_id)
      //setFacilityName(facilityList?.[0]?.full_name)
      // setSelectedFacilityData(facilityList?.length == 1 ? facilityList?.[0] : {})
      facilityRef.current = facilityList?.length == 1 ? facilityList?.[0] : {}
      setFacilityName(facilityList.length == 1 ? facilityList[0]?.full_name : '')
      setFacilityTimeZone(facilityList[0]?.timezone)
      let d2 = moment(new Date()).tz(`${facilityList?.[0]?.timezone ? facilityList?.[0]?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
      let resStartAfterTime = facilityList?.[0]?.reservation_start_time ? facilityList?.[0]?.reservation_start_time : 0
      let endmaxtime = timeRoundOff(d2)
      d2 = moment(d2).add(resStartAfterTime, 'minutes').format('YYYY-MM-DDTHH:mm')//set facility
      let dateTime = timeRoundOff(d2)
      // setbookingStartAfterTime(resStartAfterTime)
      let exitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
      setValue('entry_time', new Date(dateTime))
      setValue('exit_time', new Date(exitTime))
      // if (!isPermissionExist(accessPermissions, 'Hide Address Fields')) {
      //   setValue('country', 'United States')
      // }


      setExitDateTime(new Date(exitTime))
      exitTimeRef.current = new Date(exitTime)
      let start = dateTime
      let end = exitTime

      if (facilityList[0]?.facility_configuration?.booking_duration_hours) {
        let minutes = Number(facilityList[0]?.facility_configuration?.booking_duration_hours)
        let startTime = new Date(endmaxtime).setMinutes(new Date(endmaxtime).getMinutes() + minutes)

        let maxBookingTime = moment(startTime).add(1, 'year')
        setStartDateTime(new Date(startTime))
        setEntryDateTime(new Date(startTime))
        // setMaxEndDate(new Date(moment(new Date(startTime)).add(1, 'months')))

        let reservationExitTime = new Date(startTime).setHours(new Date(startTime).getHours() + 2)
        reservationExitTime = new Date(reservationExitTime)
        setExitDateTime(new Date(reservationExitTime))
        exitTimeRef.current = new Date(reservationExitTime)
        setMaxStartDateTime(new Date(maxBookingTime))
        start = startTime
        end = reservationExitTime
      } else {
        setStartDateTime(new Date(dateTime))
        setEntryDateTime(new Date(dateTime))
        // setMaxEndDate(new Date(moment(new Date(dateTime)).add(1, 'months')))
        let reservationExitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
        setExitDateTime(new Date(reservationExitTime))
        exitTimeRef.current = new Date(reservationExitTime)
        start = dateTime
        end = reservationExitTime
      }

      setValue('garage', partnerFacilityId)
      // getCheckInGateLane(partnerFacilityId)
      if (!BookingEdit && partnerFacilityId && !getConfigPermission(facilityRef?.current, 'enable_parking_type')) {
        getPriceDetaitlsToggle(
          user_id,
          partnerFacilityId,
          new Date(start),
          new Date(end)
        )

      }
    }

    if (isLoggedIn()) {
      setPromoAplicable(true)
      // const facility_id = partnerDetails?.facilities?.[0]?.id
      // if (facility_id) {
      dispatch(getCardDataList())
        .then((res) => {
          if (res?.data) {
            let paymentList = res?.data?.payments
            setCardList(paymentList)
            if (paymentList.length > 0) {
              setCardFormVisible(false)
              if (paymentList.length == 1) {
                setPaymentProfileId(paymentList[0]?.token ? paymentList[0]?.token : '')
                setValue('paymentProfileIDUser', paymentList[0]?.token ? paymentList[0]?.token : '')
              } else {
                let selectedCard = res?.data?.payments?.filter((card) => card?.is_default == '1')
                if (selectedCard?.length > 0) {
                  setPaymentProfileId(selectedCard[0]?.token ? selectedCard[0]?.token : '')
                  setValue('paymentProfileIDUser', selectedCard[0]?.token ? selectedCard[0]?.token : '')
                }
              }
            } else {
              setCardFormVisible(true)
            }
            // setIsLoading(false)
          } else {
            setCardFormVisible(true)
          }
        })
        .catch(() => {
          setCardFormVisible(true)
          // setIsLoading(false)
        })
      // }
      //vehical
      dispatch(getVehicleDataList()).then((res) => {

        let result = res?.data
        setVehicleList(result)
        if (result?.length > 0) {
          setIsVehicleTableVisible(false)
          if (result?.length == 1) {
            setVehicalId(result[0].id)
            setValue('vehicle', result[0].id)
            // setValue('license_plate', result?.[0]?.license_plate_number)
          }
        } else {
          setIsVehicleTableVisible(true)
        }

      })

      if (vehicleList?.length > 0 && vehicleList[0]?.license_plate != '') {
        setIsVehicleTableVisible(false)
      } else {
        setIsVehicleTableVisible(true)
      }
    } else {
      setCardFormVisible(true)
      setIsVehicleTableVisible(true)
    }

    // This is for From Value reset for Edit Booking 
    if (BookingEdit && BookingEditData && Object.keys(BookingEditData)?.length > 0 && BookingEditData?.facility?.id != '') {
      setPromoAplicable(true)
      let facilityRes = BookingEditData?.facility
      facilityRes = { ...facilityRes, facility_configuration: BookingEditData?.facility_configurations }

      // setSelectedFacilityData(facilityRes)
      facilityRef.current = facilityRes
      // for on behalf
      setOnBehalfButtonShow(BookingEditData?.on_behalf ? true : false)
      // end
      if (isLoggedIn() && !BookingEditData?.on_behalf) {
        if (Number(BookingEditData?.user_id) !== Number(loggedInUserData()?.user?.id)) {
          handleLogout()
        }
      }

      const d2 = moment(new Date()).tz(`${BookingEditData?.facility?.timezone ? BookingEditData?.facility?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
      let bookHour = moment(new Date(BookingEditData?.start_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
      let bookendTime = moment(new Date(BookingEditData?.end_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
      let bookendDate = moment(new Date(bookendTime)).format('YYYY-MM-DD')
      let currentDate = moment(new Date(d2)).format('YYYY-MM-DD')


      let diff = Math.floor((new Date(bookHour).getTime() - new Date(d2).getTime()) / 60000)
      setDiff(diff)
      // if (BookingEditData?.is_ticket == '1' || d2 > bookHour || BookingEditData?.cancelled) {
      if (BookingEditData?.is_ticket == '1' || d2 > bookHour || (BookingEditData?.cancelled_at !== null && BookingEditData?.cancelled_at !== '')) {

        setIsCheckinStatus('1')
        // navigate(`/${'roc'}/sms/${BookingEditData.id}`)
      } else {
        setIsCheckinStatus(BookingEditData?.is_ticket)
      }
      // if (BookingEditData?.is_ticket == '2'|| BookingEditData?.cancelled ) {
      if (BookingEditData?.is_ticket == '2' || (BookingEditData?.cancelled_at !== null && BookingEditData?.cancelled_at !== '')) {

        setIsCheckOutStatus(true)
        navigate(`/${partner}/sms/${BookingEditData.id}`)
      } else if (currentDate > bookendDate) {
        setIsCheckOutStatus(true)
      }

      setIsLoading(false)
      setPaymentDisable(true)

      if (BookingEditData?.facility_configurations?.is_process_fee_charged == '1') {
        setPaymentDisable(false)
      }

      /**
     * @author Vicky Tyagi 
     * @desc Set length plus minus value for edit booking 2 instead of 3.
     * @changeRequest  santosh kushwaha sir 
    */

      setLengthPlusMinus('2')
      // setLengthPlusMinus('3')
      // let priceRes = {
      //   parking_amount: '0',
      //   tax_fee: '0',
      //   processing_fee: '0',
      //   payable_amount: '0',
      // }
      setPriceDetails(BookingEditData)
      const userData = BookingEditData?.user
      const flightData = (Object.keys(BookingEditData?.flight_details ?? {})?.length > 1) ? BookingEditData?.flight_details : {}
      // const vehicelData = (Object.keys(BookingEditData?.vehical_details)?.length > 1) ? BookingEditData?.vehical_details : {}
      //const vehicelData = BookingEditData?.vehical_details?.length > 1 ? BookingEditData?.vehical_details : {}
      const vehicelData = BookingEditData?.vehical_details      // for the modal data
      vehicelData?.country ? getStateByVehicleCountry(vehicelData?.country, BookingEditData?.user) : null
      userData?.country ? getStateByCountry(userData?.country, BookingEditData?.user) : null

      // flight_details
      reset(formValues => ({
        ...formValues,
        garage: BookingEditData?.facility?.id ? BookingEditData?.facility?.id : '',
        first_name: userData.first_name ? userData?.first_name : '',
        last_name: userData?.last_name ? userData?.last_name : '',
        email: userData?.email ? userData?.email : '',
        phone: userData?.phone_number ? userData?.phone_number : '',
        license_plate: (BookingEditData?.license_plate) ? BookingEditData?.license_plate : '',
        company_name: userData?.company_name ? userData?.company_name : '',
        address: userData?.address ? userData?.address : '',
        address2: userData?.address2 ? userData?.address : '',
        city: userData?.city ? userData?.city : '',
        country: userData?.country ? userData?.country : '',
        state: userData?.state ? userData?.state : '',
        pincode: userData?.pincode ? userData?.pincode : '',
        arrival_flight_no: (flightData?.arrival_flight_no) ? flightData?.arrival_flight_no : '',
        arrival_airline_name: (flightData?.arrival_airline_name) ? flightData?.arrival_airline_name : '',
        departure_flight_no: (flightData?.departure_flight_no) ? flightData?.departure_flight_no : '',
        departure_airline_name: (flightData?.departure_airline_name) ? flightData?.departure_airline_name : '',
        // arrival_time: (flightData?.arrival_time) ? new Date(flightData?.arrival_time) : '',
        // departure_time: (flightData?.departure_time) ? new Date(flightData?.departure_time) : '',
        // make: (vehicelData?.make) ? vehicelData?.make : '',
        // model: (vehicelData?.model) ? vehicelData?.model : '',
        // color: (vehicelData?.color) ? vehicelData?.color : '',
        make: (vehicelData?.make_id) ? vehicelData?.make_id : vehicelData?.make,
        model: (vehicelData?.model_id) ? vehicelData?.model_id : vehicelData?.model,
        color: (vehicelData?.color_id) ? vehicelData?.color_id : vehicelData?.color,
        vehicle_country: vehicelData?.country ? vehicelData?.country : 'US',
        state_id: (vehicelData?.state_id) ? vehicelData?.state_id : '',
        vehicle: BookingEditData?.vehicle_id && BookingEditData?.vehicle_id != '0' ? BookingEditData?.vehicle_id : '',
        entry_time: (BookingEditData?.start_timestamp && BookingEditData?.start_timestamp != '0000-00-00 00:00:00') ? new Date(BookingEditData?.start_timestamp) : '',
        exit_time: (BookingEditData?.end_timestamp && BookingEditData?.end_timestamp != '0000-00-00 00:00:00') ? new Date(BookingEditData?.end_timestamp) : ''

      }))
      // setMobile(userData?.phone_number)
      setStateName(vehicelData?.state_name)
      setVehicalId(BookingEditData?.vehicle_id)
      // setPromoCodeApply(BookingEditData?.discount > 0 ? true: false)
      // setDiscount(BookingEditData?.discount) 
      setPromoCodeApply(BookingEditData?.discount > 0 ? true : promoCodeApply)
      setDiscount(BookingEditData?.discount > 0 ? BookingEditData?.discount : discount)
      setIsPromoDisabled(BookingEditData?.discount > 0 ? true : false)
      setIsVehicleOverSize(BookingEditData?.is_vehicle_oversize == '1' ? true : false)
      // here
      setEntryDateTime((BookingEditData?.start_timestamp && BookingEditData?.start_timestamp != '0000-00-00 00:00:00') ? new Date(moment(BookingEditData?.start_timestamp).format('YYYY/MM/DD HH:mm:ss')) : '')
      // setMaxEndDate((BookingEditData?.start_timestamp && BookingEditData?.start_timestamp != '0000-00-00 00:00:00') ? new Date(moment(new Date(BookingEditData?.start_timestamp)).add(1, 'months')) : new Date(moment(new Date().add(1, 'months'))))

      setExitDateTime((BookingEditData?.end_timestamp && BookingEditData?.end_timestamp != '0000-00-00 00:00:00') ? new Date(moment(BookingEditData?.end_timestamp).format('YYYY/MM/DD HH:mm:ss')) : '')
      exitTimeRef.current = (BookingEditData?.end_timestamp && BookingEditData?.end_timestamp != '0000-00-00 00:00:00') ? new Date(moment(BookingEditData?.end_timestamp).format('YYYY/MM/DD HH:mm:ss')) : ''


      // setDepartureTime((flightData?.departure_time && flightData?.departure_time != '0000-00-00 00:00:00') ? new Date(flightData?.departure_time) : undefined)
      // setArrivalTime((flightData?.arrival_time && flightData?.arrival_time != '0000-00-00 00:00:00') ? new Date(flightData?.arrival_time) : undefined)
      setTotalHoursLength(BookingEditData?.length)
      totalHoursLengthRef.current = BookingEditData?.length
      // for the vehicle 
      // setVehicleMakeID((vehicelData?.make) ? vehicelData?.make : '')
      setIsLicensePlate((vehicelData?.is_default == '1') ? !isLicensePlate : false)
      setMobile(userData?.phone_number ? userData?.phone_number : '')
      setDefaultPhone(userData?.phone_number ? userData?.phone_number : '')
      setFacilityId(BookingEditData?.facility?.id)


    }
    if (!isLoggedIn()) {
      reset(formValues => ({ ...formValues, vehicle_country: 'US' })) // AS PER PIMS-13126 SHOW US BY DEFAULT IN VEHICLE COUNTRY DROPDOWN
    }
    // value Reset Code Over 
    register('paymentToken')
    register('termCondition')
    register('userConsent')
  }, [EMPTY_ARRAY, partnerDetails])

  const formatAMPM = (date) => {
    var hours = new Date(date).getHours()
    var minutes = new Date(date).getMinutes()
    var ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  const loggedInUser = (on_behalf, vehicaldata = '') => {
    const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))

    if (getuserDatafromLocal?.access_token) {
      const { user: loginUserData } = getuserDatafromLocal
      let stateList = vehicleDetailsList.length > 0 ? vehicleDetailsList : vehicaldata
      const filterState = stateList?.state?.filter((item) => item?.state_code == loginUserData?.state || item?.id == loginUserData?.state)

      // const filterState = vehicleDetailsList?.state?.filter((item) => item?.state_code == loginUserData?.state)
      if (loginUserData && Object.values(loginUserData)?.length > 0) {
        // setCardFormVisible(false)


        const defaultFormValues = {
          first_name: (on_behalf) ? '' : loginUserData.first_name || '',
          last_name: (on_behalf) ? '' : loginUserData.last_name || '',
          email: (on_behalf) ? '' : loginUserData.email || '',
          phone: (on_behalf) ? '' : loginUserData.phone_number || '',
          company_name: (on_behalf) ? '' : loginUserData.company_name || '',
          address: (on_behalf) ? '' : loginUserData.address || '',
          address2: (on_behalf) ? '' : loginUserData.address2 || '',
          city: (on_behalf) ? '' : loginUserData.city || '',
          country: (on_behalf) ? '' : loginUserData.country || '',
          state: (on_behalf) ? '' : filterState?.[0]?.state_code ?? '',
          pincode: (on_behalf) ? '' : loginUserData.pincode || ''
        }

        reset((formValues) => ({ ...formValues, ...defaultFormValues }))
        setMobile((on_behalf) ? '' : loginUserData.phone_number || '')
        setDefaultPhone(loginUserData?.phone_number || '')
        setOnBehalf(on_behalf)
        setCreaterId(loginUserData?.id)
      }
    } else {
      setCardFormVisible(true)
      BookingEdit ? null : setValue('country', 'United States')
    }
  }

  const newBooking = () => {
    resetFormValue()
    setMobile('')
    setCardExpiry('')
    setCardNumber('')
    setIsPromo(false)
    setPage(1)
    setBookingStatus(false)
    setBookingError(false)
    setTicketDetails(EMPTY_OBJECT)
    setSelectedAmenities(EMPTY_ARRAY)
    selectedAmenitiesRef.current = EMPTY_ARRAY
    // setValue('entry_time', new Date(entryDateTime))
    // setValue('exit_time', new Date(exitDateTime))
    // for set current time according to timezone 

    let selectedFcility = facility.filter((v) => v.id == facilityId)
    let d2 = moment(new Date()).tz(`${facilityTimeZone ? facilityTimeZone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
    let resStartAfterTime = selectedFcility?.[0]?.reservation_start_time ? selectedFcility?.[0]?.reservation_start_time : 0
    d2 = moment(d2).add(resStartAfterTime, 'minutes').format('YYYY-MM-DDTHH:mm')//set facility
    let dateTime = timeRoundOff(d2)
    let exitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
    setValue('entry_time', new Date(dateTime))
    setValue('exit_time', new Date(exitTime))
    setEntryDateTime(dateTime)
    setExitDateTime(exitTime)
    exitTimeRef.current = exitTime
    startTimeRef.current = dateTime

    // setMaxEndDate(new Date(moment(new Date(dateTime)).add(1, 'months')))

    if (selectedFcility[0]?.facility_configuration?.booking_duration_hours) {

      let d2 = moment(new Date()).tz(`${selectedFcility?.[0]?.timezone ? selectedFcility?.[0]?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
      let endmaxtime = timeRoundOff(d2)
      let minutes = Number(selectedFcility[0]?.facility_configuration?.booking_duration_hours)
      let startTime = new Date(endmaxtime).setMinutes(new Date(endmaxtime).getMinutes() + minutes)

      let maxBookingTime = moment(startTime).add(1, 'year')
      setStartDateTime(new Date(startTime))
      setEntryDateTime(new Date(startTime))
      let reservationExitTime = new Date(startTime).setHours(new Date(startTime).getHours() + 2)
      reservationExitTime = new Date(reservationExitTime)
      setExitDateTime(new Date(reservationExitTime))
      setMaxStartDateTime(new Date(maxBookingTime))

      exitTimeRef.current = new Date(reservationExitTime)
      startTimeRef.current = new Date(startTime)

    } else {
      // setStartDateTime(new Date(dateTime))
      setEntryDateTime(new Date(dateTime))
      setStartDateTime(new Date(dateTime))
      let reservationExitTime = new Date(dateTime).setHours(new Date(dateTime).getHours() + 2)
      setExitDateTime(new Date(reservationExitTime))

      exitTimeRef.current = new Date(reservationExitTime)
      startTimeRef.current = new Date(dateTime)
    }

    setIsLoading(false)
    // login details
    loggedInUser(false)
    // isLoggedIn() ? setCardFormVisible(false) : setCardFormVisible(true)
    if (isLoggedIn()) {
      // const facility_id = partnerDetails?.facilities?.[0]?.id
      // if (facility_id) {
      dispatch(getCardDataList())
        .then((res) => {
          if (res?.data) {
            let paymentList = res?.data?.payments
            setCardList(paymentList)
            if (paymentList.length > 0) {
              setCardFormVisible(false)
              if (paymentList.length == 1) {
                setPaymentProfileId(paymentList[0]?.token ? paymentList[0]?.token : '')
                setValue('paymentProfileIDUser', paymentList[0]?.token ? paymentList[0]?.token : '')
              } else {
                let selectedCard = res?.data?.payments?.filter((card) => card?.is_default == '1')
                if (selectedCard?.length > 0) {
                  setPaymentProfileId(selectedCard[0]?.token ? selectedCard[0]?.token : '')
                  setValue('paymentProfileIDUser', selectedCard[0]?.token ? selectedCard[0]?.token : '')
                }
              }
            } else {
              setCardFormVisible(true)
            }

            // setIsLoading(false)
          }
        })
        .catch(() => {
          // setIsLoading(false)
        })
      // }
      //vehical
      dispatch(getVehicleDataList()).then((res) => {
        let result = res?.data
        setVehicleList(result)

        if (result?.length > 0) {
          setIsVehicleTableVisible(false)
          if (result?.length == 1) {
            setVehicalId(result[0].id)
            setValue('vehicle', result[0].id)
            // setValue('license_plate', result?.[0]?.license_plate_number)
          }
        } else {
          setIsVehicleTableVisible(true)
        }


      })

      if (vehicleList?.length > 0 && vehicleList[0]?.license_plate != '') {
        setIsVehicleTableVisible(false)
      } else {
        setIsVehicleTableVisible(true)
      }
      //set country state    
      if (isLoggedIn()) {
        const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
        if (getuserDatafromLocal?.access_token) {
          const { user: loginUserData } = getuserDatafromLocal
          loginUserData.country ? getStateByCountry(loginUserData.country, loginUserData) : null

        }
      }

    } else {
      setCardFormVisible(true)
      setIsVehicleTableVisible(true)
    }
    getPriceDetaitlsToggle(
      partnerUserId,
      BookingEditData?.facility?.id || facilityId || resfacility,
      startTimeRef?.current,
      exitTimeRef?.current
    )
    if (BookingEdit) {
      let partOrRMSlug = partnerDetails?.slug || partnerDetails?.partner_slug
      navigate(`/${partOrRMSlug}/book-reservation`)
      // navigate(0)
    }
  }




  const nextPage = () => {
    const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
    const { user: loginData } = getuserDatafromLocal ?? {}
    //trigger('garage')
    divRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    window.scrollTo(0, 0)
    let formValue = trimObjectValues(getValues())
    // Object.keys(formValue).filter(key => {
    //   if (formValue[key] == undefined) {
    //     setValue(key, undefined)
    //   }
    // }
    // )
    let garageDetails = facility?.filter((v) => v.id == formValue?.garage)
    let currentTimeZone = garageDetails[0]?.timezone ? garageDetails[0]?.timezone : defaultTimeZone
    let currentDate = changeTimeZone(new Date(), currentTimeZone)
    if (props.BookingEdit) {
      currentDate = new Date(entryDateTime)
    }

    if (
      page == 1 &&
      formValue?.garage &&
      formValue?.entry_time &&
      formValue?.exit_time &&
      Number(totalHoursLength) >= 1 &&
      ((isPermissionExist(accessPermissions, 'Display Flight Details') &&
        formValue?.departure_flight_no &&
        formValue?.departure_airline_name &&
        formValue?.arrival_flight_no &&
        formValue?.arrival_airline_name
        // departureTime && arrivalTime
      ) || !isPermissionExist(accessPermissions, 'Display Flight Details'))
    ) {
      if (exitDateTime >= entryDateTime && entryDateTime >= currentDate) {
        if (departureTime) {
          if (new Date(departureTime) >= new Date(entryDateTime) && new Date(departureTime) <= new Date(exitDateTime)) {
            if (arrivalTime) {
              if (new Date(arrivalTime) > new Date(departureTime) && new Date(arrivalTime) <= new Date(exitDateTime)) {
                setPage(page + 1)
                // setShowDateError(false)
              } else {
                notify('error', 'Arrival time should be greater than departing and less or equal to end time!')
              }


            } else {
              setPage(page + 1)
              // setShowDateError(false)
            }

          } else {
            notify('error', 'departing time should be less than end time!')
          }

        } else {
          setPage(page + 1)

        }
      } else {
        notify('error', 'Please enter valid start and end date!')
      }
    } else if (departureTime == null || departureTime == '' || arrivalTime == null || arrivalTime == '') {
      // setShowDateError(true)
    }
    if (page == 1 && Number(totalHoursLength) < 1) {
      notify('error', 'Booking is available for minimum 1 hour!')
    }


    if (
      page == 2 &&
      formValue?.first_name &&
      formValue?.last_name &&
      formValue?.email &&
      formValue?.phone && validatePhone(formValue?.phone) &&
      (isPermissionExist(accessPermissions, 'Hide Address Fields') || (formValue?.address &&
        formValue?.city &&
        formValue?.state &&
        formValue?.country
        && formValue?.pincode && formValue?.pincode.length > 4 && formValue?.pincode.length < 7
      )) &&
      !('email' in errors) &&
      !('phone' in errors) &&
      (isPermissionExist(accessPermissions, 'Hide Address Fields') || (!('address' in errors) &&
        !('city' in errors) &&
        !('country' in errors) &&
        !('pincode' in errors)))
    ) {
      // if (!isPermissionExist(accessPermissions, 'Hide Address Fields')) {
      //   setValue('country', 'United States')
      // }

      if ((isOnBehalfExist) && (formValue?.email == loginData?.email || formValue?.phone == loginData?.phone_number)) {
        notify('error', 'You cannot use the same email and phone for an on behalf reservation!')
        return false
      }

      // clearErrors('vehicle')
      if (formValue?.email.match(/^[A-Z0-9._%+-]+@[A-Z0-9-]+(?!.*?[.]{2})[A-Z0-9.-]+\.[A-Z]{2,}$/i) && formValue?.phone.length == 10) {
        setPage(page + 1)
      }
    } else if (formValue?.phone && !validatePhone(formValue?.phone)) {
      setError('phone', 'Please enter a valid phone number')
    }

    if (
      page == 3
    ) {

      clearErrors('vehicle')
      if ((formValue?.vehicle) ||
        (formValue?.license_plate && (formValue?.license_plate?.length >= 1 && formValue?.license_plate?.length <= 10)
          && (isPermissionExist(accessPermissions, 'Get Vehicle Type') ? (formValue?.vehicle_type && formValue?.vehicle_type != '') : true)
          && (isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') || !isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') &&
            (isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') ? formValue?.make && formValue?.make != '' : true)
            && (isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') ? formValue?.model && formValue?.model != '' : true)
            && (isPermissionExist(accessPermissions, 'Get Vehicle Color') ? formValue?.color && formValue?.color != '' : true)
            && (isPermissionExist(accessPermissions, 'Get Vehicle State') ? formValue?.state_id && formValue?.state_id != '' : true)
          ))) {
        if (verifyPrepay == '1' && page == 3 && walletButtonShow) {
          // setVerifyPrepay('0')
          const data = getValues()
          onSubmit(data, 'post')
          // setPage(page + 1)
          // setVerifyPrepay('0')
        } else {
          setPage(page + 1)
        }
        // if ((formValue?.vehicle) || (formValue?.license_plate && (formValue?.make) && (formValue?.model) && formValue?.color && formValue?.state_id)) {
        clearErrors('card_number')
        clearErrors('card_expiry')
      }
    }
  }



  const prePage = () => {
    if (walletButtonShow) {
      setVerifyPrepay('1')
    }
    setPage(page - 1)
    clearErrors()
  }

  const handleCupanchange = (e) => {
    const { value } = e.target
    if (promoCodeApply && value == '') {
      removePromocode()
    }
  }

  const handelchangeInput = (e) => {
    // const { name } = e.target
    // if(name=='departure_flight_no'){
    //   setValue('departure_flight_no', e.target.value)
    // }
    setValue('setinput', e.target.value)

    setBookingEditStatus(true)
  }




  // Datacap / Heartland iframe: it keeps the callback it got when it loaded, so it calls the latest submit
  const latestIframeSubmit = useRef(noop)

  // Stripe: the bank asked for 3DS -> authenticate, then submit the booking once more with pi_ (once).
  // Returns true when Stripe took over the response.
  const runStripe3dsIfRequired = (response, sentPayload) => {
    const stripeAction = isStripeGateway(facilityRef?.current) ? getStripeRequiredAction(response, sentPayload) : null
    if (!stripeAction) return false
    completeStripeRequiredAction(stripeAction, facilityRef?.current).then(({ error, token }) => {
      setIsLoading(false)
      setIsSubmit(false)
      if (error) {
        notify('error', getStripeErrorMessage(error))
        return
      }
      setValue('paymentToken', token)
      // After the loader is off
      setTimeout(() => latestIframeSubmit.current(), 50)
    })
    return true
  }

  // Fiserv: the submit of the latest render, run after the card iframe has answered
  const latestOnSubmit = useRef(null)
  const onSubmit = async (data, prepay = '', terms_condition_error = false, afterCardIframe = false) => {
    if (!afterCardIframe && facilityRef?.current?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.FISERV) {
      await waitForCardTokenizer()
      return latestOnSubmit.current(data, prepay, terms_condition_error, true)
    }
    if ((page == 4 && cardExpiryMessage == '') || (walletButtonShow && prepay == 'post')) {
      if (
        data?.garage &&
        data?.entry_time &&
        data?.exit_time &&
        data?.first_name &&
        data?.email &&
        data?.phone &&
        ((termCondition || data?.termCondition) || (walletButtonShow && prepay == 'post')) && (!iframeErrorMsg || iframeErrorMsg == '')
      ) {
        setIsLoading(true)
        setIsSubmit(true)

        // ===== reCAPTCHA v3: Generate Token for Reservation =====
        const captchaToken = await getToken('reservation_payment')
        if (!captchaToken) {
          notify('error', 'Security verification failed. Please try again.')
          setIsLoading(false)
          setIsSubmit(false)
          return
        }
        // ===== End reCAPTCHA =====
        let nonce
        if (
          isCardFormVisible &&
          ((data?.card_name != '' && data?.card_number != '' &&
            data?.card_expiry != '' && data?.ccv != '' &&
            cardNumber != '' && cardExpiry != '') || (cardToken && (cardToken?.message || cardToken?.token)))
        ) {
          if (facilityRef?.current?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.FISERV && cardToken && (cardToken?.message || cardToken?.token)) {
            // For Fiserv, use cardToken to create payment data
            let card = {
              name_on_card: data?.card_name ? data?.card_name : '',
              card_number: (cardToken?.message || cardToken?.token) || '',
              expiration_date: formatYearMonthExpiry(cardToken?.expiry),
              security_code: '',
            }
            if (cardToken?.zip_code || data?.pincode_card) {
              card.zip_code = cardToken?.zip_code || data?.pincode_card
            }
            nonce = EncryptionHandler(card)

          } else {
            let cardData = {
              name_on_card: data?.card_name ? data?.card_name : '',
              card_number: data?.card_number
                ? data?.card_number?.replace(/\D/g, '')
                : '',
              expiration_date: data?.card_expiry
                ? data?.card_expiry?.replace(/\D/g, '')
                : '',
              security_code: data?.ccv ? data?.ccv : '',
            }
            if (data?.pincode_card) {
              cardData.zip_code = data?.pincode_card || ''
            }
            nonce = EncryptionHandler(cardData)
          }
        } else {
          nonce = ''
        }

        let garageDetails = facility?.filter((v) => v.id == data?.garage)
        const description =
          'Reservation for ' +
          garageDetails[0]?.full_name +
          ' Garage begining at ' +
          dateTimeFormatefunction(entryDateTime) +
          ' lasting for ' +
          formatDecimal(totalHoursLength) +
          ''
        let discount_amount = discount ? formatDecimal(discount) : formatDecimal(0)
        // let discount_amount = 0
        // let totalAmount = priceDetails.payable_amount
        //   ? parseFloat(
        //     parseFloat(priceDetails.payable_amount) - discount_amount
        //   ).toFixed(2)
        //   : '0.00'
        let totalAmount = priceDetails.payable_amount
          ? formatDecimal(priceDetails.payable_amount)
          : formatDecimal(0)
        let tax_fee = priceDetails?.tax_fee
          ? formatDecimal(priceDetails?.tax_fee)
          : formatDecimal(0)
        let processing_fee = priceDetails?.processing_fee
          ? formatDecimal(priceDetails?.processing_fee)
          : formatDecimal(0)
        let additional_fee = priceDetails?.additional_fee
          ? formatDecimal(priceDetails?.additional_fee)
          : formatDecimal(0)
        let surcharge_fee = priceDetails?.surcharge_fee
          ? formatDecimal(priceDetails?.surcharge_fee)
          : formatDecimal(0)
        let parking_amount = priceDetails?.parking_amount
          ? formatDecimal(priceDetails?.parking_amount)
          : formatDecimal(0)
        let arrival_airlineDetails = airline?.length > 0 ? airline?.filter((v) => v?.name?.toLowerCase() == data?.arrival_airline_name?.toLowerCase()) : []
        let departing_airlineDetails = airline?.length > 0 ? airline?.filter((v) => v?.name?.toLowerCase() == data?.departure_airline_name?.toLowerCase()) : []

        let airLinePayload = {
          'arrival_airline_name': arrival_airlineDetails?.[0]?.id ? '' : data?.arrival_airline_name ? data?.arrival_airline_name : '',
          'arrival_flight_no': data?.arrival_flight_no ? data?.arrival_flight_no : '',
          // 'arrival_time': arrivalTime ? moment(new Date(arrivalTime)).format('YYYY-MM-DD HH:mm:ss') : '',//dateTimeFormatefunction(arrivalTime) ,
          'departure_airline_name': departing_airlineDetails?.[0]?.id ? '' : data?.departure_airline_name ? data?.departure_airline_name : '',
          'departure_flight_no': data?.departure_flight_no ? data?.departure_flight_no : '',
          'arrival_id': arrival_airlineDetails?.[0]?.id,
          'departure_id': departing_airlineDetails?.[0]?.id,
          // 'departure_time': departureTime ? moment(new Date(departureTime)).format('YYYY-MM-DD HH:mm:ss') : ''//dateTimeFormatefunction(departureTime) 
        }

        let username = `${data?.first_name + ' ' + data?.last_name}`
        let payloadRequest = {
          is_vehicle_oversize: isPermissionExist(accessPermissions, 'Enable oversize-fee - Reservation') && isVehicleOversize ? '1' : '0',
          flight_details: airLinePayload,
          warning_on_reservation: '0',
          is_opt_out: '',
          length: formatDecimal(totalHoursLength),
          length_of_stay: formatDecimal(totalHoursLength),
          processing_fee: processing_fee ? processing_fee : '0',
          user_consent: (userConsent || data?.userConsent) ? '1' : '0',
          tax_fee: tax_fee ? tax_fee : '0',
          vehicle_id: isLoggedIn() && !isVehicleTableVisible ? vehicalId : '',
          // vehicle_id: isLoggedIn() && !isVehicleTableVisible ? vehicalId : BookingEdit ? vehicalId :'',

          total: totalAmount ? totalAmount : 0,
          arrival: dateTimeFormatefunction(entryDateTime),
          is_card_req: '1',
          facility_id: data?.garage,
          warning_on_reservation_msg_email: '',
          use_bonus: '0',
          description: description,
          warning_on_reservation_msg: '',
          companyName: data?.company_name,
          //  user_id: partnerDetails.brand_setting.user_id,
          // user_id: partnerDetails?.brand_setting?.user_id ? partnerDetails?.brand_setting?.user_id : partnerDetails?.partner_details?.brand_setting?.user_id,
          user_id: isLoggedIn() ? loggedInUserData()?.user?.id : '',

          payment_profile_id:
            isLoggedIn() && !isCardFormVisible ? paymentProfileId : '',
          coupon_threshold_price: '0',

          card_description: (userConsent || data?.userConsent) ? data?.card_description : '',
          term_condition: (termCondition || data?.termCondition) ? '1' : '0',
          email: data?.email,
          phone: data?.phone,
          name: username,
          country: data?.country,
          // nonce: nonce,
          payment_type: 'credit_card',
          savePaymentMethod: '',
          promocode: promocode || getValues('promo_code'),
          is_promocode_redeemed: promoCodeApply,
          redeemed_amount: discount_amount,
          booking_source: webSourceBooking,
          license_plate: data?.license_plate ? data?.license_plate : '',
          is_license_plate: isLicensePlate ? 1 : 0,
          address: data?.address,
          address2: data?.address2,
          city: data?.city,
          state: data?.state,
          pincode: data?.pincode,
          // make: vehicleMakeID == 'Others' ? data?.other_vehicle_make : vehicleMakeID,
          // model: vehicleMakeID == 'Others' ? data?.other_vehicle_model : data?.model == 'Others' ? data?.other_vehicle_model : data?.model,
          make: vehicleMakeIDData ? '' : data?.make ? data?.make : '',
          make_id: vehicleMakeIDData,
          model: vehicleModelIDData ? '' : data?.model ? data?.model : '',
          model_id: vehicleModelIDData,
          color: vehicleColorDData && vehicleColorDData != 0 ? '' : data?.color,
          color_id: vehicleColorDData ? vehicleColorDData : data?.color,
          vehicle_country: vehicalId ? '' : data?.vehicle_country ? data?.vehicle_country : 'US',
          state_id: vehicalId ? '' : data?.state_id,
          state_name: stateName ? stateName : '',
          anon: isLoggedIn() ? false : true,// guest case = true, register user=> false
          reservation_mode: BookingEdit ? lengthPlusMinus == '1' ? '2' : lengthPlusMinus == '0' ? '1' : '3' : '0',// new reservation= 0, extend=2, reduce =>1, other update =3
          device_type: 'web',
          is_admin: '0',
          // for the vehicle type
          vehicle_type: data?.vehicle_type ?? '',
          vehicle_type_id: vehicleTypeData ?? '',
          // EOS-5093 Amenities. Set on the shared payload so it reaches both
          // pave-user-reservation-guest and pave-user-reservation-update, and
          // always sent so an update can also clear every selected amenity.
          user_amenities: formatUserAmenitiesPayload(selectedAmenities),
          recaptcha_token: captchaToken,
        }

        if (partnerDetails?.slug || partnerDetails?.partner_slug) {
          payloadRequest.partner_rm_slug = partnerDetails?.slug || partnerDetails?.partner_slug
        }

        if (additional_fee && additional_fee != '') {
          payloadRequest.additional_fee = additional_fee
        }
        if (surcharge_fee && surcharge_fee != '') {
          payloadRequest.surcharge_fee = surcharge_fee
        }
        if (parking_amount && parking_amount != '') {
          payloadRequest.parking_amount = parking_amount
        }
        if (walletButtonShow) {
          payloadRequest.verify_prepay = (prepay == 'post' || verifyPrepay == '1') ? '1' : '0'
        }
        if (data.walletPay) {
          if (isIOSDevice) {
            payloadRequest.walletPay = data.walletPay
          } else {
            payloadRequest.walletPay = JSON.parse(data.walletPay)
          }
          payloadRequest.paymentMethods = data.paymentMethods
        }
        if (verifyPrepay == '0' || !walletButtonShow) {
          payloadRequest.nonce = nonce
        }
        let currentTimeZone = garageDetails[0]?.timezone
          ? garageDetails[0]?.timezone
          : defaultTimeZone
        let currentDate = changeTimeZone(new Date(), currentTimeZone)
        if (props.BookingEdit) {
          currentDate = new Date(entryDateTime)
        }

        if ((promocodeRes?.is_tax_applicable && promocodeRes?.is_tax_applicable != '') || (priceDetails?.is_tax_applicable && priceDetails?.is_tax_applicable != '')) {
          payloadRequest.is_tax_applicable = promocodeRes?.is_tax_applicable || priceDetails?.is_tax_applicable
        }

        if (selectedPaymentType && facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1) {
          payloadRequest.pay_now = selectedPaymentType
        }
        // is onhalf exist then these key added
        if (isOnBehalfExist) {
          payloadRequest = { ...payloadRequest, 'creater_id': creater_id, 'onBehalf': (isOnBehalfExist) ? 1 : 0 }
        }
        if (data?.paymentToken && !data?.walletPay && (cardList?.length < 1 || isCardFormVisible)) {
          payloadRequest.paymentToken = data?.paymentToken
          // Name on the card and billing zip from our fields (the backend's Stripe charge reads name_on_card / zip_code)
          payloadRequest.name_on_card = data?.card_name ? data?.card_name : ''
          payloadRequest.zip_code = data?.pincode_card ? data?.pincode_card : ''
          payloadRequest.nonce = ''
          if (isStripeGateway(facilityRef?.current)) {
            payloadRequest = { ...payloadRequest, ...stripePaymentFields(data?.paymentToken) }
          }
        }
        if (exitDateTime >= entryDateTime && entryDateTime >= currentDate) {
          if (BookingEditData?.id) {
            let editPayload = { ...payloadRequest }
            editPayload['reservation_id'] = BookingEditData.id
            editPayload['user_id'] = BookingEditData.user_id
            editPayload['refundFlag'] = priceDetails?.refundFlag ? priceDetails?.refundFlag : ''
            editPayload['refund_amount'] = priceDetails?.refundFlag ? priceDetails?.refund_amount : formatDecimal(0)
            editPayload['is_vehicle_oversize'] = isVehicleOversize ? '1' : '0'
            if (payloadRequest?.promocode && (Number(payloadRequest?.total) === 0)) {
              editPayload['nonce'] = ''
              editPayload['payment_profile_id'] = ''
              editPayload['payment_type'] = ''
            } else if (isLoggedIn() && !isCardFormVisible) {
              let payment = cardList.filter((item) => {
                if (item.payment_profile_id == paymentProfileId) {
                  return item.payment_profile_id == paymentProfileId
                } else if (item.token == paymentProfileId) {
                  return item.token == paymentProfileId
                }
              })
              if (priceDetails?.refundFlag) {
                // pre charge(pre_post_charge_reservation=0) => payment_last_four,   post charge(pre_post_charge_reservation=1) => card_last_four
                editPayload['payment_profile_id'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction.token : BookingEditData.session_id
                editPayload['card_last_four'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction?.card_last_four : BookingEditData.transaction?.payment_last_four
                editPayload['expiry'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction?.expiry : BookingEditData.transaction?.expiration
              } else {
                editPayload['card_last_four'] = payment?.[0]?.card_last_four ? payment?.[0]?.card_last_four : ''
                editPayload['expiry'] = payment?.[0]?.expiry ? payment?.[0]?.expiry : ''
              }
              // editPayload['card_last_four'] = payment?.[0]?.card_last_four ? payment?.[0]?.card_last_four : ''
              // editPayload['expiry'] = payment?.[0]?.expiry ? payment?.[0]?.expiry : ''
            }

            if (priceDetails?.refundFlag) {
              // pre charge(pre_post_charge_reservation=0) => payment_last_four,   post charge(pre_post_charge_reservation=1) => card_last_four
              editPayload['payment_profile_id'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction.token : BookingEditData.session_id
              editPayload['card_last_four'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction?.card_last_four : BookingEditData.transaction?.payment_last_four
              editPayload['expiry'] = (BookingEditData.facility_configurations.pre_post_charge_reservation == '1') ? BookingEditData.transaction?.expiry : BookingEditData.transaction?.expiration
            }
            if (BookingEditData?.parking_type_id && BookingEditData?.parking_type_id != '') {
              editPayload['parking_type_id'] = BookingEditData?.parking_type_id
            }



            dispatch(updateReservationPayment(editPayload)).then((response) => {
              // const responseData = response?.data
              APILoad.current = true
              if (runStripe3dsIfRequired(response, editPayload)) return
              if (response?.data) {
                if (verifyPrepay == '1' && walletButtonShow) {
                  setVerifyPrepay('0')
                  setPage(page + 1)
                  setIsLoading(false)
                  setIsSubmit(false)
                  setBookingError(false)
                } else {
                  closeApplePaySession('success')
                  let responseData = { reservation: response.data }
                  const url =
                    'https://www.google.com/maps/place/' +
                    responseData?.reservation?.facility?.geolocations?.address_1 +
                    '/' +
                    responseData?.reservation?.facility?.geolocations?.latitude +
                    ',' +
                    responseData?.reservation?.facility?.geolocations?.longitude
                  setTicketDetails(responseData)
                  setBookingStatus(true)
                  setMapURL(url)
                  setPage(5)
                  resetFormValue()
                  notify('success', 'Booking Updated Successfully!')
                  setIsLoading(false)
                  setIsSubmit(false)
                  setBookingError(false)
                  let filterfacility = facility?.filter((fac) => fac?.id == editPayload?.facility_id)
                  if (filterfacility?.[0]?.facility_configuration?.is_inventory_check == '1') {
                    dispatch(inventoryUpdateReservatino({ 'reservation_id': responseData?.reservation?.id, 'type': 3, 'reservation_mode': editPayload?.reservation_mode })).then(() => {
                    })
                  }
                }
              } else {
                closeApplePaySession('failed')
                // setPage(4)
                setBookingStatus(false)
                setBookingError(true)
                const errors = response?.errors
                setTicketDetails(response)
                notify(
                  'error',
                  errors
                    ? errors?.message
                    : 'Something went wrong, Please try again!'
                )
                setIsLoading(false)
                setIsSubmit(false)
              }
            })
          } else {
            if (payloadRequest.promocode && (Number(payloadRequest.total) === 0)) {
              payloadRequest.nonce = ''
              payloadRequest.payment_profile_id = ''
              payloadRequest.payment_type = ''
            } else if (isLoggedIn() && !isCardFormVisible) {
              let payment = cardList.filter((item) => {
                if (item.payment_profile_id === paymentProfileId) {
                  return item.payment_profile_id === paymentProfileId
                } else if (item.token === paymentProfileId) {
                  return item.token === paymentProfileId
                }
              })
              payloadRequest.card_last_four = payment?.[0]?.card_last_four ? payment?.[0]?.card_last_four : ''
              payloadRequest.expiry = payment?.[0]?.expiry ? payment?.[0]?.expiry : ''
            }

            if (selectedParkingType && selectedParkingType != '') {
              payloadRequest.parking_type_id = selectedParkingType
            }
            payloadRequest.booking_label_id = partnerDetails?.id ? partnerDetails?.id : ''

            dispatch(saveReservationPayment(payloadRequest)).then((response) => {
              APILoad.current = true
              if (runStripe3dsIfRequired(response, payloadRequest)) return
              const responseData = response?.data

              const url =
                'https://www.google.com/maps/place/' +
                responseData?.reservation?.facility?.geolocations?.address_1 +
                '/' +
                responseData?.reservation?.facility?.geolocations?.latitude +
                ',' +
                responseData?.reservation?.facility?.geolocations?.longitude
              if (responseData) {
                if (verifyPrepay == '1' && walletButtonShow) {
                  setVerifyPrepay('0')
                  setPage(page + 1)
                  setIsLoading(false)
                  setIsSubmit(false)
                  setBookingError(false)
                } else {
                  closeApplePaySession('success')
                  setTicketDetails(responseData)
                  setBookingStatus(true)
                  setMapURL(url)
                  setPage(5)
                  resetFormValue()
                  notify('success', 'Booking confirmed!')
                  if (responseData?.is_card_added && responseData?.is_card_added == '0') {
                    setTimeout(function () {
                      notify('error', 'Your card is not added')
                    }, 2000)
                  }
                  if (facilityRef?.current?.facility_configuration?.is_reservation_inventory_check == '1') {
                    dispatch(inventoryUpdateReservatino({ 'reservation_id': responseData?.reservation?.id, 'type': 1 })).then(() => {
                    })
                  }
                  setIsLoading(false)
                  setIsSubmit(false)
                  setBookingError(false)
                  // setTicketId(responseData?.reservation?.id)
                }
              } else {
                //resetFormValue()
                // setPage(4)
                closeApplePaySession('failed')
                setBookingStatus(false)
                setBookingError(true)
                const errors = response?.errors
                setTicketDetails(response)
                if (errors?.message && errors?.detail?.isratemismatch) {
                  setIsRateMisMatch(true)
                  setMismatchRateError(errors?.message)
                } else {
                  notify(
                    'error',
                    errors
                      ? errors?.message
                      : 'Something went wrong, Please try again!'
                  )
                }
                setIsLoading(false)
                setIsSubmit(false)
              }
            })
          }

        } else {
          APILoad.current = true
          setIsLoading(false)
          notify('error', 'Please enter valid start and end time!')
        }
      } else {
        APILoad.current = true
        if (facilityRef?.current?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.FISERV && iframeErrorMsg) {
          // EOS-973 Check for iframe errors (when using Fiserv payment gateway)
          notify('error', iframeErrorMsg)
          setIsLoading(false)
          setTermShow(false)
        } else if (termCondition || data?.termCondition) {
          notify('error', 'Please fill the required details')
        } else {
          notify('error', 'Please accept the Terms & Conditions.')
        }

        setIsLoading(false)
        setIsSubmit(false)
      }
    } else if (terms_condition_error) {
      APILoad.current = true
      notify('error', 'Please accept the Terms & Conditions.')
    }
  }
  latestOnSubmit.current = onSubmit

  const handleCardSelectChange = (e) => {
    setBookingEditStatus(true)
    clearErrors('paymentProfileIDUser')
    const { value } = e.target
    const selectedCard = cardList?.filter((card) => card?.token == value)
    setPaymentProfileId(selectedCard[0]?.token ? selectedCard[0]?.token : '')
    setValue('paymentProfileIDUser', selectedCard[0]?.token ? selectedCard[0]?.token : ''
    )
  }

  const showCardForm = () => {
    setPaymentProfileId('')
    setValue('paymentProfileIDUser', '')
    setCardFormVisible(true)
    clearErrors('card_number')
    clearErrors('card_expiry')
    setValue('card_number', '')
    setValue('card_expiry', '')
    setCardNumber('')
    setCardExpiry('')
    clearErrors('paymentProfileIDUser')
    //setFormData({ ...formData, ['card_pan']: '' })
  }

  const hideCardForm = () => {
    if (isLoggedIn()) {
      if (cardList?.length == 1) {
        setPaymentProfileId(cardList[0]?.token ? cardList[0]?.token : '')
        setValue('paymentProfileIDUser', cardList[0]?.token ? cardList[0]?.token : '')
      }
    }

    setCardFormVisible(false)

    //setFormData({ ...formData, ['card_pan']: '' })
  }

  const filterPassedTime = (time) => {
    const currentDate = changeTimeZone(new Date(), partnerDetails?.facilities[0]?.timezone)
    const selectedDate = time
    return currentDate.getTime() < selectedDate.getTime()
  }

  const filterPassedTimeStart = (time) => {
    const currentDate = changeTimeZone(new Date(), partnerDetails?.facilities[0]?.timezone)
    const selectedDate = time
    const FDate = new Date(startDateTime)
    return (currentDate.getTime() < selectedDate.getTime() && FDate.getTime() < selectedDate.getTime())
  }

  const filterPassedTimeEnd = (time) => {
    const currentDate = entryDateTime
    const selectedDate = time
    return (currentDate.getTime() < selectedDate.getTime())

  }

  // const filterArrivalTime = (time) => {
  //   const currentDate = new Date(exitDateTime)
  //   const selectedDate = time
  //   return currentDate.getTime() >= selectedDate.getTime()
  // }
  // const filterPassedDepartTime = (time) => {
  //   const startDate = new Date(entryDateTime)
  //   // const endDate = new Date(entryDateTime)
  //   const selectedDate = time
  //   return startDate.getTime() <= selectedDate.getTime()
  // }

  const handleLoginModalOpen = (e, id) => {
    setShow(true)
    setCaller('nav')
    setUseFor(id)
  }
  const handleState = (e) => {
    setBookingEditStatus(true)
    const { name, value } = e.target
    setValue(name, value)
  }

  const handlezipcode = (e) => {
    setBookingEditStatus(true)
    const { name, value } = e.target
    setValue(name, value)
    if (name == 'pincode_card') {
      if (value?.trim()?.length < 5) {
        setError('pincode_card', { type: 'minLength', message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed' })

      } else if (value?.trim()?.length > 6) {
        setError('pincode_card', { type: 'maxLength', message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Maximum 6 characters allowed' : 'Maximum 6 numbers allowed' })
      } else {
        clearErrors('pincode_card')
      }
    } else {
      if (value?.trim()?.length < 5) {
        setError('pincode', { type: 'minLength', message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed' })

      } else if (value?.trim()?.length > 6) {
        setError('pincode', { type: 'maxLength', message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Maximum 6 characters allowed' : 'Maximum 6 numbers allowed' })
      } else {
        clearErrors('pincode')
      }
    }


  }

  const handleVehicalMakeChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    let modelData = vehicleDetailsList.make.filter((v) => v?.id == value)
    let modelList = modelData[0]?.mst_model
    modelList?.length > 0 ? setvehicleModelList(modelList) : setvehicleModelList(EMPTY_ARRAY)
    // setVehicleMakeID(value)
    // setVehicleMakeIDData(modelData[0]?.id)
    let findindex = modelList?.find(item => item.name == 'Others')
    if (value == 'Others') {
      setOtherMake(true)
      // setOtherModel(true)
      setVehicleMakeIDData('')
      setVehicleModelIDData('')
    } else {
      setVehicleMakeIDData(modelData[0]?.id)
      if (!findindex && value != '') {
        modelList?.unshift({
          'id': 'Others',
          'make_id': 'Others',
          'name': 'Others'
        })
      }
      if (value != '') {
        setvehicleModelList(modelList)
        setOtherMake(false)
      } else {
        setvehicleModelList(EMPTY_ARRAY)
        setOtherMake(false)
      }
    }
  }

  const handleVehicalModelChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target

    if (value == 'Others') {
      setOtherModel(true)
      setVehicleModelIDData('')
    } else {
      setOtherModel(false)
      let getModelId = vehicleModelList?.filter((v) => v?.id == value)
      setVehicleModelIDData(getModelId?.[0]?.id)
    }

  }

  const handleVehicalColorChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    let getColoId = vehicleDetailsList?.color?.filter((v) => v?.id == value)
    setVehicleColorDData(getColoId?.[0]?.id)
  }

  const handleCountryChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    setValue('state', '')
    getStateByCountry(value)
    // setValue('vehicle_country', value)
    // reset((formValues) => ({ ...formValues, vehicle_country: value }))
  }

  const getStateByCountry = (value, userdata = '') => {
    if (value == '') {
      reset((formValues) => ({ ...formValues, state: '' }))
      return false
    }
    dispatch(getVehicleDetailsList()).then((ress) => {
      let countryData = ress?.country?.filter((v) => v?.country_code == value || v?.name == value)
      dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
        setVehicleDetailsList(res)
        // setVehicleDetailsState(res)
        // if getting state id then convert state code and set state
        if (userdata != '') {
          let filterState = res?.state?.filter((v) => v?.id == userdata.state)
          let state = filterState?.length > 0 ? filterState[0]?.state_code : userdata.state
          reset(formValues => ({ ...formValues, state: state }))
        }

      })
    })


  }

  const handleVehicalCountryChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    getStateByVehicleCountry(value)
    // setValue('vehicle_country', value)
    // reset((formValues) => ({ ...formValues, vehicle_country: value }))
  }

  const getStateByVehicleCountry = (value) => {
    // setValue('vehicle_country', value)
    // reset((formValues) => ({ ...formValues, vehicle_country: value }))   
    dispatch(getVehicleDetailsList()).then((res) => {
      let countryData = res?.country?.filter((v) => v?.country_code == value || v?.name == value)
      dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
        setVehicleDetailsState(res)


      })
    })



  }

  const handleVehicalStateIDChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    let stateIdlData = vehicleDetailsState.state.filter((v) => v.id == value)
    setStateName(stateIdlData[0]?.name)
  }

  const lineborder = () => {
    let widthdata = 0
    if (page == 1) {
      widthdata = 0
    } else if (page == 2) {
      widthdata = 35
    } else if (page == 3) {
      widthdata = 65
    } else if (page == 4) {
      widthdata = 100
    } else {
      widthdata = 0
    }

    return widthdata
  }


  const handleModalTerm = () => {
    setTermShow(!showTerm)
  }


  const handleStepErrorFirst = (step) => {
    let neededKeys = []
    if (step == 1) {
      neededKeys = ['garage', 'entry_time', 'exit_time']
    } else if (step == 2) {
      neededKeys = ['first_name', 'last_name', 'email', 'phone', 'address', 'city', 'state', 'country', 'pincode']
    } else if (step == 3) {
      neededKeys = ['license_plate', 'vehicle', 'make', 'model', 'color', 'state_id']
    } else {
      neededKeys = []
    }
    // let validaterror = neededKeys.every(key => Object.keys(errors).includes(key))
    let validaterror = neededKeys.filter(key => Object.keys(errors).includes(key)).length
    return validaterror
  }



  const handelOtherModelAdd = (data) => {
    let newListModel = [...vehicleModelList]
    let dup_model = newListModel?.findIndex(item => item?.name?.toLowerCase() == data?.model?.toLowerCase())
    if (dup_model == '-1') {
      newListModel?.unshift({
        'id': data?.model,
        'make_id': '',
        'name': data?.model
      })
      setValue('model', data?.model)
      setvehicleModelList(newListModel)
      setOtherModel(false)
    } else {
      notify('error', 'You can not add duplicate model')
    }
  }


  const handelOtherVehicleClose = (data) => {
    if (data == 'make') {
      setValue('make', '')
      setValue('model', '')
    } else if (data == 'model') {
      setValue('model', '')
    }
    // setOtherMake(false)
    // setOtherModel(false)
  }

  const handelOtherVehicleAdd = (data) => {
    let newList = [...vehicleMakeList]
    let dup_make = newList?.findIndex(item => item?.name?.toLowerCase() == data?.make?.toLowerCase())
    if (dup_make == '-1') {
      newList.unshift({
        'id': data?.make,
        'name': data?.make,
        // 'mst_model': [{
        //   'id': '0',
        //   'make_id': '',
        //   'name': data?.model
        // }]
      })
      handelOtherModelAdd(data)
      setValue('make', data?.make)
      setValue('model', data?.model)
      setVehicleMakeList(newList)
      setOtherMake(false)
    } else {
      notify('error', 'You can not add duplicate make or model')
    }
  }


  // const handleEmailChange = () => {
  //   setPromoAplicable(true)
  // }
  const handleEmailChange = (e) => {
    if (!isParksfo()) {
      setBookingEditStatus(true)
      setPromoAplicable(true)
      const { value } = e.target
      if (promoCodeApply && value != '' && facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == 0 && validateEmail(value)) {
        deb(priceDetails)
      }
    }
  }

  const deb = useCallback(debounce((payload) => { applyPromocode(payload, '0') }, 400), [facilityId, partnerUserId, priceDetails])

  const handleCardNumber = (value) => {
    setBookingEditStatus(true)
    setCardNumber(value)
  }

  const handlCardExpiry = (value) => {
    setCardExpiry(value)
    let expiryDateCheck = validExpiryDate(value)
    if (value.length == 4 && !expiryDateCheck) {
      // notify('error', 'Please Enter a valid expire date')
      setCardExpiryMessage('Enter a valid expire date')
      // setExpiry('')
      // formData['expiration_date'] = ''
      // setFormData({ ...formData })
    } else {
      setCardExpiryMessage('')
      setCardExpiry(value?.trim())
    }
  }

  // const handlePhoneNumber = (value) => {
  //   setMobile(value)

  // }
  const handlePhoneNumber = (value) => {
    if (!isParksfo()) {
      setBookingEditStatus(true)
      setMobile(value)
      if (promoCodeApply && value != '' && facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == 0 && validatePhone(value)) {
        deb(priceDetails)
      }
    } else {
      setMobile(value)
    }
  }
  const handleLicenseChange = (e) => {
    if (!isParksfo()) {
      setBookingEditStatus(true)
      const { value } = e.target
      setValue('license_plate', restrictInValidCharLicense(value)?.replace(/[^a-zA-Z0-9]/g, ''))
      clearErrors('license_plate')
      if (promoCodeApply && value != '' && facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == 0) {
        deb(priceDetails)
      }
    } else {
      const { value } = e.target
      setValue('license_plate', restrictInValidCharLicense(value)?.replace(/[^a-zA-Z0-9]/g, ''))
      clearErrors('license_plate')
    }
  }


  // const restrictInputValuesData=(e)=>{
  //   // let x=restrictInputValuesVal(e)
  //   // if(x) {
  //   //   setCVV(e.target.value)
  //   //   setValue('ccv',e.target.value)
  //   // }
  // }

  const reFetchFacilityParkingData = () => {
    // fetchRates(rateFetchPayload)
    setIsRateMisMatch(false)
    setMismatchRateError('')
    getPriceDetaitlsToggle(
      partnerUserId,
      BookingEditData?.facility?.id || facilityId || resfacility,
      entryDateTime,
      exitDateTime
    )

  }


  // for the vehicle type 
  const handleVehicleTypeChange = (e) => {
    setBookingEditStatus(true)
    const { value } = e.target
    let getvehicletypeId = vehicleDetailsList?.vehicletype?.filter((v) => v?.id == value)
    setVehicleTypeData(getvehicletypeId?.[0]?.id)
  }
  // for the vehicle type end 

  const closeApplePaySession = (endsession) => {
    if (applePaySessionRef.current) {
      if (endsession === 'success') {
        applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
      } else if (endsession === 'failed') {
        applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
      } else {
        applePaySessionRef.current.abort()
      }
    }
  }

  // EOS-5093 Amenities shown on the success page. The booking response is the
  // source of truth when it carries them, otherwise the user's selection is used.
  const responseAmenities = formatAmenityOptions(ticketDetails?.reservation?.reservation_amenities)
  const bookedAmenities = responseAmenities?.length > 0 ? responseAmenities : selectedAmenities

  // EOS-5093 Amenities. Selecting or removing one re-prices the reservation,
  // the same way a parking type change does.
  const handleAmenitiesChange = (selectedList) => {
    const updatedAmenities = selectedList || EMPTY_ARRAY
    setBookingEditStatus(true)
    setSelectedAmenities(updatedAmenities)
    // Updated ahead of the rate call, which reads the ref while building its slug.
    selectedAmenitiesRef.current = updatedAmenities
    const amenityFacilityId = BookingEdit
      ? (BookingEditData?.facility_id || BookingEditData?.facility?.id)
      : (facilityId || resfacility)
    if (amenityFacilityId) {
      getPriceDetaitlsToggle(partnerUserId, amenityFacilityId, entryDateTime, exitDateTime)
    }
  }
  // EOS-5093 Amenities

  const fetchParkingTypes = () => {
    dispatch(getParkingTypes()).then((res) => {
      if (res && res?.length > 0) {
        setParkingType(res)
        if (BookingEdit && BookingEditData?.parking_type_id && BookingEditData?.parking_type_id != '') {
          setSelectedParkingType(BookingEditData?.parking_type_id)
        } else {
          const defaultParkingType = res?.filter((parking_type) => parking_type?.is_default == 1)
          setSelectedParkingType(defaultParkingType?.[0]?.id)
        }
      } else {
        setParkingType(EMPTY_ARRAY)
      }
    }).catch(() => {
      setParkingType(EMPTY_ARRAY)
    })
  }

  const fetchValidationCodes = () => {
    const payload = {
      start_date: moment(startTimeRef?.current)?.format('YYYY-MM-DD'),
      end_date: moment(exitTimeRef?.current)?.format('YYYY-MM-DD'),
      parking_type_id: selectedParkingType
    }
    dispatch(getValidationCodes(payload)).then((res) => {
      if (res && res?.length > 0) {
        setValidationCodes(res)
        const isAppliedCouponAvailable = res?.filter((coupon) => selectedValidationCode?.id == coupon?.id)
        if (isAppliedCouponAvailable?.length == 0) {
          selectedValidationCode?.length > 0 ? removePromocode(false) : null
        }
      } else {
        setValidationCodes(EMPTY_ARRAY)
        selectedValidationCode?.length > 0 ? removePromocode(false) : null
      }

    }).catch(() => {
      setParkingType(EMPTY_ARRAY)
    })
  }

  const handleValidationCodeChange = (event) => {
    const { value } = event.target
    setBookingEditStatus(true)
    const selectedPromocode = validationCodes?.filter((validation_code) => validation_code?.promo_code?.[0]?.promocode == value)

    if (value && moment(selectedPromocode?.[0]?.valid_to).isAfter(moment(exitDateTime))) {

      setSelectedValidationCode(selectedPromocode?.[0])
      setValue('promo_code', value)

      if (BookingEdit) {
        BookingEditData.promocode = value
      }
      if (value) {
        applyPromocode()
      } else {
        removePromocode()
        setSelectedValidationCode({})
      }

    } else {
      value ? notify('error', 'Selected Coupon Code is not Valid for this Parking Duration') : null
      Object.keys(selectedValidationCode)?.length > 0 ? removePromocode(false) : null
      setSelectedValidationCode({})
      setValue('promo_code', '')
      if (value == '') {
        setValue('promo_code', '')
        setPromocode(null)
        setPromoCodeApply(false)
        setDiscount(0)
        promocodeRef.current = null
        setPromocodeRes(EMPTY_OBJECT)
        removePromocode(false)
      }
    }


  }

  latestIframeSubmit.current = handleSubmit(onSubmit)

  // ---- Payment modal (as trans-staging): New Card / Saved Card / Apple Pay - GPay; the payment is still onSubmit
  // Pay now with an amount due: Proceed To Pay checks the form and the terms, then opens the modal
  const paymentModalFlow = page == 4 && selectedPaymentType != 0 && !paymentDisable && Number(priceDetails?.payable_amount) > 0 && !isCheckOutStatus

  const handleProceedToPay = async () => {
    const valid = await trigger()
    if (!valid) return
    if (!termCondition) {
      // Shows the terms error, as the wallet buttons do
      onSubmit({ ...getValues() }, '', true)
      return
    }
    setIsPaymentModalOpen(true)
  }

  // Closing the modal drops the card / token entered there, so nothing is paid with it later
  const closePaymentModal = () => {
    setCardToken(null)
    setIframeErrorMsg('')
    setValue('paymentToken', '')
    setPaymentTab(null)
    setIsPaymentModalOpen(false)
  }

  const payButton = (
    <button type='button' className='btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center' onClick={handleSubmit(onSubmit)} disabled={isLoading || !isReady || (BookingEdit && !bookingEditStatus)}>
      <span className='fw-bold'>{selectedPaymentType == '0' ? 'Confirm & Book' : 'Pay'}</span>
      {isLoading && isSubmit ? <span className='ms-2'><Circles height='20' width='20' color='#ffffff' ariaLabel='circles-loading' visible={true} /></span> : null}
    </button>
  )

  const amountDueRow = (
    <div className='d-flex justify-content-between align-items-center py-2 border-top border-bottom mt-3'>
      <span className='fw-semibold'>Amount Due</span>
      <span className='fw-bold'>{priceDetails?.payable_amount ? `$${formatDecimal(priceDetails?.payable_amount)}` : ''}</span>
    </div>
  )

  // Card holder fields (same order as trans-staging: name, card, expiry + CVV, zip): the name on the card and the
  // billing zip for the card form, the gateway fields (Stripe / Datacap / Heartland) and Fiserv
  const cardNameField = (
    <div className="row g-2 row-cols-1">
      <div className="col">
        <div className="mb-1">
          <label className="form-label">
            Name on Card{' '}
            <span className="text-danger">*</span>
          </label>
          {/* <input type="text" className="form-control" /> */}
          <Controller
            name="card_name"
            type="text"
            id="card_name"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'This field is required',
              },
            }}
            render={({ field }) => (
              <input
                autoComplete="off"
                className="form-control"
                {...field}
                id="card_name"
                placeholder="Name on Card"
                maxLength="50"
                onKeyPress={(e) => { allowalphabetical(e); handleKeyPressRestrictLeadingTrailingSpace(e) }}
              />
            )}
          />
          {errors?.card_name && (
            <span className="text-danger small">
              {errors?.card_name?.message}
            </span>
          )}
        </div>
      </div>
    </div>
  )
  const cardZipField = (
    <div className="row g-2 row-cols-1">
      <div className="col">
        <div className="mb-1">
          <label className="form-label">
            Zip/Postal code
          </label>
          <Controller
            name="pincode_card"
            type="text"
            id="pincode_card"
            control={control}
            rules={{
              // required: {
              //   value: true,
              //   message: 'This field is required',
              // },
              minLength: {
                value: 5,
                message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed',
              },
              maxLength: {
                value: 6,
                message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Maximum 6 characters allowed' : 'Maximum 6 numbers allowed',
              },
            }}
            render={({ field }) => (
              <input
                name="pincode_card"
                autoComplete="off"
                className="form-control"
                maxLength={6}
                minLength={5}
                {...field}
                disabled={isCheckinStatus == '1' ? true : false}
                id="pincode_card"
                placeholder="Enter Zip/Postal Code"
                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}
                onChange={(e) => { field.onChange(e); handlezipcode(e) }}

              />
            )}
          />
          <span className="form-text text-danger h-40">**Mandatory for Amex Cards only</span>
          {/* {errors?.pincode && (
              <span className="text-danger small">
                {errors?.pincode?.message}
              </span>
            )} */}
          {/* {errors?.pincode?.type === 'minLength' &&
                <span className="text-danger small">Please enter a valid pincode</span>
              } */}
        </div>
      </div>
    </div>
  )

  // New Card tab: amount due and the card form (gateway fields with their own Submit, the card form or Fiserv)
  const newCardForm = (
    facilityRef?.current?.facility_payment_details?.facility_payment_type_id != PAYMENT_GATEWAY.FISERV ?
      <>
        {usesHostedCardFields(facilityRef?.current) ? cardNameField : null}
        <PaymentGatewayCommon
          faciltyData={facilityRef?.current}
          onSubmit={() => latestIframeSubmit.current()}
          setIsSubmittingForm={setIsSubmit}
          isSubmittingForm={isSubmit && isLoading}
          prevButton={prevButton}
          page='reservation'
          // setFormData={setFormData}
          // formData={formData}
          setValue={setValue}
          amount={Number(priceDetails?.payable_amount ? priceDetails?.payable_amount : 0)}
          APILoad={APILoad}
          // Stripe card fields invalid: the name on card is checked with them
          onInvalid={() => trigger('card_name')}
          setupFutureUsage={userConsent ? 'off_session' : null}
          // Same as the backend (checkPreAuthPayment): pay later or pre/post charge facility -> pre-authorize, else charge now
          stripeCaptureMethod={((facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1 && selectedPaymentType == '0') || Number(facilityRef?.current?.facility_configuration?.pre_post_charge_reservation) > 0) ? STRIPE_CAPTURE.PRE_AUTH : STRIPE_CAPTURE.SALE}
          consent={<>
            {usesHostedCardFields(facilityRef?.current) ? cardZipField : null}
            {isLoggedIn() && <div className=" my-2">
              <div className="block my-2">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <label style={{ minHeight: '35px' }} className="form-check-label fw-normal">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        id="userConsent"
                        name="userConsent"
                        onClick={() => {
                          setUserConsent(!userConsent)
                          setValue('userConsent', !userConsent)
                        }}
                        checked={userConsent}
                      />
                      Save my card
                    </label>
                  </div>
                  {userConsent ? (
                    <div className="col">
                      <div className="input-group input-group-sm">
                        <span className="input-group-text text-sm">
                          Card Description
                        </span>
                        <Controller
                          name="card_description"
                          type="text"
                          id="card_description"
                          control={control}
                          rules={{
                            required: {
                              value: false,
                              message:
                                'This field is required',
                            },
                          }}
                          render={({ field }) => (
                            <input
                              autoComplete="off"
                              {...field}
                              id="card_description"
                              title="Card Description"
                              className="form-control"
                              placeholder="Card Description"
                            />
                          )}
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>

            </div>}
          </>
          }
          loginUser={isLoggedIn()}
          LoginSignUpButton={<></>}
          // In the payment modal: no page Previous / login button inside the card form
          previousButton={<></>}
          isCheckOutStatus={isCheckOutStatus}
          paymentDisable={paymentDisable}
          customGateWay={<div className="mb-1">
            {cardNameField}
            <div className="row g-2 row-cols-1">



              <div className="col">
                <div className="mb-3">
                  <label className="form-label">
                    Card Number{' '}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="d-block position-relative ">
                    {/* <input type="text" className="w-100 p-1 border-0" />{' '} */}
                    <Controller
                      name="card_number"
                      type="text"
                      id="card_number"
                      control={control}
                      rules={{
                        required: {
                          value: true,
                          message: 'This field is required'
                        },
                        minLength: {
                          value: 15,
                          message:
                            'Minimum 15 characters allowed',
                        },
                        maxLength: {
                          value: 19,
                          message: 'Maximum 16 characters allowed'
                        },
                      }}
                      render={({ field }) => (
                        <MaskedInput
                          maskGenerator={cardnumbermask}
                          autoComplete="off"
                          pattern="[0-9 ]{18,19}"
                          maxLength="19"
                          minLength={15}
                          {...field}
                          onChange={(e) => { field.onChange(e); handleCardNumber(e) }}
                          id="card_number"
                          title="Card Number should be 15-16 digit"
                          className="form-control"
                          // value={cardNumber}
                          value={getValues().card_number}
                          onInvalid={(e) =>
                            e.target.setCustomValidity(
                              'Please enter a valid card number'
                            )
                          }
                          onInput={(e) =>
                            e.target.setCustomValidity('')
                          }
                          placeholder="Card Number"
                        />
                      )}
                    />


                    <i className=" fa text-primary fa-credit-card me-2 position-absolute top-50 end-0 translate-middle-y"></i>
                  </div>
                  {errors?.card_number && (
                    <span className="text-danger small">
                      {errors?.card_number?.message}
                    </span>
                  )}
                </div>
              </div>
            </div>



            <div className="row g-2 row-cols-md-2 row-cols-lg-2 row-cols-sm-2 row-cols-1">
              <div className="col">
                <div className="mb-1">
                  <label className="form-label">
                    Expiry Date{' '}
                    <span className="text-danger">*</span>
                  </label>
                  {/* <input type="text" className="form-control" /> */}
                  <Controller
                    name="card_expiry"
                    type="text"
                    id="card_expiry"
                    control={control}
                    // rules={{ required: (cardNumber.length === 4 && cardExpiry.length !== 4) ? true : false, maxLength: 5 }}
                    rules={{
                      required: {
                        value: true,
                        message: 'This field is required',
                      },
                      minLength: {
                        value: 4,
                        message:
                          'Minimum 4 characters allowed',
                      },
                      maxLength: {
                        value: 5,
                        message:
                          'Maximum 4 characters allowed',
                      },
                    }}
                    render={({ field }) => (
                      <MaskedInput
                        maskGenerator={expirymask}
                        autoComplete="off"
                        pattern="(?:0?[1-9]|1[0-2])/[0-9 ]{2}"
                        {...field}
                        maxLength={5}
                        minLength={4}
                        id="card_expiry"
                        onChange={(e) => { field.onChange(e); handlCardExpiry(e) }}
                        // value={cardExpiry}
                        value={getValues().card_expiry}
                        className="form-control"
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            'Please enter MM/YY format card expiry date'
                          )
                        }
                        onInput={(e) =>
                          e.target.setCustomValidity('')
                        }
                        placeholder="MM/YY"
                      // onChange={(e) => { field.onChange(e); handleCardExpiry(e) }}
                      />
                    )}
                  />
                  {errors?.card_expiry && (
                    <span className="text-danger small">
                      {errors?.card_expiry?.message}
                    </span>
                  )}
                  {<span className="text-danger small">
                    {cardExpiryMessage}
                  </span>}
                </div>
              </div>
              <div className="col">
                <div className="mb-1">
                  <label className="form-label">
                    CVV{' '}
                    <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="ccv"
                    type="text"
                    id="ccv"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'This field is required',
                      },
                      minLength: {
                        value: 3,
                        message:
                          'Minimum 3 characters allowed',
                      },
                      maxLength: {
                        value: 4,
                        message:
                          'Maximum 4 characters allowed',
                      },
                    }}
                    render={({ field }) => (
                      <input
                        autoComplete="off"
                        type="password"
                        // pattern="([1-9]|1[0-2])/[0-9 ]{2}"
                        maxLength="4"
                        minLength="3"
                        className="form-control"
                        {...field}
                        id="ccv"
                        placeholder="CVV"
                        // value={CVV}
                        // onChange={(e) => restrictInputValuesData(e)}
                        onKeyPress={(e) => restrictInputValues(e)}
                        onKeyUp={(e) => numberMobile(e)}
                      />
                    )}
                  />
                  {errors?.ccv && (
                    <span className="text-danger small">
                      {errors?.ccv?.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
            {cardZipField}

            {isLoggedIn() &&
              <div className=" my-2">
                <div className="block my-2">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <label style={{ minHeight: '35px' }} className="form-check-label fw-normal">
                        <input
                          className="form-check-input me-2"
                          type="checkbox"
                          id="userConsent"
                          name="userConsent"
                          onClick={() =>
                            setUserConsent(!userConsent)
                          }
                          checked={userConsent}
                        />
                        Save my card
                      </label>
                    </div>
                    {userConsent ? (
                      <div className="col">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text text-sm">
                            Card Description
                          </span>
                          <Controller
                            name="card_description"
                            type="text"
                            id="card_description"
                            control={control}
                            rules={{
                              required: {
                                value: false,
                                message:
                                  'This field is required',
                              },
                            }}
                            render={({ field }) => (
                              <input
                                autoComplete="off"
                                {...field}
                                id="card_description"
                                title="Card Description"
                                className="form-control"
                                placeholder="Card Description"
                              />
                            )}
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

              </div>}
            {payButton}
          </div>}
        />
      </> : <>
        {/* Fiserv: name on card, the CardConnect fields (card, expiry, CVV), zip */}
        {cardNameField}
        <CardConnectTokenizer
          setToken={setCardToken}
          faciltyPaymentDetails={facilityRef?.current?.facility_payment_details}
          setIframeErrorMessage={setIframeErrorMsg}
          tokenRef={tokenRef}
        />
        {cardZipField}
        {payButton}
      </>
  )
  const newCardContent = (
    <div className='pm-gateway'>
      <p className='mb-2 text-muted small'>Enter Payment Details</p>
      {amountDueRow}
      <div className='d-flex align-items-center mb-2'>
        <div className='py-2 pe-2 small text-nowrap text-primary'>Credit/Debit Card</div>
        <div className='w-100' style={{ height: '1px', background: 'var(--bs-border-color)' }}></div>
      </div>
      {newCardForm}
    </div>
  )

  // Saved Card tab (logged in, with saved cards): the same selection as the card list did
  const currentSelCard = cardList?.find((item) => item?.token && item?.token == paymentProfileId)
  const savedCardContent = (isLoggedIn() && cardList?.length > 0) ? (
    <div className='p-2'>
      <span className='fw-semibold'>Select a saved card</span>
      <div className='mt-2 border rounded'>
        {cardList?.map((item, index) => (
          <div
            key={index}
            role='button'
            className={`d-flex align-items-center px-3 py-2 ${index < cardList.length - 1 ? 'border-bottom' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleCardSelectChange({ target: { value: item?.token } })}
          >
            <i className='fa fa-check me-3' style={{ visibility: currentSelCard?.token === item?.token ? 'visible' : 'hidden' }}></i>
            <i className='fa fa-credit-card me-2 text-muted'></i>
            <div className='me-auto'>
              <div className='fw-semibold' style={{ fontSize: '14px' }}>Card ending in {item?.card_last_four?.slice(0, 4)}</div>
              <div className='text-muted small'>Expires {item?.expiry ? `${item?.expiry?.slice(0, 2)}/${item?.expiry?.slice(2, 4)}` : '--'}</div>
            </div>
            {item?.is_default == '1' ? <small className='text-success'>Default</small> : null}
          </div>
        ))}
      </div>
      {!paymentProfileId ? <span className='form-text text-danger'>{errors?.paymentProfileIDUser?.message}</span> : null}
      {amountDueRow}
      {payButton}
    </div>
  ) : null

  // New Card: the card form (no saved card); Saved Card: the selected one (or the default)
  const handlePaymentTabChange = (method) => {
    setPaymentTab(method)
    if (method == 'card') {
      showCardForm()
    } else if (method == 'saved-card') {
      hideCardForm()
      const selected = currentSelCard || cardList?.find((item) => item?.is_default == '1') || cardList?.[0]
      if (selected) {
        handleCardSelectChange({ target: { value: selected?.token } })
      }
    }
  }

  // Apple Pay / GPay tab: the page's wallet buttons (facility configuration)
  const walletContent = (Number(priceDetails?.parking_amount) > 0 && walletButtonShow) ? (
    <div className='d-flex justify-content-center'>
      <div className='position-relative'>
        {(walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null}
        <WalletButtons key={priceDetails?.payable_amount} faciltyData={facilityRef?.current} getValues={getValues} onSubmit={onSubmit} isSubmittingForm={isLoading} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={priceDetails?.payable_amount} notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} dispatch={dispatch} />
      </div>
    </div>
  ) : null

  return (
    <div style={{ minHeight: '80vh' }} className="h-100 reservation-container">
      <ModalLogin
        setShow={setShow}
        show={show}
        caller={caller}
        notify={notify}
        useFor={useFor}
        partnerDetails={partnerDetails}
      />
      <ModalTerm partnerDetails={partnerDetails} facilityId={facilityId} setShow={setTermShow} show={showTerm} />
      <VehicalModel vehiclename='make' handelOtherVehicleAdd={handelOtherVehicleAdd} handelOtherVehicleClose={handelOtherVehicleClose} setShow={setOtherMake} show={otherMake} />
      <VehicalModel vehiclename='model' handelOtherVehicleAdd={handelOtherModelAdd} handelOtherVehicleClose={handelOtherVehicleClose} setShow={setOtherModel} show={otherModel} />

      {page == 5 && bookingError && !bookingStatus && (
        <div
          className="alert alert-warning mb-0 alert-dismissible fade show"
          role="alert"
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-auto">
                <i className="fa fa-exclamation-triangle fa-2x"></i>
              </div>
              <div className="col">
                <b>Error!</b> {ticketDetails?.errors?.message ? ticketDetails?.errors?.message : 'Something went wrong, Please try again!'}
              </div>
              {isParksfo() ? null : <div className="col-auto">
                <button
                  type="button"
                  onClick={newBooking}
                  className="btn btn-primary"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  New Booking
                </button>
              </div>}
            </div>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
      )}

      {isReservationEnabled ? <div className="container py-5 flud mt-5">
        {page != 5 && (
          <h2 className="fw-medium h4  mt-2 text-center text-primary">
            {BookingEdit ? 'Modify Parking Details' : 'Book Parking at your convenience'}
          </h2>
        )}
        <div className="row justify-content-center mb-4">
          <div className="col-md-8 col-11">
            <div className="stepper position-relative d-flex align-items-center justify-content-between">
              {/* <div className="stepper-line" style={{ width: '65%' }}></div> */}
              <div className="stepper-line" style={{ width: `${lineborder()}%` }}></div>
              <div
                className={page == 1 ? Object.keys(errors).length > 0 && handleStepErrorFirst(1) ? 'stepper-circle error' : 'stepper-circle active' : page > 1 ? 'stepper-circle done' : 'stepper-circle'
                }
              >
                <span>
                  {page == 1 ? Object.keys(errors).length > 0 && handleStepErrorFirst(1) ? (<i className="fa fa-times"></i>) : '1' : page > 1 ? (
                    <i className="fa fa-check"></i>
                  ) : (
                    '1'
                  )}
                </span>
                <span className="stepper-title">Parking Details</span>{' '}
              </div>
              <div
                className={page == 2 ? Object.keys(errors).length > 0 && handleStepErrorFirst(2) ? 'stepper-circle error' : 'stepper-circle active'
                  : page > 2
                    ? 'stepper-circle done'
                    : 'stepper-circle'
                }
              >
                {page == 2 ? (Object.keys(errors).length > 0 && handleStepErrorFirst(2) ? (<i className="fa fa-times"></i>) : '2') : page > 2 ? (
                  <i className="fa fa-check"></i>
                ) : (
                  '2'
                )}{' '}
                <span className=" stepper-title">Customer Details</span>
              </div>
              <div
                className={
                  page == 3
                    ? Object.keys(errors).length > 0 && handleStepErrorFirst(3) ? 'stepper-circle error' : 'stepper-circle active'
                    : page > 3
                      ? 'stepper-circle done'
                      : 'stepper-circle'
                }
              >
                {page == 3 ? (Object.keys(errors).length > 0 && handleStepErrorFirst(3) ? (<i className="fa fa-times"></i>) : '3') : page > 3 ? (
                  <i className="fa fa-check"></i>
                ) : (
                  '3'
                )}{' '}
                <span className=" stepper-title">Vehicle Details</span>
              </div>
              <div
                className={
                  page == 4 ? 'stepper-circle active'
                    : page > 4
                      ? (!bookingStatus && bookingError) ? 'stepper-circle error' : 'stepper-circle done'
                      : 'stepper-circle'
                }
              >
                {page == 4 ? '4' : page > 4 ? ((!bookingStatus && bookingError) ? <i className="fa fa-times"></i> :
                  <i className="fa fa-check"></i>
                ) : (
                  '4'
                )}{' '}
                <span className=" stepper-title">{lengthPlusMinus == '0' && priceDetails?.refundFlag == '1' && facilityRef?.current?.facility_configuration?.is_process_fee_charged != '1' ? 'Refund' : 'Payment Details'}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="boxWrap" ref={divRef}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {page != 5 && (
              <div className="row g-2 ">
                <div className="col-md-7 col-lg-8 mb-3 position-relative">

                  <div className={loaderPrice || applyPromoLoder ? 'reservation-loader-area' : 'd-none'}>
                    <Circles
                      height="20"
                      width="20"
                      style={{ display: 'inline-block', opacity: '100% !important' }}
                      color="#ffffff"
                      ariaLabel="circles-loading"
                      visible={true}
                    />
                  </div>
                  <>
                    {page == 1 && (
                      <div id="step-1" className="border p-3  bg-white">
                        <h4 className="mb-0  mb-3"> Parking Details </h4>
                        {BookingEdit && BookingEditData?.promocode ? <div className="my-3 border rounded alert alert-info">
                          <span><strong>Note: </strong>{errorMessage?.couponRemoveMessage}</span>
                        </div> : null}
                        <div className="row g-2 row-cols-md-2 row-cols-lg-3 row-cols-sm-2 row-cols-1">
                          {isParksfo() ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Reserved Parking Zone
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                //  onChange={(event) => handelGarage(event)}
                                name="garage"
                                type="select"
                                id="garage"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <select

                                    autoComplete="off"
                                    className="form-select"
                                    {...field}
                                    disabled={BookingEdit}
                                    //disabled={ isCheckinStatus == '1' ? true : false}
                                    id="garage"
                                    value={facilityId || resfacility || ''}
                                    onChange={(event) => handelGarage(event)}
                                  >
                                    {facility?.length > 1 && (
                                      <option value="">
                                        Select Parking Zone
                                      </option>
                                    )}
                                    {facility?.length > 0 &&
                                      facility?.map((v, i) => {
                                        return (
                                          <option key={i} value={v.id}>
                                            {v.full_name}
                                          </option>
                                        )
                                      })}
                                  </select>
                                )}
                              />
                              {errors?.garage && (
                                <span className="text-danger small">
                                  {errors?.garage?.message}
                                </span>
                              )}
                            </div>
                          </div>}
                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Start Date / Time{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="entry_time"
                                type="text"
                                id="entry_time"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}

                                render={() => (
                                  <div className='position-relative'>
                                    <DatePicker
                                      selected={entryDateTime}
                                      // isClearable
                                      onChange={(date) => handleEntryTime(date)}
                                      className="form-control "
                                      timeIntervals={15}
                                      autoComplete="off"
                                      disabled={(isCheckinStatus == '1' || diff < actionTime || applyPromoLoder || loaderPrice) ? true : false}
                                      id="entry_time"
                                      name="entry_time"
                                      showTimeSelect
                                      dateFormat="MMMM d, yyyy hh:mm aa"
                                      minDate={startDateTime}
                                      maxDate={maxstartDateTime}
                                      onKeyDown={(e) => {
                                        e.preventDefault()
                                      }}
                                      filterTime={maxstartDateTime != '' ? filterPassedTimeStart : filterPassedTime}
                                    // minTime={moment(entryDateTime).format('YYYY-MM-DD')>moment(new Date()).format('YYYY-MM-DD') ?setHours(setMinutes(entryDateTime,0), 0):setHours(setMinutes(entryDateTime.getMinutes(), moment(new Date()).format('ss')), entryDateTime.getHours())}
                                    // maxTime={setHours(setMinutes(entryDateTime, 30), 23)}
                                    />
                                    <i className='fa fa-calendar-alt text-gray position-absolute' style={{ top: '8px', right: '10px', pointerEvents: 'none', cursor: 'pointer' }} ></i>
                                  </div>
                                )}
                              />
                              {errors?.entry_time && (
                                <span className="text-danger small">
                                  {errors?.entry_time?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                End Date / Time{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="exit_time"
                                type="text"
                                id="exit_time"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={() => (
                                  <div className='position-relative'>
                                    <DatePicker
                                      selected={exitDateTime}
                                      onChange={(date) => handleExitTime(date)}
                                      // isClearable

                                      className="form-control"
                                      disabled={isCheckOutStatus || applyPromoLoder || loaderPrice}
                                      timeIntervals={15}
                                      autoComplete="off"
                                      id="exit_time"
                                      name="exit_time"
                                      showTimeSelect
                                      dateFormat="MMMM d, yyyy hh:mm aa"
                                      minDate={entryDateTime}
                                      // maxDate={maxEndDate}
                                      onKeyDown={(e) => {
                                        e.preventDefault()
                                      }}
                                      filterTime={filterPassedTimeEnd}

                                    // minTime={moment(exitDateTime).format('YYYY-MM-DD')>moment(entryDateTime).format('YYYY-MM-DD') ?setHours(setMinutes(exitDateTime, 0), 0):setHours(setMinutes(entryDateTime.getMinutes(), moment(entryDateTime).format('ss')), entryDateTime.getHours())}
                                    // maxTime={setHours(setMinutes(entryDateTime, 30), 23)}
                                    />
                                    <i className='fa fa-calendar-alt text-gray position-absolute' style={{ top: '8px', right: '10px', pointerEvents: 'none', cursor: 'pointer' }} ></i>
                                  </div>
                                )}
                              />
                              {errors?.exit_time && (
                                <span className="text-danger small">
                                  {errors?.exit_time?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          {/* EOS-5093 Amenities */}
                          {facilityRef?.current?.facility_configuration?.show_amenities && facilityRef?.current?.facility_configuration?.show_amenities == '1' && amenitiesList?.length > 0 ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">Amenities</label>
                              <Multiselect
                                options={amenitiesList} // Options to display in the dropdown
                                selectedValues={selectedAmenities} // Preselected value to persist in dropdown
                                onSelect={handleAmenitiesChange} // Function will trigger on select event
                                onRemove={handleAmenitiesChange} // Function will trigger on remove event
                                displayValue="amenity_label" // Property name to display in the dropdown options
                                showCheckbox={true}
                                emptyRecordMsg={'Amenities not found.'}
                                className='reservation-amenities'
                                placeholder='Select Amenities'
                                hidePlaceholder={true}
                                disable={applyPromoLoder || loaderPrice}
                                optionValueDecorator={(label, amenity) => amenity?.price ? `${label} - $${formatDecimal(amenity?.price)}` : label}
                                selectedValueDecorator={(label, amenity) => amenity?.price ? `${label} - $${formatDecimal(amenity?.price)}` : label}
                              />
                            </div>
                          </div> : null}
                          {/* EOS-5093 Amenities */}
                          {isPermissionExist(accessPermissions, 'Display Flight Details') ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">Departing Flight No <span className="text-danger">*</span></label>
                              <Controller
                                name="departure_flight_no"
                                type="text"
                                id="departure_flight_no"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="departure_flight_no"
                                    title="Flight"
                                    // unmask
                                    // rtl
                                    className="form-control"
                                    placeholder="Flight No"
                                    maxLength="10"
                                    onKeyPress={(e) => restrictSpecialChar(e)}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  // onChange={(e) => { field.onChange(e); removeSpecialChar(e) }}
                                  />
                                )}
                              />
                              {errors?.departure_flight_no && (
                                <span className="text-danger small">
                                  {errors?.departure_flight_no?.message}
                                </span>
                              )}
                            </div>
                          </div> : null}
                          {isPermissionExist(accessPermissions, 'Display Flight Details') ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">Departing Airline Name <span className="text-danger">*</span></label>
                              <Controller
                                name="departure_airline_name"
                                type="select"
                                id="departure_airline_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <select
                                    autoComplete="off"
                                    className="form-select"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="departure_airline_name"
                                    // selected={departure_airline_name ? departure_airline_name : ''}
                                    onChange={(event) => handelAirline(event)}
                                  >
                                    {airline?.length > 1 && (
                                      <option value="">
                                        Select Airline Name
                                      </option>
                                    )}
                                    {airline?.length > 0 &&
                                      airline?.map((v, i) => {
                                        return (
                                          <option key={i} value={v.name}>
                                            {v.name}
                                          </option>
                                        )
                                      })}
                                  </select>
                                )}
                              />
                              {/* <Controller
                                name="departure_airline_name"
                                type="text"
                                id="departure_airline_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="departure_airline_name"
                                    title="Flight"
                                    // unmask
                                    // rtl
                                    className="form-control"
                                    placeholder="Airline Name"
                                    maxLength="25"
                                    // onKeyPress={(e) => restrictSpecialChar(e)}
                                    onKeyPress={(e) => restrictSpecialChar(e, ['departure_airline_name'])}
                                  // onChange={(e) => { field.onChange(e); removeSpecialChar(e) }}
                                  />
                                )}
                              /> */}
                              {errors?.departure_airline_name && (
                                <span className="text-danger small">
                                  {errors?.departure_airline_name?.message}
                                </span>
                              )}
                            </div>
                          </div> : null}
                          {isPermissionExist(accessPermissions, 'Display Flight Details') ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">Arrival Flight No <span className="text-danger">*</span></label>
                              <Controller
                                name="arrival_flight_no"
                                type="text"
                                id="arrival_flight_no"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="arrival_flight_no"
                                    title="Flight"
                                    // unmask
                                    // rtl
                                    className="form-control"
                                    placeholder="Flight No"
                                    maxLength="10"
                                    onKeyPress={(e) => restrictSpecialChar(e)}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  // onChange={(e) => { field.onChange(e); removeSpecialChar(e) }}
                                  />
                                )}
                              />
                              {errors?.arrival_flight_no && (
                                <span className="text-danger small">
                                  {errors?.arrival_flight_no?.message}
                                </span>
                              )}
                            </div>
                          </div> : null}
                          {isPermissionExist(accessPermissions, 'Display Flight Details') ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">Arrival Airline Name <span className="text-danger">*</span></label>
                              <Controller
                                name="arrival_airline_name"
                                type="select"
                                id="arrival_airline_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <select
                                    autoComplete="off"
                                    className="form-select"
                                    {...field}
                                    disabled={isCheckOutStatus}
                                    //disabled={ isCheckinStatus == '1' ? true : false}
                                    id="arrival_airline_name"
                                    // selected={arrival_airline_name ? arrival_airline_name : ''}
                                    onChange={(event) => handelAirline(event)}
                                  >
                                    {airline?.length > 1 && (
                                      <option value="">
                                        Select Airline Name
                                      </option>
                                    )}
                                    {airline?.length > 0 &&
                                      airline?.map((v, i) => {
                                        return (
                                          <option key={i} value={v.name}>
                                            {v.name}
                                          </option>
                                        )
                                      })}
                                  </select>
                                )}
                              />
                              {/* <Controller
                                name="arrival_airline_name"
                                type="text"
                                id="arrival_airline_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="arrival_airline_name"
                                    title="Flight"
                                    // unmask
                                    // rtl
                                    className="form-control"
                                    placeholder="Airline Name"
                                    maxLength="25"
                                    // onKeyPress={(e) => restrictSpecialChar(e)}
                                    onKeyPress={(e) => restrictSpecialChar(e, ['arrival_airline_name'])}
                                  // onChange={(e) => { field.onChange(e); removeSpecialChar(e) }}
                                  />
                                )}
                              /> */}
                              {errors?.arrival_airline_name && (
                                <span className="text-danger small">
                                  {errors?.arrival_airline_name?.message}
                                </span>
                              )}
                            </div>
                          </div> : null}
                        </div>
                        {getConfigPermission(facilityRef?.current, 'display_parking_type_checkbox') && getConfigPermission(facilityRef?.current, 'enable_parking_type') && parkingType?.length > 0 ?
                          <div className="row g-3 row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 mb-3 mt-1">
                            {parkingType?.map((parking_type, index) => {
                              return <div className="col" key={index}>
                                <div
                                  className={`checkbox-tile ${selectedParkingType == parking_type?.id ? BookingEdit ? 'text-muted' : 'active' : BookingEdit ? 'd-none' : ''}`}
                                  onClick={() => isParkingTypeDisabled ? null : setSelectedParkingType(parking_type?.id)}
                                >
                                  <div>
                                    <h6 className="m-0">{parking_type.category}</h6>
                                    {/* OPTIONAL SUBTITLE 
                                    <p className="text-muted small m-0">Some description</p> 
                                    */}
                                  </div>
                                  <input
                                    type="checkbox"
                                    className="form-check-input tile-checkbox"
                                    checked={selectedParkingType == parking_type.id}
                                    readOnly
                                    disabled={BookingEdit}
                                  />
                                </div>
                              </div>
                            })}
                          </div> : null}

                        <div className={`border-top pt-3 d-flex align-items-center ${isParksfo() ? 'justify-content-end' : (!isLoggedIn()) ? 'justify-content-between' : 'justify-content-end'}`}>
                          {/* {logiSignUp()} */}
                          {isParksfo() ? null : !isLoggedIn() ? <LoginSignUpButton handleLoginModalOpen={handleLoginModalOpen} /> : null}

                          <NextPreviousButton walletButtonShow={walletButtonShow} verifyPrepay={verifyPrepay} page={page} isLoading={isLoading} nextPage={nextPage} prePage={prePage} />
                        </div>
                      </div>
                    )}

                    {page == 2 && (
                      <div id="step-2" className={`border p-3 bg-white ${page == 2 ? 'd-block' : 'd-none'}}`} >
                        {/* header */}
                        <div className='d-flex justify-content-between aling-items-center'>
                          <h4 className="m-0"> Customer Details </h4>
                          {((isPermissionExist(accessPermissions, 'On Behalf') && isLoggedIn() && onBehalfButtonShow)) &&
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" onClick={(e) => loggedInUser(e.target.checked)} checked={BookingEditData?.on_behalf || isOnBehalfExist} disabled={BookingEditData?.on_behalf} />
                              <label className="form-check-label fw-bold" htmlFor="flexCheckDefault">On Behalf</label>
                            </div>}
                        </div>
                        {/* header end */}
                        {/* input fields for the customer Details */}
                        <div className="row g-2 row-cols-md-2 row-cols-lg-3 row-cols-sm-2 row-cols-1 ">
                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                First Name <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="first_name"
                                type="text"
                                id="first_name"
                                control={control}
                                value={getValues?.first_name}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="first_name"
                                    placeholder="First Name"
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                    onKeyPress={(e) => { allowalphabetical(e); handleKeyPressRestrictLeadingTrailingSpace(e) }}
                                  />
                                )}
                              />
                              {errors?.first_name && (
                                <span className="text-danger small">
                                  {errors?.first_name?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Last Name <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="last_name"
                                type="text"
                                id="last_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}

                                    id="last_name"
                                    placeholder="Last Name"
                                    onKeyPress={(e) => { allowalphabetical(e); handleKeyPressRestrictLeadingTrailingSpace(e) }}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  />
                                )}
                              />
                              {errors?.last_name && (
                                <span className="text-danger small">
                                  {errors?.last_name?.message}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Email Address{' '}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="email"
                                type="text"
                                id="email"

                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },

                                  pattern: {
                                    // value:
                                    //   /^[A-Z0-9._%+-]+@[A-Z0-9-]+\.[A-Z]{2,}$/i,
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9-]+(?!.*?[.]{2})[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Please enter a valid Email Address',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={ismobileEmailEnabled}
                                    id="email"
                                    placeholder="Email Address"
                                    onChange={(e) => { field.onChange(e); handleEmailChange(e) }}
                                  //onChange={(event) => field.onChange(handleInputChange(event))}
                                  />
                                )}
                              />
                              {errors?.email && (
                                <span className="text-danger small">
                                  {errors?.email?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Phone Number{' '}
                                <span className="text-danger">*</span>
                              </label>
                              {/* <input type="number" className="form-control" /> */}
                              <Controller
                                name="phone"
                                type="text"
                                id="phone"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                  pattern: {
                                    value: validPhone,
                                    message: 'Please enter a valid phone number',
                                  },
                                  // minLength: {
                                  //   value: 10,
                                  //   message: 'Minimum 10 characters allowed',
                                  // },
                                  // maxLength: {
                                  //   value: 14,
                                  //   message: 'Maximum 10 characters allowed',
                                  // },
                                }}
                                render={({ field }) => (
                                  <MaskedInput
                                    maskGenerator={phoneMask}
                                    // autoComplete="off"
                                    maxLength={14}
                                    minLength={10}
                                    {...field}
                                    disabled={ismobileEmailEnabled && validatePhone(defaultPhone)}
                                    value={getValues().phone}
                                    // value={mobile ? mobile : ''}
                                    title="Phone number should be 10 digit numeric"
                                    className="form-control"
                                    //isValidating={true}
                                    onInvalid={(e) =>
                                      e.target.setCustomValidity(
                                        'Please enter a valid phone number'
                                      )
                                    }
                                    onInput={(e) =>
                                      e.target.setCustomValidity('')
                                    }
                                    placeholder="Phone Number"
                                    onChange={(e) => { field.onChange(e); handlePhoneNumber(e) }}
                                  />
                                )}
                              />

                              {errors?.phone && (
                                <span className="text-danger small">
                                  {errors?.phone?.message}
                                </span>
                              )}

                            </div>
                          </div>

                          {/* other information */}

                          {isPermissionExist(accessPermissions, 'Enable Company Name') ? <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Company Name
                              </label>
                              <Controller
                                name="company_name"
                                type="text"
                                id="company_name"
                                control={control}
                                rules={{
                                  required: {
                                    value: false,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}

                                    id="company_name"
                                    placeholder="Company Name"
                                    maxLength="20"
                                    onKeyPress={(e) => allowalphabetical(e)}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  />
                                )}
                              />
                              {errors?.company_name && (
                                <span className="text-danger small">
                                  {errors?.company_name?.message}
                                </span>
                              )}
                            </div>
                          </div> : null}

                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Address 1 <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="address"
                                type="text"
                                id="address"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}

                                    id="address"
                                    placeholder="Address 1"
                                    maxLength="70"
                                    onKeyPress={(e) => restrictSpecialChar(e, ['address'])}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  />
                                )}
                              />
                              {errors?.address && (
                                <span className="text-danger small">
                                  {errors?.address?.message}
                                </span>
                              )}
                            </div>
                          </div>}

                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label"> Address 2 </label>
                              <Controller
                                name="address2"
                                type="text"
                                id="address2"
                                control={control}
                                rules={{
                                  required: {
                                    value: false,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}

                                    id="address2"
                                    placeholder="Address 2"
                                    maxLength="70"
                                    onKeyPress={(e) => restrictSpecialChar(e, ['address2'])}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  />
                                )}
                              />
                              {errors?.address2 && (
                                <span className="text-danger small">
                                  {errors?.address2?.message}
                                </span>
                              )}
                            </div>
                          </div>}

                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                City <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="city"
                                type="text"
                                id="city"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    autoComplete="off"
                                    className="form-control"
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}

                                    id="city"
                                    placeholder="City"
                                    maxLength="20"
                                    onKeyPress={(e) => allowalphabetical(e)}
                                    onChange={(e) => { field.onChange(e); handelchangeInput(e) }}
                                  />
                                )}
                              />
                              {errors?.city && (
                                <span className="text-danger small">
                                  {errors?.city?.message}
                                </span>
                              )}
                            </div>
                          </div>}
                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null :
                            <div className="w-full">
                              <label className="form-label"> Country <span className="text-danger">*</span> </label>
                              <Controller
                                name="country"
                                id='country'
                                control={control}
                                defaultValue=""
                                className='form-select'
                                rules={{ required: { value: true, message: 'This field is required' } }}
                                render={({ field }) => <select type="select" className='form-select' {...field} name='country' disabled={isCheckinStatus == '1' ? true : false} id='country' onChange={(e) => { field.onChange(e); handleCountryChange(e) }} >
                                  <option value=''>Select Country</option>
                                  {countryData?.map((item, index) => {
                                    return <option key={(index + 1)} value={item?.name} >{item?.name}</option>
                                  })}
                                </select>}
                              />
                              {errors?.country && (<span className="text-danger small">{errors?.country?.message} </span>)}
                              {/* {errors?.country?.type === 'required' && <span className="text-danger">This field is required</span>} */}
                            </div>}
                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                State <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="state"
                                id='state'
                                control={control}
                                defaultValue=""
                                className='form-select'
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                  },
                                }}
                                render={({ field }) => <select onChange={(e) => { field.onChange(e); handleState(e) }} className='form-select' name="state" id='state'  {...field} disabled={isCheckinStatus == '1' ? true : false}>
                                  <option value=''>Select an option</option>
                                  {(vehicleDetailsList?.state)?.map((item, itemIndex) => <option key={(itemIndex + 1)} selected={item?.id == getValues()?.state || item?.state_code == getValues()?.state} value={item?.state_code}>{item?.state_code}</option>)}                              </select>}
                              />
                              {errors?.state && (
                                <span className="text-danger small">
                                  {errors?.state?.message}
                                </span>
                              )}
                              {/* {errors?.state?.type === 'required' && <span className="text-danger">This field is required</span>} */}
                            </div>
                          </div>}
                          {isPermissionExist(accessPermissions, 'Hide Address Fields') ? null : <div className="col">
                            <div className="mb-1">
                              <label className="form-label">
                                Zip/Postal Code <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="pincode"
                                type="text"
                                id="pincode"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: 'This field is required',
                                    validate: (value) => value.trim()?.length > 4 && value.trim()?.length < 7,
                                  },
                                  minLength: {
                                    value: 5,
                                    message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed',
                                  },
                                  maxLength: {
                                    value: 6,
                                    message: isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Maximum 6 characters allowed' : 'Maximum 6 numbers allowed',
                                  },
                                }}
                                render={({ field }) => (
                                  <input
                                    name="pincode"
                                    autoComplete="off"
                                    className="form-control"
                                    maxLength={6}
                                    minLength={5}
                                    {...field}
                                    disabled={isCheckinStatus == '1' ? true : false}
                                    id="pincode"
                                    placeholder="Enter Zip/Postal Code"
                                    onChange={(e) => { field.onChange(e); handlezipcode(e) }}

                                  />
                                )}
                              />
                              {errors?.pincode && (
                                <span className="text-danger small">
                                  {errors?.pincode?.message}
                                </span>
                              )}
                              {errors?.pincode?.type === 'minLength' &&
                                <span className="text-danger small"> Please enter a valid pincode</span>
                              }
                            </div>
                          </div>}


                        </div>
                        {/* input fields end */}
                        {/* fotter */}
                        <div className={`border-top pt-3 d-flex align-items-center ${isParksfo() ? 'justify-content-end' : (!isLoggedIn()) ? 'justify-content-between' : 'justify-content-end'}`}>
                          {isParksfo() ? null : !isLoggedIn() ? <LoginSignUpButton handleLoginModalOpen={handleLoginModalOpen} /> : null}
                          <NextPreviousButton walletButtonShow={walletButtonShow} verifyPrepay={verifyPrepay} page={page} isLoading={isLoading} nextPage={nextPage} prePage={prePage} />
                        </div>
                        {/* fotter end */}
                      </div>
                    )}

                    {page == 3 && (
                      <div

                        id="step-3"
                        className={`border p-3 bg-white ${page == 3 ? 'd-block' : 'd-none'
                          }}`}
                      >
                        <h4 className="mb-0  mb-3"> Vehicle Details </h4>

                        <div className="clearfix">
                          {/* save vehical */}

                          {/* vehical */}

                          {isLoggedIn() && vehicleList?.length > 0 && (
                            <div className="row g-2 row-cols-md-2 row-cols-lg-3 row-cols-sm-2 row-cols-1">
                              {vehicleList?.length > 0 && (
                                <div className="col">
                                  <div className="mb-1">
                                    <Controller

                                      name="vehicle"
                                      type="select"
                                      id="vehicle"
                                      control={control}
                                      rules={{
                                        required: {
                                          value: !isVehicleTableVisible,
                                          message: 'This field is required',
                                        },
                                      }}
                                      render={({ field }) => (
                                        <select
                                          {...field}
                                          disabled={isVehicleTableVisible || (isCheckinStatus == '1' ? true : false)}
                                          autoComplete="off"
                                          className="form-select"

                                          id="vehicle"
                                          selected={vehicalId}
                                          onChange={(event) =>
                                            handleVehicleChange(event)
                                          }
                                        >
                                          {vehicleList.length > 1 || isVehicleTableVisible ? <option value="">
                                            Select Vehicle
                                          </option> : null}

                                          {vehicleList?.map((vehicle, index) => {
                                            return (
                                              <option
                                                value={
                                                  vehicle?.id
                                                }
                                                key={index}
                                              >
                                                {vehicle?.license_plate_number}
                                              </option>
                                            )
                                          })}
                                        </select>
                                      )}
                                    />
                                    {errors?.vehicle && (
                                      <span className="text-danger small">
                                        {errors?.vehicle?.message}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                              {vehicleList?.length > 0 &&
                                <div className="col">
                                  <span className="badge badge-primary text-dark fw-bold me-2">
                                    OR
                                  </span>

                                  <button
                                    disabled={facilityMaxVehicle && (vehicleList?.length >= facilityMaxVehicle)}
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={showVehicleTable}
                                  >
                                    <i className="fa fa-plus"></i> Add New vehicle
                                  </button>
                                </div>}
                            </div>
                          )}

                          {(isVehicleTableVisible) &&
                            <div className='bg-light p-3 mb-3 border position-relative'>
                              <div className="row g-2 row-cols-md-2 row-cols-lg-3 row-cols-sm-2 row-cols-1  ">
                                <div className="col">
                                  <div className="mb-1">
                                    <label className="form-label">
                                      License Plate
                                      <span className="text-danger">*</span>
                                    </label>
                                    {/* <div
                                      className={
                                        showVehicleTable && isLoggedIn()
                                          ? 'input-group'
                                          : ''
                                      }
                                    > */}
                                    <div
                                      className={
                                        showVehicleTable && isLoggedIn()
                                          ? ''
                                          : ''
                                      }
                                    >
                                      <Controller
                                        name="license_plate"
                                        type="text"
                                        id="license_plate"
                                        control={control}
                                        rules={{
                                          required: {
                                            value: true,
                                            message: 'This field is required',
                                          },
                                          minLength: {
                                            value: 1,
                                            message: 'Minimum 1 characters allowed',
                                          },
                                          maxLength: {
                                            value: 10,
                                            message: 'Maximum 10 characters allowed',
                                          },
                                        }}
                                        render={({ field }) => (
                                          <input
                                            autoComplete="off"
                                            {...field}
                                            name="license_plate"
                                            disabled={isCheckinStatus == '1' ? true : false}
                                            id="license_plate"
                                            title="License Plate should be 10 digit"
                                            className="form-control"
                                            placeholder="License Plate"
                                            maxLength="10"
                                            onChange={(e) => handleLicenseChange(e)}
                                            onKeyPress={(e) => {
                                              handleKeyPressRestrictLeadingTrailingSpace(e, true)
                                            }}
                                          />
                                        )}
                                      />
                                      {errors?.license_plate && (<span className="text-danger small">{errors?.license_plate?.message}</span>)}


                                    </div>
                                  </div>


                                </div>
                                {isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') ? <div className="col">
                                  <div className="mb-1">
                                    <label className="form-label">Vehicle Make {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                    <Controller
                                      name="make"
                                      id="make"
                                      defaultValue=""
                                      className='form-select'
                                      control={control}
                                      rules={{
                                        required: {
                                          value: isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true,
                                          message: 'This field is required',
                                        },
                                      }}
                                      render={({ field }) => (
                                        <select name="make" className="form-select"  {...field} disabled={isCheckinStatus == '1' ? true : false} id="make" onChange={(e) => { field.onChange(e); handleVehicalMakeChange(e) }}>
                                          <option value="">Select an option</option>
                                          {(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
                                            return (<option value={val?.id} key={index} >{val?.name}</option>)
                                          })}
                                        </select>
                                      )}
                                    />
                                    {errors?.make && (<span className="text-danger small">{errors?.make?.message}</span>)}
                                  </div>
                                </div> : null}


                                {isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') ? <div className="col">
                                  <div className="mb-1">
                                    <label className="form-label">Vehicle Model {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                    <Controller
                                      name="model"
                                      id='model'
                                      control={control}
                                      defaultValue=""
                                      className='form-select'
                                      rules={{
                                        required: {
                                          value: isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true,
                                          message: 'This field is required',
                                        },
                                      }}
                                      render={({ field }) => <select className='form-select' name="model" id='model' {...field} disabled={isCheckinStatus == '1' ? true : false} onChange={(e) => { field.onChange(e); handleVehicalModelChange(e) }} >
                                        <option value="">Select an option</option>
                                        {vehicleModelList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.name}</option>)}
                                      </select>} />
                                    {errors?.model && (<span className="text-danger small">  {errors?.model?.message}  </span>)}
                                  </div>
                                </div> : null}

                                {/* vehicle type */}
                                {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <div className="w-full">
                                  <label className="form-label">Vehicle Type <span className="text-danger">*</span></label>
                                  <Controller
                                    name="vehicle_type"
                                    id='vehicle_type'
                                    control={control}
                                    defaultValue=""
                                    className='form-select'
                                    rules={{ required: { value: true, message: 'This field is required' } }}
                                    render={({ field }) => <select className='form-select' {...field} disabled={isCheckinStatus == '1' ? true : false} name="vehicle_type" id='vehicle_type' onChange={(e) => { field.onChange(e); handleVehicleTypeChange(e) }}>
                                      <option value="">Select an option</option>
                                      {vehicleDetailsList?.vehicletype?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.name}</option>)}
                                    </select>} />
                                  {errors?.vehicle_type && (<span className="text-danger small">  {errors?.vehicle_type?.message} </span>)}
                                </div> : null}
                                {/* vehicle type end */}

                                {isPermissionExist(accessPermissions, 'Get Vehicle Color') ? <div className="col">
                                  <div className="mb-1">
                                    <label className="form-label">Vehicle Color {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                    <Controller
                                      name="color"
                                      id='color'
                                      control={control}
                                      defaultValue=""
                                      className='form-select'
                                      rules={{
                                        required: {
                                          value: isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true,
                                          message: 'This field is required',
                                        },
                                      }}
                                      render={({ field }) => <select className='form-select' {...field} disabled={isCheckinStatus == '1' ? true : false} name="color" id='color' onChange={(e) => { field.onChange(e); handleVehicalColorChange(e) }} >
                                        <option value="">Select an option</option>
                                        {vehicleDetailsList.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.name}</option>)}
                                      </select>} />
                                    {errors?.color && (<span className="text-danger small">  {errors?.color?.message} </span>)}
                                  </div>
                                </div> : null}
                                {isPermissionExist(accessPermissions, 'Get Vehicle State') ? isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ?
                                  <div className="w-full">
                                    <label className="form-label">Country {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                    <Controller
                                      name="vehicle_country"
                                      id='vehicle_country'
                                      control={control}
                                      defaultValue=""
                                      className='form-select'
                                      rules={{ required: { value: isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true, message: 'This field is required' } }}
                                      render={({ field }) => <select type="select" className='form-select' {...field} name='vehicle_country' disabled={isCheckinStatus == '1' ? true : false} id='vehicle_country' onChange={(e) => { field.onChange(e); handleVehicalCountryChange(e) }} >
                                        <option value=''>Select Country</option>
                                        {countryData?.map((item, index) => {
                                          return <option key={(index + 1)} value={item?.country_code} >{item?.name}</option>
                                        })}
                                      </select>}
                                    />
                                    {/* <select className='form-select ' {...field}  required={isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true} placeholder="Country" name="vehicle_country" id='vehicle_country' onChange={(e) => handleVehicalCountryChange(e)}>
                                        <option value=''>Select an option</option>
                                        {(vehicleDetailsList?.country?.length > 0) && vehicleDetailsList?.country?.map((item, itemIndex) => {
                                          if (item?.country_code == 'US' || item?.country_code == 'CA' || item?.country_code == 'GB') {
                                            return <option key={(itemIndex + 1)} value={item?.country_code}>{item?.name}</option>
                                          }
                                        }
                                        )}
                                      </select> */}

                                    <span className="form-text text-danger h-40">{page == 3 && errors?.vehicle_country ? 'This field is required' : ''}</span>
                                  </div> : '' : null}
                                {isPermissionExist(accessPermissions, 'Get Vehicle State') ? <div className="col">
                                  <div className="mb-1">
                                    <label className="form-label">Vehicle State/Province {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                    <Controller
                                      name="state_id"
                                      id='state_id'
                                      control={control}
                                      defaultValue=""
                                      className='form-select'
                                      rules={{
                                        required: {
                                          value: isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? false : true,
                                          message: 'This field is required',
                                        },
                                      }}
                                      render={({ field }) => <select className='form-select' {...field} disabled={isCheckinStatus == '1' ? true : false} name="state_id" id='state_id' onChange={(e) => { field.onChange(e); handleVehicalStateIDChange(e) }}  >
                                        <option value="">Select an option</option>
                                        {vehicleDetailsState.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                      </select>} />
                                    {errors?.state_id && (
                                      <span className="text-danger small">
                                        {
                                          errors?.state_id
                                            ?.message
                                        }
                                      </span>
                                    )}
                                  </div>
                                </div> : null}



                                <div className=" col pt-5">
                                  {isLoggedIn() ? (
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="isLicensePlate"
                                        name="isLicensePlate"
                                        onClick={() =>
                                          setIsLicensePlate(!isLicensePlate)
                                        }
                                        checked={isLicensePlate}
                                      />

                                      <small>Set as default</small>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                              </div>

                              {isLoggedIn() && vehicleList?.length > 0 ? (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger  btn btn-sm btn-danger  position-absolute top-0 end-0 "
                                  onClick={() => removeVehicleMake()}
                                >
                                  <i className="fa fa-minus"></i>
                                </button>
                              ) : null}

                            </div>
                          }

                          {isPermissionExist(accessPermissions, 'Enable oversize-fee - Reservation') ? <div className="py-2">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" onClick={() => { !BookingEdit ? setIsVehicleOverSize(!isVehicleOversize) : null }} id="vehicleOversize" checked={isVehicleOversize} disabled={BookingEdit} />
                              <label className="form-check-label font-normal" >
                                Oversized vehicle?
                              </label>
                            </div>
                          </div> : null}

                          {/*vehical end */}

                          <div className={`border-top pt-3 d-flex align-items-center ${isParksfo() ? 'justify-content-end' : (!isLoggedIn()) ? 'justify-content-between' : 'justify-content-end'}`}>

                            {isParksfo() ? null : !isLoggedIn() ? <LoginSignUpButton handleLoginModalOpen={handleLoginModalOpen} /> : null}
                            <NextPreviousButton walletButtonShow={walletButtonShow} verifyPrepay={verifyPrepay} page={page} isLoading={isLoading} nextPage={nextPage} prePage={prePage} />

                          </div>
                        </div>
                      </div>
                    )}

                    {page == 4 && (
                      <div
                        id="step-4"
                        className={`border p-3 bg-white ${page == 4 ? 'd-block' : 'd-none'
                          }}`}
                      >
                        {((lengthPlusMinus == '0' && facilityRef?.current?.facility_configuration?.is_process_fee_charged != '1') || !usesHostedCardFields(facilityRef?.current) || ![PAYMENT_GATEWAY.DATACAP, PAYMENT_GATEWAY.STRIPE].includes(String(facilityRef?.current?.facility_payment_details?.facility_payment_type_id))) ? <h4 className="mb-0  mb-3">{lengthPlusMinus == '0' && priceDetails?.refundFlag == '1' && facilityRef?.current?.facility_configuration?.is_process_fee_charged != '1' ? 'Refund' : 'Payment Details'}</h4> : null}
                        {/* <h4 className="mb-0  mb-3">{lengthPlusMinus == '0' && priceDetails?.refundFlag=='1' && facilityRef?.current?.facility_configuration?.is_process_fee_charged != '1' ? 'Refund' : 'Payment Details'}</h4> */}

                        <div className="clearfix">

                          {/* Pay Now or Pay Later */}

                          {facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1 && !paymentDisable ?
                            <div className="row g-3 row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 mb-3 mt-1">
                              {/* Hiding "Pay Now and only enable Pay later option for now", as of Deployment Plan and Suggested by Rajiv Sir and Vishal sir 14/04/2026 */}
                              <div className="col d-none">
                                <div
                                  className={`checkbox-tile ${selectedPaymentType == '1' ? 'active' : ''}`}
                                  onClick={() => setSelectedPaymentType('1')}
                                >
                                  <div>
                                    <h6 className="m-0">Pay Now</h6>
                                  </div>
                                  <input
                                    type="checkbox"
                                    className="form-check-input tile-checkbox"
                                    checked={selectedPaymentType == '1'}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col">
                                <div
                                  className={`checkbox-tile ${selectedPaymentType == '0' ? 'active' : ''}`}
                                  onClick={() => setSelectedPaymentType('0')}
                                >
                                  <div>
                                    <h6 className="m-0">Pay Later</h6>
                                  </div>
                                  <input
                                    type="checkbox"
                                    className="form-check-input tile-checkbox"
                                    checked={selectedPaymentType == '0'}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div> : null}

                          {/* Pay Now or Pay Later */}

                          {/* save card */}
                          {/* Card / saved card / gateway fields: in the payment modal (Proceed To Pay) */}

                          {selectedPaymentType == 0 && !paymentDisable && isParksfo() ? <>
                            <div className="row g-2 row-cols-md-2 row-cols-lg-2 row-cols-sm-2 row-cols-1 d-none">
                              <div className="col">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Card Last Four Digits{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="d-block position-relative ">
                                    <Controller
                                      name="card_number"
                                      type="text"
                                      id="card_number"
                                      control={control}
                                      rules={{
                                        required: {
                                          value: false,
                                          message: 'This field is required'
                                        },
                                        minLength: {
                                          value: 4,
                                          message:
                                            'Minimum 4 characters allowed',
                                        },
                                        maxLength: {
                                          value: 4,
                                          message: 'Maximum 4 characters allowed'
                                        },
                                      }}
                                      render={({ field }) => (
                                        <MaskedInput
                                          maskGenerator={cardlastFournumbermask}
                                          autoComplete="off"
                                          pattern="[0-9 ]{4}"
                                          maxLength="4"
                                          minLength={4}
                                          {...field}
                                          onChange={(e) => { field.onChange(e); handleCardNumber(e) }}
                                          id="card_number"
                                          title="Card Number should be 4 digit"
                                          className="form-control"
                                          value={cardNumber}
                                          onInvalid={(e) =>
                                            e.target.setCustomValidity(
                                              'Please enter a valid card number'
                                            )
                                          }
                                          onInput={(e) =>
                                            e.target.setCustomValidity('')
                                          }
                                          placeholder="Card Last Four Digits"
                                        />
                                      )}
                                    />


                                    <i className=" fa text-primary fa-credit-card me-2 position-absolute top-50 end-0 translate-middle-y"></i>
                                  </div>
                                  {errors?.card_number && (
                                    <span className="text-danger small">
                                      {errors?.card_number?.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="col">
                                <div className="mb-1">
                                  <label className="form-label">
                                    Expiry Date{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Controller
                                    name="card_expiry"
                                    type="text"
                                    id="card_expiry"
                                    control={control}
                                    rules={{
                                      required: {
                                        value: false,
                                        message: 'This field is required',
                                      },
                                      minLength: {
                                        value: 4,
                                        message:
                                          'Minimum 4 characters allowed',
                                      },
                                      maxLength: {
                                        value: 5,
                                        message:
                                          'Maximum 4 characters allowed',
                                      },
                                    }}
                                    render={({ field }) => (
                                      <MaskedInput
                                        maskGenerator={expirymask}
                                        autoComplete="off"
                                        pattern="(?:0?[1-9]|1[0-2])/[0-9 ]{2}"
                                        {...field}
                                        maxLength={5}
                                        minLength={4}
                                        id="card_expiry"
                                        onChange={(e) => { field.onChange(e); handlCardExpiry(e) }}
                                        value={cardExpiry}
                                        className="form-control"
                                        onInvalid={(e) =>
                                          e.target.setCustomValidity(
                                            'Please enter MM/YY format card expiry date'
                                          )
                                        }
                                        onInput={(e) =>
                                          e.target.setCustomValidity('')
                                        }
                                        placeholder="MM/YY"
                                      />
                                    )}
                                  />
                                  {errors?.card_expiry && (
                                    <span className="text-danger small">
                                      {errors?.card_expiry?.message}
                                    </span>
                                  )}
                                  {<span className="text-danger small">
                                    {cardExpiryMessage}
                                  </span>}
                                </div>
                              </div>

                            </div>
                          </> : null}

                          {facilityRef?.current?.facility_configuration?.is_process_fee_charged == '1' ? <div className="block my-2">
                            <p>Estimated Parking Payment ${priceDetails?.payable_amount
                              ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : formatDecimal(priceDetails?.payable_amount)
                              : formatDecimal(0)}{' '}</p>
                            <p>Parking payment will be collected at exit based on actual time parked.</p>
                          </div> : null}
                          {(page == 4) ? <div className="block my-2">
                            {BookingEdit && lengthPlusMinus == '0' && priceDetails?.refund_amount > 0 && <div className="block my-2">
                              <label className="form-check-label fw-normal">
                                Your refund will be credited to card no ending with xxxx{BookingEditData?.transaction?.payment_last_four} , expiry {BookingEditData?.transaction?.expiration}.
                              </label>
                            </div>}

                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              id="termCondition"
                              name="termCondition"
                              onClick={() => setTermCondition(!termCondition)}
                              checked={termCondition}
                            />

                            <>I have read and agreed to the {partnerDetails?.term_condition_heading ? partnerDetails?.term_condition_heading : 'ParkEngage'}   <a href='javascript:;' onClick={handleModalTerm}>Terms & Conditions</a>.</>

                          </div> : null}


                          <div className={`border-top pt-3 d-flex align-items-center ${isParksfo() ? 'justify-content-end' : (!isLoggedIn()) ? 'justify-content-between' : 'justify-content-end'}`}>
                            {isParksfo() ? null : !isLoggedIn() ? <LoginSignUpButton handleLoginModalOpen={handleLoginModalOpen} /> : null}
                            <div className="clearfix d-flex align-items-center justify-content-end">
                              <button
                                className="btn btn-primary me-sm-2 btn-sm text-white"
                                onClick={prePage}
                                type="button"
                                disabled={isSubmit || isLoading}
                              >
                                <i className="fa fa-arrow-left"></i>{' '}
                                <span className="d-none d-sm-inline-block">
                                  Previous{' '}
                                </span>
                              </button>
                              {/* && facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1 */}
                              {paymentModalFlow ? <button
                                className="btn btn-primary btn-sm"
                                onClick={handleProceedToPay}
                                type="button"
                                disabled={isLoading || !isReady || (BookingEdit && !bookingEditStatus)}
                              >
                                Proceed To Pay
                              </button> : !isCheckOutStatus && <button
                                className="btn btn-primary x d-none d-sm-block   btn-sm"
                                //s onClick={nextPage}
                                disabled={isLoading || !isReady || (BookingEdit && !bookingEditStatus)}
                                type="submit"
                                name="submit"
                              >
                                <div className='d-flex  justify-content-center align-items-centerd'>
                                  <span>
                                    {paymentDisable || facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1
                                      ? 'Confirm & Book'
                                      : 'Confirm & Pay'}
                                  </span>
                                  {page == 4 && (
                                    <span className="ms-2">
                                      {isLoading && isSubmit ? (
                                        <Circles
                                          height="20"
                                          width="20"
                                          style={{ display: 'inline-block' }}
                                          color="#ffffff"
                                          ariaLabel="circles-loading"
                                          visible={true}
                                        />
                                      ) : null}
                                    </span>
                                  )}
                                </div>
                              </button>}



                            </div>
                          </div>
                          {(!isCheckOutStatus && page != 4) && <button style={{ width: '100%' }}
                            className="btn btn-primary  mt-2 d-block d-sm-none   btn-sm"
                            disabled={isLoading || !isReady}
                            type="submit"
                            name="submit"
                          >
                            <div className='d-flex   w-100  justify-content-center align-items-center'>
                              <span>
                                {paymentDisable || facilityRef?.current?.facility_configuration?.enable_pay_now_selection == 1
                                  ? 'Confirm & Book'
                                  : 'Confirm & Pay'}
                              </span>
                              {page == 4 && (
                                <span className="ms-2">
                                  {isLoading && isSubmit ? (
                                    <Circles
                                      height="20"
                                      width="20"
                                      style={{ display: 'inline-block' }}
                                      color="#ffffff"
                                      ariaLabel="circles-loading"
                                      visible={true}
                                    />
                                  ) : null}
                                </span>
                              )}
                            </div>
                          </button>}
                          {(Number(priceDetails?.parking_amount) > 0 && walletButtonShow && !paymentModalFlow) ? <>
                            <div className="my-3 fw-bold text-center">- OR -</div>

                            <div className='d-flex justify-content-center'>
                              <div className='position-relative'>
                                {!termCondition ? <div className='overlay_terms_cond position-absolute' role='button' onClick={() => onSubmit({ ...getValues() }, '', true)}>&nbsp;</div> : null}
                                {(walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null}
                                <WalletButtons key={priceDetails?.payable_amount} faciltyData={facilityRef?.current} getValues={getValues} onSubmit={onSubmit} isSubmittingForm={isLoading} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={priceDetails?.payable_amount} notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} />
                              </div>
                            </div>
                          </> : ''}
                          {paymentModalFlow && <PaymentMethodModal
                            show={isPaymentModalOpen}
                            onHide={closePaymentModal}
                            isPaymentLocked={isLoading && isSubmit}
                            isSubmitting={isLoading && isSubmit}
                            paybyCardorWallet={true}
                            tab={paymentTab}
                            onTabChange={handlePaymentTabChange}
                            currentSelCard={currentSelCard}
                            amount={priceDetails?.payable_amount}
                            cardContent={newCardContent}
                            savedCardContent={savedCardContent}
                            // Apple Pay / Google Pay tab: by the facility configuration (as on the page)
                            walletButtonShow={walletContent ? true : false}
                            showApplePayButton={facilityRef?.current?.facility_configuration?.show_apple_pay_button}
                            showGooglePayButton={facilityRef?.current?.facility_configuration?.show_google_pay_button}
                            isIOSDevice={isIOSDevice}
                            walletContent={walletContent}
                          />}


                        </div>
                      </div>
                    )}
                    {isPermissionExist(accessPermissions, 'Display Disclaimer Note') ? getDisclaimerNote(facilityName, partnerDetails) : null}
                  </>
                </div>





                {/* cart details */}
                <div className="col-md-5 col-lg-4">
                  <div className="border bg-white">
                    {isPermissionExist(accessPermissions, 'Add Policy Url') ? <p className='mb-1 m-0 fw-bold'> <a href={`${usmLInk}`} target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small p-1 w-100 d-block border-bottom m-0"><i className='fa fa-link me-2'></i>Click For: {usmLInkMsg ? usmLInkMsg : ''} </a> </p> : ''}

                    {facilityName ? <div className=' p-3 '>
                      <h5 className='fw-bold m-0'>{facilityName} <p>{facilityRef?.current?.geolocations?.city} {facilityRef?.current?.geolocations?.state}</p></h5>

                    </div> : null}

                    <div className=" px-2 bg-light py-1 border-top border-bottom">
                      <div className='row '>
                        <div className='col text-center border-end'>
                          <small className="text-xs mb-1 fw-bold">
                            Entry Date / Time
                          </small>

                          <div className='d-flex gap-1  align-items-center justify-content-center'>
                            {/* en-CA */}
                            <small>
                              {entryDateTime
                                ? ('0' + (entryDateTime?.getMonth() + 1)).slice(
                                  -2
                                ) +
                                '-' +
                                ('0' + (entryDateTime?.getDate())).slice(
                                  -2
                                ) +
                                '-' +
                                entryDateTime?.getFullYear()
                                : '-'}
                            </small>
                            <br className='d-block d-sm-none' />
                            <small>{entryDateTime ? formatAMPM(entryDateTime) : '-'}</small>
                          </div>
                        </div>
                        <div className='col text-center'>
                          <small className="text-xs mb-1 fw-bold">
                            Exit Date / Time
                          </small>

                          <div className='d-flex gap-1  align-items-center justify-content-center'>
                            {/* en-CA */}
                            <small>


                              {exitDateTime
                                ? (
                                  '0' +
                                  (new Date(exitDateTime)?.getMonth() + 1)
                                ).slice(-2) +
                                '-' +
                                (
                                  '0' +
                                  (new Date(exitDateTime)?.getDate())
                                ).slice(-2) +
                                '-' +
                                new Date(exitDateTime)?.getFullYear()
                                : '-'}
                            </small>
                            <br className='d-block d-sm-none' />
                            <small>{exitDateTime ? formatAMPM(exitDateTime) : '-'}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Enable Auto Apply Coupon EOS-701 */}
                    {isPermissionExist(accessPermissions, 'Display Promocode') ?
                      // Use Third Party Coupons
                      facilityRef?.current?.facility_configuration?.enable_third_party_coupons == 1 ?
                        // Display Dropdown
                        (facilityRef?.current?.facility_configuration?.enable_coupon_selection == 1 && validationCodes?.length > 0 && facilityRef?.current?.facility_configuration?.enable_promo_auto_apply == 0) ?
                          <div className="row g-3 row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-1 mb-3 mt-1 ms-2 me-2">
                            <div className="mb-1">
                              <label className="form-label">
                                Coupon Code
                              </label>
                              <Controller
                                name="validation_code"
                                type="select"
                                id="validation_code"
                                control={control}
                                render={({ field }) => (
                                  <select
                                    key={resetKey}
                                    defaultValue=""
                                    autoComplete="off"
                                    className="form-select"
                                    {...field}
                                    disabled={isSubmit || applyPromoLoder || loaderPrice || (BookingEdit && !isParksfo())}
                                    //disabled={ isCheckinStatus == '1' ? true : false}
                                    id="garage"
                                    value={(BookingEdit && lengthPlusMinus != '0' && selectedValidationCode?.length > 0) ? BookingEditData?.promocode : getValues('promo_code')}
                                    // value={promocode}
                                    onChange={(event) => handleValidationCodeChange(event)}
                                  >
                                    {validationCodes?.length > 0 && (
                                      <option value="">
                                        Select Coupon Code
                                      </option>
                                    )}
                                    {validationCodes?.length > 0 &&
                                      selectedParkingType == 68 ? //Static Changes for Display Only One Day Free Coupon for Valet parking 15/04/2026 11:15 P.M.
                                      validationCodes?.filter((item) => item?.id == 2204)?.map((v, i) => {
                                        return (
                                          <option key={i} value={v?.promo_code?.[0]?.promocode}>
                                            {v?.name}
                                          </option>
                                        )
                                      }) :
                                      validationCodes?.map((v, i) => {
                                        return (
                                          <option key={i} value={v?.promo_code?.[0]?.promocode}>
                                            {v?.name}
                                          </option>
                                        )
                                      })}
                                  </select>
                                )}
                              />
                              {selectedValidationCode?.promo_code?.[0]?.restrictions && selectedValidationCode?.promo_code?.[0]?.restrictions != '' && (
                                <div className="small">
                                  <a className='ps-0 btn btn-sm align-items-center d-inline-flex gap-3 py-1 justify-content-between  fw-bold ' onClick={() => setCouponConditions(!couponConditions)} data-bs-toggle="collapse" href="#hiddenSection" role="button" aria-expanded="false" aria-controls="hiddenSection">Please Read Coupon Terms & Conditions <i className={couponConditions ? 'fa fa-square-minus' : 'fa fa-square-plus'}></i></a>
                                  <div className="collapse" id="hiddenSection">
                                    <div className="text-danger" dangerouslySetInnerHTML={{ __html: selectedValidationCode?.promo_code?.[0]?.restrictions }} />
                                  </div>

                                </div>
                              )}
                            </div>
                          </div> : null
                        :
                        <div className="px-3 py-2">
                          {!BookingEdit ? <div className="form-check mb-2">
                            <input className="form-check-input" checked={(BookingEdit && priceDetails?.promocode?.promocode?.promocode) || BookingEditData?.promocode} disabled={isPromocodeEnabled || promoCodeApply} type="checkbox" onClick={() => { setIsPromo(!isPromo) }} id="flexCheckDefault" />
                            <label className="form-check-label font-normal" >
                              Apply Promo Code
                            </label>
                          </div> : null}

                          {isPromo ?
                            <div>
                              {BookingEdit ? <div className="mb-2">
                                <label className="form-check-label font-normal" >
                                  Promo Code
                                </label>
                              </div> : null}
                              <div className="input-group input-group-sm ">
                                <Controller
                                  name="promo_code"
                                  type="text"
                                  id="promo_code"
                                  control={control}
                                  rules={{
                                    required: {
                                      value: false,
                                      message: 'This field is required',
                                    },
                                  }}
                                  render={({ field }) => (
                                    <input
                                      autoComplete="off"
                                      {...field}
                                      id="promo_code"
                                      disabled={promoAplicable ? (BookingEdit && BookingEditData?.discount > 0) ? true : false : true}

                                      //disabled={BookingEdit && (lengthPlusMinus == '0' && priceDetails?.refund_amount > 0 || BookingEditData?.discount>0)? true : false}
                                      title="Enter Promo Code"
                                      className="form-control"
                                      placeholder="Enter Promo Code"
                                      onChange={(e) => { field.onChange(e); handleCupanchange(e) }}
                                      onKeyPress={(e) => restrictSpecialCharPromo(e, ['promo_code'])}
                                    />
                                  )}
                                />
                                {(promoCodeApply && !BookingEditData?.promocode) ? (
                                  <button
                                    className="btn btn-danger text-white"
                                    type="button"
                                    onClick={removePromocode}
                                  >
                                    Remove
                                  </button>
                                ) : (
                                  (lengthPlusMinus != '0' && !BookingEditData?.promocode) ? <button
                                    className="btn btn-primary text-white"
                                    type="button"
                                    disabled={promoAplicable ? (BookingEdit && BookingEditData?.discount > 0) || applyPromoLoder ? true : false : true}
                                    onClick={promoAplicable ? (BookingEdit && BookingEditData?.discount > 0) ? '' : () => applyPromocode(priceDetails) : ''}
                                  >
                                    {applyPromoLoder ? <Circles
                                      height="20"
                                      width="20"
                                      style={{ display: 'inline-block' }}
                                      color="#ffffff"
                                      ariaLabel="circles-loading"
                                      visible={true}
                                    /> : 'Apply'}
                                  </button> : ''
                                )}
                              </div>
                            </div> : ''}



                        </div> :
                      ''}
                    {getValues()?.first_name && <div className="px-3 py-1 border-bottom border-dashed">
                      <div className="d-flex justify-content-between mb-1 ">
                        <p className="m-0 fw-semibold">Name</p>{' '}
                        <p style={{ wordBreak: 'break-all' }} className="m-0">
                          {`${getValues()?.first_name || ''} ${getValues()?.last_name || ''}`}

                        </p>
                      </div>
                      {getValues()?.email && <div className="d-flex justify-content-between mb-1 ">
                        <p className="m-0 fw-semibold">Email ID</p>{' '}
                        <p style={{ wordBreak: 'break-all' }} className="m-0">
                          {getValues()?.email || ''}
                        </p>
                      </div>}
                      {getValues()?.phone && <div className="d-flex justify-content-between mb-1 ">
                        <p className="m-0 fw-semibold">Phone No</p>{' '}
                        <p style={{ wordBreak: 'break-all' }} className="m-0">
                          {getValues()?.phone ? phoneMasker(getValues()?.phone) : '-'}
                        </p>
                      </div>}
                      {getValues()?.license_plate && <div className="d-flex justify-content-between mb-1 ">
                        <p className="m-0 fw-semibold">License Plate</p>{' '}
                        <p style={{ wordBreak: 'break-all' }} className="m-0">
                          {getValues()?.license_plate
                            ? getValues()?.license_plate
                            : '-'}
                        </p>
                      </div>}

                      {getValues()?.fligt_no && <div className="d-flex justify-content-between mb-1 ">
                        <p className="m-0 fw-semibold">Flight No</p>{' '}
                        <p style={{ wordBreak: 'break-all' }} className="m-0">
                          {getValues()?.fligt_no
                            ? getValues()?.fligt_no
                            : '-'}
                        </p>
                      </div>}
                    </div>}
                    {BookingEdit ?
                      <PriceBreackupEdit isVehicleOversize={isVehicleOversize} selectedFacilityData={facilityRef?.current} promoRes={promocodeRes} BookingEditData={BookingEditData} BookingEdit={BookingEdit} timeupdate={timeupdate} loaderPrice={loaderPrice} priceDetails={priceDetails} promoCodeApply={(Number(BookingEditData?.discount) > 0 && lengthPlusMinus != '0') ? true : promoCodeApply} discount={discount} lengthPlusMinus={lengthPlusMinus} selectedPaymentType={selectedPaymentType} totalHoursLengthRef={totalHoursLengthRef} applyPromoLoder={applyPromoLoder} selectedAmenities={selectedAmenities} />

                      // <PriceBreackupEdit BookingEditData={BookingEditData} BookingEdit={BookingEdit} timeupdate={timeupdate} loaderPrice={loaderPrice} priceDetails={priceDetails} promoCodeApply={BookingEditData?.discount > 0 ? true : promoCodeApply} discount={BookingEditData?.discount > 0 ? BookingEditData?.discount : discount} lengthPlusMinus={lengthPlusMinus} />

                      //  <PriceBreackupEdit BookingEditData={BookingEditData} BookingEdit={BookingEdit} timeupdate={timeupdate} loaderPrice={loaderPrice} priceDetails={priceDetails} promoCodeApply={BookingEditData?.discount > 0 ? true: false} discount={BookingEditData?.discount} lengthPlusMinus={lengthPlusMinus} />
                      : <PriceBreackup isVehicleOversize={isVehicleOversize} selectedFacilityData={facilityRef?.current} promoRes={promocodeRes} BookingEdit={BookingEdit} timeupdate={timeupdate} loaderPrice={loaderPrice} priceDetails={priceDetails} promoCodeApply={promoCodeApply} discount={discount} selectedPaymentType={selectedPaymentType} totalHoursLengthRef={totalHoursLengthRef} applyPromoLoder={applyPromoLoder} selectedAmenities={selectedAmenities} />
                    }
                    {isParksfo() ? getParkSfoEstimateDisclaimer() : null}
                  </div>
                </div>
              </div>
            )}

            {page == 5 && (
              bookingStatus ? (<div className="card shadow-lg  border-0  mt-5 p-2 p-sm-5">

                <div className="row justify-content-center mb-3">
                  <div className="col-sm-4">
                    <h1 className="text-center text-success mb-2">
                      <i className="fa-regular fa-circle-check fa-2x"></i>
                    </h1>
                    <h2 className="text-success mb-0 block  text-center  font-bold">{BookingEditData?.id ? 'Reservation is modified successfully!' : 'Thank You for Booking!'}</h2>
                    <p className="text-center">
                      {isLoggedIn()
                        ? 'Your e-receipt details has been sent to the registered Mobile number and Email Address '
                        : 'Your e-receipt details has been sent to your Mobile number and Email Address'}
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <div className="border  p-3 border-dark">
                      <div className="row  ">
                        <div className="col-sm-auto col-12 text-center">
                          <div className='QRCenter mb-2'>
                            <QRCodeSVG
                              value={(ticketDetails?.reservation?.thirdparty_code && ticketDetails?.reservation?.thirdparty_code != '') ? ticketDetails?.reservation?.thirdparty_code : ticketDetails?.reservation?.ticketech_code}
                              // value={ticketDetails?.reservation?.ticketech_code}
                              //value={`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revadminUrl : getConfigDetails()?.adminUrl}/admin/tickets?ticket_number=${ticketDetails?.reservation?.ticketech_code}`}
                              width="200px"
                              height="200px"
                            />

                          </div>
                          <span className="fw-bold h5"
                          >Reservation QR Code
                          </span>
                        </div>
                        <div className="col forMobile">
                          <p className="mb-1">
                            Reservation Number:{' '}
                            {ticketDetails?.reservation?.ticketech_code}
                          </p>
                          <p className="mb-1">
                            Start Date/Time:{' '}
                            {
                              ticketDetails?.reservation
                                ?.formatted_start_date_time
                            }
                          </p>
                          <p className="mb-1">
                            End Date/Time:{' '}
                            {
                              ticketDetails?.reservation
                                ?.formatted_end_date_time
                            }
                          </p>
                          {/* EOS-5093 Amenities booked with the reservation. Prefer what the
                              booking response returns, fall back to the user's selection. */}
                          {bookedAmenities?.length > 0 ? (
                            <p className="mb-1">
                              Amenities:{' '}
                              {bookedAmenities
                                ?.map((amenity) => amenity?.price && Number(amenity?.price) > 0
                                  ? `${amenity?.amenity_label} ($${formatDecimal(amenity?.price)})`
                                  : amenity?.amenity_label)
                                ?.join(', ')}
                            </p>
                          ) : null}
                          <p className="mb-0">
                            <b>
                              {
                                ticketDetails?.reservation?.facility
                                  ?.full_name
                              }
                              {ticketDetails?.reservation?.cruise_name
                                ? `(${ticketDetails?.reservation?.cruise_name})`
                                : ''}
                            </b>
                          </p>
                          <p className="mb-0">
                            {isPermissionExist(accessPermissions, 'Add Policy Url') ? <a href={`${usmLInk}`} target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small p-1 w-100 d-block border-bottom m-0"><i className='fa fa-link'></i> {usmLInkMsg ? usmLInkMsg : ''} </a> : ''}

                          </p>
                          {ticketDetails?.reservation?.facility?.geolocations
                            ?.city ? (
                            <p className="mb-0">
                              City:
                              {
                                ticketDetails?.reservation?.facility
                                  ?.geolocations?.city
                              }
                            </p>
                          ) : (
                            ''
                          )}

                          <a
                            target="_blank"
                            href={mapURL}
                            className="btn btn-link p-0"
                            rel="noreferrer"
                          >
                            Get Directions{' '}
                            <i className="fa-solid fa-diamond-turn-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="py-2 border-top">
                      <PassWalletButtons
                        ticketId={ticketDetails?.reservation?.ticketech_code}
                        googleWalletApi={APICONFIG.getGoogleReservationPassDownload}
                        appleWalletApi={APICONFIG.getappleReservationPassDownload}
                        notify={notify}
                        partnerDetails={partnerDetails}
                      />
                    </div>

                    <div className="d-flex mt-3">
                      <a
                        className="btn btn-primary me-2 w-100"
                        onClick={() =>
                          handleDownloadTicket(
                            ticketDetails?.reservation?.id,
                            ticketDetails?.reservation?.ticketech_code
                          )
                        }
                        disabled={loaderTicket}
                      >
                        <div className="d-flex justify-content-center align-items-center">
                          Download &nbsp;
                          <i className="fa fa-download"></i>
                          <span className="ms-2">
                            {loaderTicket ? (
                              <Circles
                                height="20"
                                width="20"
                                style={{ display: 'inline-block' }}
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                              />
                            ) : null}
                          </span>
                        </div>
                      </a>
                      {isParksfo() ? null : <button
                        className="btn btn-primary   w-100 text-white"
                        onClick={newBooking}
                      >
                        New Booking
                      </button>}

                    </div>
                  </div>
                  <div className="col-sm-10 mt-2 row justify-content-center mt-2">
                    {isParksfo() ? getParkSfoEstimateDisclaimer() : null}
                    {isParksfo() ? getParkSfoDisclaimerNote() : null}
                  </div>

                </div>
                {isPermissionExist(accessPermissions, 'Display Disclaimer Note') ? getDisclaimerNote(facilityName, partnerDetails) : null}
              </div>) : ''
            )}
          </form>
        </div>
        {isRateMisMatch ? <div style={{ display: 'block' }} className='modal overflow-hidden bg-dark bg-opacity-50    fade show'>

          <div className='modal-dialog modal-dialog-centered z-index-10 h-100'>
            <div className='modal-content'>
              <div className='modal-body'>
                <p>{mismatchRateError}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className='btn text-white bg-primary'
                  onClick={() => reFetchFacilityParkingData()}
                ><div className='d-flex justify-content-center align-items-center'>
                    <span>Refresh</span><span className='ms-2'>
                    </span>
                  </div></button>
              </div>
            </div>
          </div>
        </div> : null}
      </div> :
        <div className="container py-5 flud mt-5 d-flex">
          <div className="reservation-unavailable-card">

            <div className="left-icon">
              <div className='d-flex justify-content-center'>
                <img src={reservationcalendar}
                  alt="Reservations Unavailable" className="h-25" />
              </div>
            </div>

            <div className="vertical-divider"></div>
            <div className="vertical-divider"></div>

            <div className="content-area">

              <h2 className="reservation-title">
                Reservations Not Available!
              </h2>

              <div className="title-line"></div>

              <div className="info-row">
                <div className="info-text">
                  {facilityRef?.current?.facility_configuration?.reservation_notice_message && facilityRef?.current?.facility_configuration?.reservation_notice_message != '' ?
                    facilityRef?.current?.facility_configuration?.reservation_notice_message : errorMessage?.reservationsNotAvailable}
                </div>
              </div>

            </div>

          </div>
        </div>}
    </div>
  )
}

responsiveReservation.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  loaderSms: PropTypes.bool,
  loaderDownload: PropTypes.bool,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object,
  BookingEditData: PropTypes.object,
  BookingEdit: PropTypes.bool,
  prevButton: PropTypes.elementType.isRequired
}

responsiveReservation.defaulProps = {
  dispatch: noop,
  loader: false,
  notify: noop,
  partnerDetails: EMPTY_OBJECT,
  BookingEditData: EMPTY_OBJECT,
  BookingEdit: false,
  prevButton: DefaultComponent
}

function mapStateToProps({ userDetailsReducer, vehicleListReducer }) {
  return {
    loader: userDetailsReducer?.loader,
    loaderSms: userDetailsReducer?.loaderSms,
    loaderDownload: userDetailsReducer?.loaderDownload,
    countryData: vehicleListReducer?.data?.country,
  }
}
export default connect(mapStateToProps)(responsiveReservation)
